webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/Uq3O0j/%3F1696870362788&title=Commentaries%20on%20Job%2C%20Hosea%2C%20Joel%2C%20and%20Amos%2C%20Ancient%20Christian%20Texts&summary=%22Then%20the%20Lord%20answered%20Job%20out%20of%20the%20whirlwind%20.%20.%20.%20%22%20Julian%20of%20Eclanum%20%28c.%20386%13455%29%20was%20the%20bishop%20of%20Eclanum%2C%20located%20in%20modern-day%20Italy.%20In%20this%20volume%20in%20IVP%27s%20Ancient%20Christian%20Texts%20series%2C%20Thomas%20Scheck%20provides%20a%20new%20translation%20of%20Julian%27s%20co&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/Uq3O0j/%3F1696870362788",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=%22Then%20the%20Lord%20answered%20Job%20out%20of%20the%20whirlwind%20.%20.%20.%20%22%20Julian%20of%20Eclanum%20%28c.%20386%13455%29%20was%20the%20bishop%20of%20Eclanum%2C%20located%20in%20modern-day%20Italy.%20%0Dhttps://textcafe.co/books/Uq3O0j/%3F1696870362788&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/Uq3O0j/%3F1696870362788&posttype=link&caption=%22Then%20the%20Lord%20answered%20Job%20out%20of%20the%20whirlwind%20.%20.%20.%20%22%20Julian%20of%20Eclanum%20%28c.%20386%13455%29%20was%20the%20bishop%20of%20Eclanum%2C%20located%20in%20modern-day%20Italy.%20In%20this%20volume%20in%20IVP%27s%20Ancient%20Christian%20Texts%20series%2C%20Thomas%20Scheck%20provides%20a%20new%20translation%20of%20Julian%27s%20co",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/Uq3O0j/%3F1696870362788&description=%22Then%20the%20Lord%20answered%20Job%20out%20of%20the%20whirlwind%20.%20.%20.%20%22%20Julian%20of%20Eclanum%20%28c.%20386%13455%29%20was%20the%20bishop%20of%20Eclanum%2C%20located%20in%20modern-day%20Italy.%20In%20this%20volume%20in%20IVP%27s%20Ancient%20Christian%20Texts%20series%2C%20Thomas%20Scheck%20provides%20a%20new%20translation%20of%20Julian%27s%20co&media=https://textcafe.co/books/Uq3O0j/tc-custom/9780830825486.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: '',
        img: 'https://www.google.com/s2/favicons?domain=ivpress.com',
        url: 'https://www.ivpress.com/Search?q=9780830825486',
        alt: ''
      }, {
        title: '',
        img: 'https://www.google.com/s2/favicons?domain=christianbook.com',
        url: 'https://www.christianbook.com/Christian/Books/product?&event=AFF&p=1201454&isbn=9780830825486',
        alt: ''
      }, {
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/dp/0830825479?tag=mobilebookcom-20&ref=nosim',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=1jDwDwAAQBAJ&amp;rdid=book-1jDwDwAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }, {
        title: 'Kobo',
        img: 'https://textcafe.co/global-css/img/kobo_appicon.svg',
        url: 'https://www.kobo.com/us/en/search?Query=9780830825486',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9780830825486').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/Uq3O0j/tc-custom/9780830825486.jpg?1696870362788',
        alt: 'Commentaries on Job, Hosea, Joel, and Amos, Ancient Christian Texts'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "sommaire", "pre2", "pre3", "pre4", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "https://www.ivpress.com/",
      brandLogoUrl: "https://s3.amazonaws.com/textcafe.epubs/brand_logos/InterVarsity_Logo.png",
      currentUrl: "https://textcafe.co/books/Uq3O0j/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ident1__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ident1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ident1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ident12__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ident12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ident12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sommaire__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sommaire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_sommaire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pre2__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pre2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pre2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pre3__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pre3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pre3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pre4__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pre4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pre4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_p1chap1__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_p1chap1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_p1chap1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_p1chap2__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_p1chap2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_p1chap2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_p1chap3__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_p1chap3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_p1chap3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_appen5__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_appen5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_appen5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_appen6__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_appen6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_appen6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_appen7__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_appen7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_appen7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_appen8__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_appen8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_appen8__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_appen9__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_appen9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_appen9__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_appen10__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_appen10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_appen10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_fin_acheve__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_fin_acheve___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_fin_acheve__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ident11__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ident11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_ident11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_last__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_last__);
/*jshint esversion: 6 */

























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/sommaire",
    "name": "sommaire",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_sommaire___default.a
  }, {
    "path": "/pre2",
    "name": "pre2",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_pre2___default.a
  }, {
    "path": "/pre3",
    "name": "pre3",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_pre3___default.a
  }, {
    "path": "/pre4",
    "name": "pre4",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_pre4___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_22__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Uq3O0j/tc-custom/9780830825486.jpg?1696870362788",
      "alt": "This image is the cover for the book Commentaries on Job, Hosea, Joel, and Amos, Ancient Christian Texts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Commentaries on Job, Hosea, Joel, and Amos, Ancient Christian Texts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("\"Then the Lord answered Job out of the whirlwind . . . \"")])]), _vm._v(" "), _c('p', [_vm._v("Julian of Eclanum (c. 386–455) was the bishop of Eclanum, located in modern-day Italy. In this volume in IVP's Ancient Christian Texts series, Thomas Scheck provides a new translation of Julian's commentaries on the biblical books of Job and those of three Minor Prophets: Hosea, Joel, and Amos. Here, readers will gain insight into how early Christians read texts such as God's speech to Job, Hosea's symbolic representation of God's unending love for a faithless Israel, Joel's anticipation of the outpouring of the Holy Spirit, and Amos's call for social justice.")]), _vm._v(" "), _c('p', [_vm._v("While Julian was a well-known leader among the Pelagians, whose theology was famously opposed by Augustine of Hippo and ultimately determined to be outside the bounds of the church's orthodoxy, the Pelagian movement was a significant element within the early church. And although Julian's Pelagianism does not fundamentally affect the commentaries presented in this volume, Christians can gain insight into the truths of Scripture by reading the text alongside others, even when—or perhaps especially when—we might disagree with other aspects of their beliefs.")]), _vm._v(" "), _c('p', [_vm._v("Ancient Christian Texts are new English translations of full-length commentaries or sermon series from ancient Christian authors that allow you to study key writings of the early church fathers in a fresh way.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julian of Eclanum, Thomas P. Scheck\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLUME")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OB")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TRACTATES ON THE PROPHETS HOSEA, JOEL, AND AMOS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHET")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHET")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OEL")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHET")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MOS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLIOGRAPHY")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITLES")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTER")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSITY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")])])])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_IX",
      "title": "IX"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("GENERAL INTRODUCTION")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Ancient Christian Texts (hereafter ACT) presents the full text of ancient Christian commentaries on Scripture that have remained so unnoticed that they have not yet been translated into English.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The patristic period ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" 95–750) is the time of the fathers of the church, when the exegesis of Scripture texts was in its primitive formation. This period spans from Clement of Rome to John of Damascus, embracing seven centuries of biblical interpretation, from the end of the New Testament to the mid-eighth century, including the Venerable Bede.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This series extends but does not reduplicate texts of the Ancient Christian Commentary on Scripture (ACCS). It presents full-length translations of texts that appear only as brief extracts in the ACCS. The ACCS began years ago authorizing full-length translations of key patristic texts on Scripture in order to provide fresh sources of valuable commentary that previously were not available in English. It is from these translations that the ACT series has emerged.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A multiyear project such as this requires a well-defined objective. The task is straightforward: "), _c('i', [_vm._v("to introduce full-length translations of key texts of early Christian teaching, homilies and commentaries on a particular book of Scripture.")]), _vm._v(" These are seminal documents that have decisively shaped the entire subsequent history of biblical exegesis, but in our time have been largely ignored.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To carry out this mission each volume of the Ancient Christian Texts series has four aspirations:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_vm._v("1. To show the approach of one of the early Christian writers in dealing with the problems of understanding, reading and conveying the meaning of a particular book of Scripture.")]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_vm._v("2. To make more fully available the whole argument of the ancient Christian interpreter of Scripture to all who wish to think with the early church about a particular canonical text.")]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_vm._v("3. To broaden the base of the biblical studies, Christian teaching and preaching to include classical Christian exegesis.")]), _c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("4. To stimulate Christian historical, biblical, theological and pastoral scholarship toward deeper inquiry into early classic practitioners of scriptural interpretation.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_X",
      "title": "X"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("For Whom Is This Series Designed? ")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We have selected and translated these texts primarily for general and nonprofessional use by an audience of persons who study the Bible regularly.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In varied cultural settings around the world, contemporary readers are asking how they might grasp the meaning of sacred texts under the instruction of the great minds of the ancient church. They often study books of the Bible verse by verse, book by book, in groups and workshops, sometimes with a modern commentary in hand. But many who study the Bible intensively hunger to have available as well the thoughts of a reliable classic Christian commentator on this same text. This series will give the modern commentators a classical text for comparison and amplification. Readers will judge for themselves as to how valuable or complementary are their insights and guidance.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The classic texts we are translating were originally written for anyone (lay or clergy, believers or seekers) who wished to reflect and meditate with the great minds of the early church. They sought to illuminate the plain sense, theological wisdom, and moral and spiritual meaning of an individual book of Scripture. They were not written for an academic audience, but for a community of faith shaped by the sacred text.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Yet in serving this general audience, the editors remain determined not to neglect the rigorous requirements and needs of academic readers who until recently have had few full translations available to them in the history of exegesis. So this series is designed also to serve public libraries, universities, academic classes, homiletic preparation and historical interests worldwide in Christian scholarship and interpretation.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Hence our expected audience is not limited to the highly technical and specialized scholarly field of patristic studies, with its strong bent toward detailed word studies and explorations of cultural contexts. Though all of our editors and translators are patristic and linguistic scholars, they also are scholars who search for the meanings and implications of the texts. The audience is not primarily the university scholar concentrating on the study of the history of the transmission of the text or those with highly focused interests in textual morphology or historical-critical issues. If we succeed in serving our wider readers practically and well, we hope to serve as well college and seminary courses in Bible, church history, historical theology, hermeneutics and homiletics. These texts have not until now been available to these classes.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Readiness for Classic Spiritual Formation")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Today global Christians are being steadily drawn toward these biblical and patristic sources for daily meditation and spiritual formation. They are on the outlook for primary classic sources of spiritual formation and biblical interpretation, presented in accessible form and grounded in reliable scholarship.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These crucial texts have had an extended epoch of sustained influence on Scripture interpretation, but virtually no influence in the modern period. They also deserve a hearing "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XI",
      "title": "XI"
    }
  }, [_vm._v("among modern readers and scholars. There is a growing awareness of the speculative excesses and spiritual and homiletic limitations of much post-Enlightenment criticism. Meanwhile the motifs, methods and approaches of ancient exegetes have remained unfamiliar not only to historians but to otherwise highly literate biblical scholars, trained exhaustively in the methods of historical and scientific criticism.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is ironic that our times, which claim to be so fully furnished with historical insight and research methods, have neglected these texts more than scholars in previous centuries who could read them in their original languages.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This series provides indisputable evidence of the modern neglect of classic Christian exegesis: it remains a fact that extensive and once authoritative classic commentaries on Scripture still remain untranslated into any modern language. Even in China such a high level of neglect has not befallen classic Buddhist, Taoist and Confucian commentaries.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Ecumenical Scholarship ")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This series, like its two companion series, the ACCS and Ancient Christian Doctrine (ACD), is an expression of unceasing ecumenical efforts that have enjoyed the wide cooperation of distinguished scholars of many differing academic communities. Under this classic textual umbrella, it has brought together in common spirit Christians who have long distanced themselves from each other by competing church memories. But all of these traditions have an equal right to appeal to the early history of Christian exegesis. All of these traditions can, without a sacrifice of principle or intellect, come together to study texts common to them all. This is its ecumenical significance.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v(" This series of translations is respectful of a distinctively theological reading of Scripture that cannot be reduced to historical, philosophical, scientific or sociological insights or methods alone. It takes seriously the venerable tradition of ecumenical reflection concerning the premises of revelation, providence, apostolicity, canon and consensuality. A high respect is here granted, despite modern assumptions, to uniquely Christian theological forms of reasoning, such as classical consensual christological and triune reasoning, as distinguishing premises of classic Christian textual interpretation. These cannot be acquired by empirical methods alone. This approach does not pit theology against critical theory; instead, it incorporates critical historical methods and brings them into coordinate accountability within its larger purpose of listening to Scripture.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The internationally diverse character of our editors and translators corresponds with the global range of our audience, which bridges many major communions of Christianity. We have sought to bring together a distinguished international network of Protestant, Catholic and Orthodox scholars, editors and translators of the highest quality and reputation to accomplish this design.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But why just now at this historical moment is this need for patristic wisdom felt particularly by so many readers of Scripture? Part of the reason is that these readers have "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XII",
      "title": "XII"
    }
  }, [_vm._v("been longer deprived of significant contact with many of these vital sources of classic Christian exegesis.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("The Ancient Commentary Tradition")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This series focuses on texts that comment on Scripture and teach its meaning. We define a commentary in its plain-sense definition as a series of illustrative or explanatory notes on any work of enduring significance. The word "), _c('i', [_vm._v("commentary")]), _vm._v(" is an Anglicized form of the Latin "), _c('i', [_vm._v("commentarius")]), _vm._v(" (or “annotation” or “memoranda” on a subject, text or series of events). In its theological meaning it is a work that explains, analyzes or expounds a biblical book or portion of Scripture. Tertullian, Origen, John Chrysostom, Jerome, Augustine and Clement of Alexandria all revealed their familiarity with both the secular and religious commentators available to them as they unpacked the meanings of the sacred text at hand.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The commentary in ancient times typically began with a general introduction covering such questions as authorship, date, purpose and audience. It commented as needed on grammatical or lexical problems in the text and provided explanations of difficulties in the text. It typically moved verse by verse through a Scripture text, seeking to make its meaning clear and its import understood.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The general Western literary genre of commentary has been definitively shaped by the history of early Christian commentaries on Scripture. It is from Origen, Hilary, the "), _c('i', [_vm._v("Opus imperfectum in Matthaeum")]), _vm._v(", John Chrysostom and Cyril of Alexandria that we learn what a commentary is—far more so than in the case of classic medical, philosophical or poetic commentaries. It leaves too much unsaid simply to assume that the Christian biblical commentary took a previously extant literary genre and reshaped it for Christian texts. Rather it is more accurate to say that "), _c('i', [_vm._v("the Western literary genre of the commentary (and especially the biblical commentary) has patristic commentaries as its decisive pattern and prototype. ")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is only in the last two centuries, since the development of modern historicist methods of criticism, that modern writers have sought more strictly to delimit the definition of a commentary so as to include only certain limited interests focusing largely on historical-critical method, philological and grammatical observations, literary analysis, and socio-political or economic circumstances impinging on the text. While respecting all these approaches, the ACT editors do not hesitate to use the classic word "), _c('i', [_vm._v("commentary")]), _vm._v(" to define more broadly the genre of this series. These are commentaries in their classic sense.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The ACT editors freely take the assumption that the Christian canon is to be respected as the church’s sacred text. The reading and preaching of Scripture are vital to religious life. The central hope of this endeavor is that it might contribute in some small way to the revitalization of religious faith and community through a renewed discovery of the earliest readings of the church’s Scriptures.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-005"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XIII",
      "title": "XIII"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("An Appeal to Allow the Text to Speak for Itself ")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This prompts two appeals:")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("1. For those who begin by assuming as normative for a commentary only the norms considered typical for modern expressions of what a commentary is, we ask: please allow the ancient commentators to define "), _c('i', [_vm._v("commentarius")]), _vm._v(" according to their own lights. Those who assume the preemptive authority and truthfulness of modern critical methods alone will always tend to view the classic Christian exegetes as dated, quaint, premodern, hence inadequate, and in some instances comic or even mean-spirited, prejudiced, unjust and oppressive. So in the interest of hermeneutical fairness, it is recommended that the modern reader not impose upon ancient Christian exegetes modern assumptions about valid readings of Scripture. The ancient Christian writers constantly challenge these unspoken, hidden and indeed often camouflaged assumptions that have become commonplace in our time.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We leave it to others to discuss the merits of ancient versus modern methods of exegesis. But even this cannot be done honestly without a serious examination of the texts of ancient exegesis. Ancient commentaries may be disqualified as commentaries by modern standards. But they remain commentaries by the standards of those who anteceded and formed the basis of the modern commentary.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The attempt to read a Scripture text while ruling out all theological and moral assumptions—as well as ecclesial, sacramental and dogmatic assumptions that have prevailed generally in the community of faith out of which it emerged—is a very thin enterprise indeed. Those who tendentiously may read a single page of patristic exegesis, gasp and toss it away because it does not conform adequately to the canons of modern exegesis and historicist commentary are surely not exhibiting a valid model for critical inquiry today.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("2. In ancient Christian exegesis, chains of biblical references were often very important in thinking about the text in relation to the whole testimony of sacred Scripture, by the analogy of faith, comparing text with text, on the premise that "), _c('i', [_vm._v("scripturam ex scriptura explicandam esse")]), _vm._v(". When ancient exegesis weaves many Scripture texts together, it does not limit its focus to a single text as much modern exegesis prefers, but constantly relates them to other texts, by analogy, intensively using typological reasoning, as did the rabbinic tradition.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Since the principle prevails in ancient Christian exegesis that each text is illumined by other texts and by the whole narrative of the history of revelation, we find in patristic comments on a given text many other subtexts interwoven in order to illumine that text. In these ways the models of exegesis often do not correspond with modern commentary assumptions, which tend to resist or rule out chains of scriptural reference. We implore the reader not to force the assumptions of twentieth-century hermeneutics upon the ancient Christian writers, who themselves knew nothing of what we now call hermeneutics.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-006"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XIV",
      "title": "XIV"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("The Complementarity of Research Methods in This Series ")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Ancient Christian Texts series will employ several interrelated methods of research, which the editors and translators seek to bring together in a working integration. Principal among these methods are the following:")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("1. The editors, translators and annotators will bring to bear the best resources of "), _c('i', [_vm._v("textual criticism")]), _vm._v(" in preparation for their volumes. This series is not intended to produce a new critical edition of the original-language text. The best urtext in the original language will be used. Significant variants in the earliest manuscript sources of the text may be commented upon as needed in the annotations. But it will be assumed that the editors and translators will be familiar with the textual ambiguities of a particular text and be able to state their conclusions about significant differences among scholars. Since we are working with ancient texts that have, in some cases, problematic or ambiguous passages, we are obliged to employ all methods of historical, philological and textual inquiry appropriate to the study of ancient texts. To that end, we will appeal to the most reliable text-critical scholarship of both biblical and patristic studies. We will assume that our editors and translators have reviewed the international literature of textual critics regarding their text so as to provide the reader with a translation of the most authoritative and reliable form of the ancient text. We will leave it to the volume editors and translators, under the supervision of the general editors, to make these assessments. This will include the challenge of considering which variants within the biblical text itself might impinge upon the patristic text, and which forms or stemma of the biblical text the patristic writer was employing. The annotator will supply explanatory footnotes where these textual challenges may raise potential confusions for the reader.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("2. Our editors and translators will seek to understand the "), _c('i', [_vm._v("historical context")]), _vm._v(" (including socioeconomic, political and psychological aspects as needed) of the text. These understandings are often vital to right discernment of the writer’s intention. Yet we do not see our primary mission as that of discussing in detail these contexts. They are to be factored into the translation and commented on as needed in the annotations, but are not to become the primary focus of this series. Our central interest is less in the social location of the text or the philological history of particular words than in authorial intent and accurate translation. Assuming a proper social-historical contextualization of the text, the main focus of this series will be upon a dispassionate and fair translation and analysis of the text itself.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("3. The main task is to set forth the meaning of the biblical text itself as understood by the patristic writer. The intention of our volume editors and translators is to help the reader see clearly into the meanings that patristic commentators have discovered in the biblical text. "), _c('i', [_vm._v("Exegesis")]), _vm._v(" in its classic sense implies an effort to explain, interpret and comment on a text, its meaning, its sources and its connections with other texts. It implies "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XV",
      "title": "XV"
    }
  }, [_vm._v("a close reading of the text, using whatever linguistic, historical, literary or theological resources are available to explain the text. It is contrasted with "), _c('i', [_vm._v("eisegesis,")]), _vm._v(" which implies that interpreters have imposed their own personal opinions or assumptions on the text. The patristic writers actively practiced intratextual exegesis, which seeks to define and identify the exact wording of the text, its grammatical structure and the interconnectedness of its parts. They also practiced extratextual exegesis, seeking to discern the geographical, historical or cultural context in which the text was written. Our editors and annotators will also be attentive as needed to the ways in which the ancient Christian writer described his own interpreting process or hermeneutic assumptions.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("4. The underlying philosophy of translation that we employ in this series is, like the Ancient Christian Commentary on Scripture, termed "), _c('i', [_vm._v("dynamic equivalency")]), _vm._v(". We wish to avoid the pitfalls of either too loose a paraphrase or too rigid a literal translation. We seek language that is literary but not purely literal. Whenever possible we have opted for the metaphors and terms that are normally in use in everyday English-speaking culture. Our purpose is to allow the ancient Christian writers to speak for themselves to ordinary readers in the present generation. We want to make it easier for the Bible reader to gain ready access to the deepest reflection of the ancient Christian community of faith on a particular book of Scripture. We seek a thought-for-thought translation rather than a formal equivalence or word-for-word style. This requires the words to be first translated accurately and then rendered in understandable idiom. We seek to present the same thoughts, feelings, connotations and effects of the original text in everyday English language. We have used vocabulary and language structures commonly used by the average person. We do not leave the quality of translation only to the primary translator, but pass it through several levels of editorial review before confirming it.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("The Function of the ACT Introductions, Annotations and Translations")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In writing the introduction for a particular volume of the ACT series, the translator or volume editor will discuss, where possible, the opinion of the writer regarding authorship of the text, the importance of the biblical book for other patristic interpreters, the availability or paucity of patristic comment, any salient points of debate between the Fathers, and any special challenges involved in translating and editing the particular volume. The introduction affords the opportunity to frame the entire commentary in a manner that will help the general reader understand the nature and significance of patristic comment on the biblical text under consideration and to help readers find their critical bearings so as to read and use the commentary in an informed way.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The footnotes will assist the reader with obscurities and potential confusions. In the annotations the volume editors have identified Scripture allusions and historical references embedded within the texts. Their purpose is to help the reader move easily from passage to passage without losing a sense of the whole.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XVI",
      "title": "XVI"
    }
  }, [_vm._v("The ACT general editors seek to be circumspect and meticulous in commissioning volume editors and translators. We strive for a high level of consistency and literary quality throughout the course of this series. We have sought out as volume editors and translators those patristic and biblical scholars who are thoroughly familiar with their original language sources, who are informed historically, and who are sympathetic to the needs of ordinary nonprofessional readers who may not have professional language skills.")])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Thomas C. Oden, Gerald L. Bray, and Michael Glerup, Series Editors")])])])])])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XVII",
      "title": "XVII"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("VOLUME EDITOR’S INTRODUCTION")])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A Brief History of the Pelagian Controversy")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This volume contains the first English translation of four commentaries on Scripture by Julian (380–ca. 445), the “Pelagian” bishop of Eclanum, Italy. I use quotation marks here because the term "), _c('i', [_vm._v("Pelagian")]), _vm._v(" is problematic. Julian never used this word to describe himself. His adversaries, especially Augustine, Jerome, the Roman bishops, and the imperial power, labeled him so. Yet modern scholarship does not necessarily concur that the doctrines defined as Pelagian were actually held by the persons accused. The author of a recent monograph argues that Pelagianism was in fact the heresiological construction of a heresy and that what the members of this movement preached was something different."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-001",
      "id": "ap_ntb-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" At the very least, most modern scholars concede that it is impossible to speak of Pelagianism as a monolithic movement as if there were no differences among its exponents. It was Augustine and Jerome who tried to present the movement as unified.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To understand Julian and situate him in his historical context, it is first necessary to become acquainted with the heresy with which he is associated. Pelagianism is named after the British monk Pelagius (ca. 360–ca. 420), a zealous and learned Christian leader and Pauline exegete in the ancient church who conflicted theologically with St. Augustine (354–430) and St. Jerome (ca. 347–ca. 419) in the second decade of the fifth century."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-002",
      "id": "ap_ntb-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" After being acquitted by two Eastern synods and exonerated by at least one Roman pope, Pelagius was eventually branded as a heretic in the West. In his Christology and trinitarian doctrine, Pelagius was orthodox."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-003",
      "id": "ap_ntb-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Traditionally the principal error of the Pelagian heresy is its doctrine of sin. Pelagius and another contemporary figure named Caelestius claimed that the sin of Adam affected only himself; it did not implicate or cause the downfall of the entire human race. According to Caelestius, Pelagius, and Julian, while Adam’s transgression set a bad example for his posterity, his sin and guilt could not have been transmitted to his descendants, especially newborn infants, to make them guilty and culpable for what he had done and therefore worthy of eternal damnation. In "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XVIII",
      "title": "XVIII"
    }
  }, [_vm._v("his interpretation of Romans 5:12, for example, Pelagius bypasses the idea that Adam transmitted to the human race an inheritance of guilt, physical death, ignorance, and concupiscence. It is interesting to note, however, that in this passage, Pelagius simply lists the arguments of those who are against the transmission of original sin. He does not explicitly say that he supports their teaching, though this is the impression one has. The tone of Pelagius’s writings strikes me as churchman-like. In any case, Catholics and Protestants, following the main lines of Augustine’s teaching (though not necessarily all his inferences and particular interpretations of biblical texts), have generally agreed that all human beings enter this world subject to fallen conditions, mysteriously implicated in Adam’s sin, and in need of grace and redemption. This predicament is the result of our entailment in Adam’s sin and condemnation and is not merely the result of our own actual sins carried out in imitation of Adam. J. N. D. Kelly formulates Pelagius’s teaching as follows:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("He rejected as Manichaean, as well as stultifying to endeavor, the notion that human nature has been corrupted by original sin transmitted from Adam, and can raise itself only by God’s help. Although a habit of sinning has set in, a man is always free to shake it off, and by the exercise of his will to choose either right or wrong. Indeed, so far as from there being any necessity of sinning, a man is in principle able to live without sin. Regarding sin as a voluntary act, he denied that new-born babies, who have no choice, can be guilty of it, yet he upheld the traditional practice of having them baptized. Assuredly men always need God’s grace; but Pelagius defined grace, not as an inner power transforming them, but as their original endowment with rational will, the divine forgiveness they obtain through baptism, and the illumination provided by the law of Moses and the teaching and example of Christ."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-004",
      "id": "ap_ntb-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Beatrice explains that for Caelestius (and Pelagius), “babies are born without original sin, that is, they are in the same condition as Adam was in the Garden of Eden before he sinned. This is because sin is not something that can be transmitted or passed on.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-005",
      "id": "ap_ntb-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Julian of Eclanum concurred with this Pelagian doctrine, and this particular Pelagian teaching (that is, the reduction of Adam’s fault to that of a bad influence) has been repudiated in the magisterial teaching of the church."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-006",
      "id": "ap_ntb-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The difficulty in discerning the extent to which Pelagius and Julian’s writings were infused with the other errors of which they were accused by their orthodox opponents is illustrated by the striking fact that many of their written works were transmitted in the West anonymously or under false attributions to saints. And so long as their ascription to Pelagius (or Julian) was unknown, the writings were treasured. For instance, Ali Bonner "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XIX",
      "title": "XIX"
    }
  }, [_vm._v("has studied the manuscript tradition of Pelagius’s "), _c('i', [_vm._v("Letter to Demetrias")]), _vm._v(" and pointed out how influential it was throughout the medieval period. When authorship of these writings by Pelagius (or Julian) was discovered in modern times, suddenly these same works began to be accused. Lamberigts comments with respect to Pelagius:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("It would appear, however, that the tradition was not always so ill at ease with Pelagian perspectives as was the case with Augustine of Hippo, certainly if one takes into account the fact that several so-called Pelagian documents have survived to the present day because the said tradition had ascribed them to other, “orthodox,” Christian authors. Perhaps the most striking example thereof is Pelagius’ "), _c('i', [_vm._v("Epistula ad Demetriadem")]), _vm._v(", authorship of which was ascribed for a significant period of time either to Jerome or to Augustine himself on account of the quality of the ascetic content of the work. When scholars came to be convinced that the work could be ascribed with certainty to Pelagius, it suddenly acquired the epithets “un-evangelical” and “non-Pauline,” a somewhat surprising change of perspective given the fact that Pelagius’s writings tended to afford a significant amount of space to commentary on the letters of Paul."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-007",
      "id": "ap_ntb-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It appears that scholars in the Greek Orthodox tradition likewise take a more moderate stance to interpreting the polemics between Augustine and Pelagius and Augustine and Julian. John McGuckin, for instance, argues that")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Eastern Christianity to this day senses that Augustine’s clash with Pelagius was unnecessarily limiting, and that while all the initiative for grace and redemption, at every level and stage, lies with God, the same God expects each believer to do his or her part in responding to the divine assistance. For the East, grace was not simply an assistance of God in the soul, but more so the transfigurative indwelling of God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-008",
      "id": "ap_ntb-008-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("McGuckin adds further that in the later theological tradition the heresy of “Pelagianism” has generally been drawn up in reference to Augustine’s theology of grace and “what Augustine said were Pelagian implications, not to what Pelagius was actually saying. Pelagius believed that God gave grace to human beings, certainly, but his primary grace was the freedom to choose and respond.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-009",
      "id": "ap_ntb-009-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" When interpreting the works of Pelagius and Julian I have taken an irenic and ecumenical approach that takes into account the positions of the Eastern fathers of the church, and thus the received tradition of Eastern Orthodoxy, rather than limiting myself to an Augustinian interpretation that is progressively narrowed by medieval Scholasticism and Magisterial Reformation Protestantism.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-009"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XX",
      "title": "XX"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("The Life and Career of Julian of Eclanum (ca. 380–ca. 445)")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We now turn to Julian of Eclanum’s involvement in the Pelagian controversy."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-010",
      "id": "ap_ntb-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Julian is first encountered in ancient Christian literature as the son of an Italian bishop named Memor, or Memorius, and the recipient of an epithalium, or wedding poem, composed by his father’s friend St. Paulinus of Nola (ca. 355–431) between 401 and 404."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-011",
      "id": "ap_ntb-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Julian had been a lector in the church over which his father presided. In addition to Paulinus of Nola, Augustine of Hippo was familiar with his family and wrote of them respectfully and affectionately prior to the outbreak of the Pelagian controversy. After the sack of Rome in 410, Pelagius and Caelestius fled to Africa."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-012",
      "id": "ap_ntb-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" At the time, Pelagius was regarded in the West as an outstanding spiritual director. He, along with Augustine and Jerome, was solicited to offer spiritual counsel to the noble woman Demetrias, who had taken a vow of virginity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-013",
      "id": "ap_ntb-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Pelagius went to Carthage and thence to Palestine. Caelestius stayed in Carthage, where he was accused of heresy by Paulinus, the former deacon of Ambrose in Milan. He was found guilty of six charges by Aurelius, bishop of Carthage, in 412."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-014",
      "id": "ap_ntb-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" In June 415, Pelagius was acquitted of heresy charges in a synod in Jerusalem presided over by John of Jerusalem."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-015",
      "id": "ap_ntb-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" In December of the same year, Pelagius was again acquitted of heresy charges by fourteen Eastern bishops at the Synod of Diospolis "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXI",
      "title": "XXI"
    }
  }, [_vm._v("(Lydda) in Palestine."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-016",
      "id": "ap_ntb-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" This synod was possibly attended by St. Chromatius of Aquileia and Jovinus."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-017",
      "id": "ap_ntb-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" The eleventh accusation was based on words taken from Caelestius’s book, where it was objected against Pelagius that he had said that “everyone can have all virtues and graces and that they destroy the diversity of graces which the apostle [Paul] teaches.” Pelagius replied that this was a “malignant and blundering charge.” “We do not . . . destroy the diversity of graces; rather we say that God gives all the graces to one who is worthy to receive them, as He gave them to the apostle Paul.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-018",
      "id": "ap_ntb-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" To this response the synod replied, “Your views on the gift of the graces found in the holy apostle are reasonable and in accord with the mind of the Church.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-019",
      "id": "ap_ntb-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" The modern Greek Orthodox scholar, John A. McGuckin, assesses this vindication as follows:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("And when Pelagius came to Jerusalem and was forced to answer ecclesiastical charges that the way he taught underestimated God’s grace and placed too high a premium on human effort (saving ourselves by good works) the learned bishop John exonerated him there, finding nothing wrong with his ascetical teachings at all."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-020",
      "id": "ap_ntb-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Pelagius’s troubles, however, did not end with these acquittals. Through Augustine’s initiative, the cases of Pelagius and Caelestius were reopened and they were condemned in provincial synods in Africa. The Africans reported their actions to Pope Innocent of Rome, who in late January 417 excommunicated Caelestius, Pelagius, and their followers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-021",
      "id": "ap_ntb-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Pope Innocent died in March 417 and was succeeded by Pope Zosimus. Caelestius appeared in Rome and requested a hearing. Letters and a profession of faith, which Pelagius addressed to Innocent, also arrived. Zosimus looked into the matter and acquitted Pelagius and Caelestius in September 417. Burns writes, “Pelagius’ profession of faith astonished the Roman clergy and attendant bishops who could not understand how such a man could be accused of heresy.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-022",
      "id": "ap_ntb-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Lamberigts writes in summary of Pope Zosimus’s rehabilitation of Caelestius,")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXII",
      "title": "XXII"
    }
  }, [_vm._v("A sharper critique of the anti-Pelagian movement is inconceivable. Therefore one may believe that Caelestius did not try to mislead Zosimus in order to be set free [as Augustine misleadingly claimed] but that he was set free while stating that the doctrine of original sin as understood by Augustine, was against the catholic doctrine."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-023",
      "id": "ap_ntb-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Beatrice states the matter this way: “Zosimus completely rehabilitated Caelestius and Pelagius, declaring them in full communion with orthodoxy. Moreover . . . he accepted essentially without reservation their rejection of the Augustinian notion of "), _c('i', [_vm._v("peccatum ex traduce")]), _vm._v(" [sin by transmission].”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-024",
      "id": "ap_ntb-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" The African bishops did not obey the instructions found in the papal letters that arrived in Carthage on November 2, 417. Instead they dispatched countering letters to Rome to which Zosimus responded on March 23, 417. The Roman pope persisted in his conviction that the case had not been proven. He refused to comply with the request to take further action against Caelestius. A dramatic contest between Rome and Carthage had arisen. The next event occurred on April 30, 418 when an imperial rescript was published. It condemned Caelestius and Pelagius as heretics and denounced them for disturbing the peace of the church and of the city of Rome. The cooperation between imperial authority and the African episcopacy isolated Zosimus, who then submitted to this outside pressure and issued his "), _c('i', [_vm._v("Epistula tractoria")]), _vm._v(" to all the bishops of the East and West for subscription. The theological content of the surviving fragments of the "), _c('i', [_vm._v("Tractoria")]), _vm._v(" is analyzed linguistically by Beatrice."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-025",
      "id": "ap_ntb-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" He claims that it does not amount to being a full recognition by Rome of the Augustinian theology of original sin, but an attempt at compromise, “more in word than in substance, between the theological tradition of Rome, which was influenced in a markedly profound way by orthodox Greek theology.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-026",
      "id": "ap_ntb-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Julian was among the eighteen Italian bishops who refused to subscribe to the "), _c('i', [_vm._v("Tractoria")]), _vm._v(". These bishops were deposed and afterward exiled under the edicts issued by Emperor Honorius in 418. Eugene TeSelle wonders whether the papal action may have been a “premature decision”:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Eighteen bishops in Italy and Illyria, led by Julian of Eclanum, asked that the issues be examined in a general council. They had a credible argument. The controversy had been decided after only a few years of formal debate (415–18); the condemnation had come from the imperial court and only then, under duress, from the pope; and many regions were unacquainted with the doctrine of original sin and had scarcely heard of Augustine’s approach to grace and free will."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-027",
      "id": "ap_ntb-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXIII",
      "title": "XXIII"
    }
  }, [_vm._v("Julian now addressed two letters to Zosimus in the fall of 418, using very harsh language. About the same time, Julian addressed a letter to Rufus, bishop of Thessalonica (410–431), on his own behalf and that of eighteen fellow recusants. For Julian it was very clear that the Roman clergy had changed sides because of fear of the imperial edict. They contradicted their earlier attitude and were now declaring human nature to be evil. Pope Zosimus died on December, 26, 418, and was succeeded by Boniface I on April 10, 419. Augustine responded to Julian’s letter to Rufus and to another epistle of Julian to the clergy of Rome in his "), _c('i', [_vm._v("Contra Duas Epistulas Pelagianorum")]), _vm._v(". According to Augustine’s account, Julian had tried to persuade the Eastern bishops that Augustine’s doctrine was Manichean, and Julian had denounced Pope Zosimus for vacillation. Moreover, Julian had accused the Roman clergy of unjustly condemning the Pelagians and had argued that the Roman church had embraced heresy and that the Western bishops had been victims of imperial extortion.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After composing two letters to Pope Zosimus, Julian replied to the first book of Augustine’s "), _c('i', [_vm._v("De nuptiis et concupiscentia")]), _vm._v(". His work was dedicated to a fellow recusant named Turbantius. Julian again accused the church of having embraced Manicheism. Julian sent portions of this four-book work to Valerius, friend of Augustine. The title of Julian’s book accused Augustine of condemning marriage and assigning its fruits to the devil. Augustine answered the accusations in the second book of"), _c('i', [_vm._v(" De nuptiis et concupiscentia")]), _vm._v(". When Augustine received Julian’s complete work, he published a more detailed answer in his "), _c('i', [_vm._v("Contra Julianum Pelagianum")]), _vm._v(". In this work Augustine quoted his opponent at length.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Julian and other deposed Italian bishops took refuge with Theodore of Mopsuestia in Cilicia. Julian occupied himself with a translation of Theodore’s "), _c('i', [_vm._v("Commentary on the Psalms")]), _vm._v(" from Greek into Latin, thus demonstrating his competency in the Greek language."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-028",
      "id": "ap_ntb-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Julian answered Augustine’s reply to him in a lengthy work dedicated to Florus, a fellow recusant. Augustine cites extensively from Julian’s attack in his "), _c('i', [_vm._v("Opus Imperfectum")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-029",
      "id": "ap_ntb-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Julian returned to Italy when Pope Celestine I succeeded Boniface I in September 422. He may have hoped for rehabilitation, but the endeavor was not successful and he was exiled a second time. Julian apparently died in Sicily between 443 and 445."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-030",
      "id": "ap_ntb-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Julian’s Surviving Exegetical Writings")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('i', [_vm._v("Commentary on the Song of Songs.")])]), _vm._v(" Until the beginning of the twentieth century, only fragments and excerpts from Julian’s writings had been preserved under his name in the West, most of these in the form of quotations and allusions recorded in Augustine’s works against him. Fragments of a "), _c('i', [_vm._v("Commentary on the Song of Songs")]), _vm._v(" by Julian are attested by "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXIV",
      "title": "XXIV"
    }
  }, [_vm._v("Bede the Venerable. This is probably the work Julian refers to in the preface to Hosea as a commentary on the books of Solomon. Holder writes of it,")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("[Bede’s] commentary begins with a polemical preface in which Bede refutes the teachings of Julian of Eclanum, a fifth-century Italian bishop who had opposed Augustine by defending Pelagian notions affirming free will and denying original sin. Perhaps inspired by his time in exile under the tutelage of the Antiochene exegete Theodore of Mopsuestia, Julian had written a treatise "), _c('i', [_vm._v("De amore")]), _vm._v(" in which he advanced a literalistic interpretation of the Song of Songs as a celebration of human sexuality. . . . Bede calls Julian a “snake in the grass” because he presented heretical doctrine under the guise of seductive eloquence. Further on, however, Bede quotes Julian’s completely innocuous interpretation of the hair of the bridegroom in Song 5,11, with apparent approbation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-031",
      "id": "ap_ntb-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is noteworthy that despite his view that the main theme of the Song of Songs is a literal defense of the goodness of human sexuality after the fall of Adam and Eve, Julian also uses allegorical exegesis in this commentary, including Marian interpretations."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-032",
      "id": "ap_ntb-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Bede rejected Julian’s Mariological interpretation of Song 8:1-2, which identified the Blessed Virgin as the mother referred to. In these texts, Julian had argued that there was nothing sinful about human birth, since the Lord was completely encircled in flesh yet was free from sin."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-033",
      "id": "ap_ntb-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" It seems most unfortunate that Julian’s commentary does not survive.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Exposition of the book of Job.")])]), _vm._v(" A date in the early to mid-420s for Julian’s "), _c('i', [_vm._v("Exposition of the Book of Job")]), _vm._v(" is reasonable. The unique manuscript attributes the "), _c('i', [_vm._v("Expositio")]), _vm._v(" to Philip the Presbyter (a disciple of St. Jerome). Unfortunately, it is damaged at the end and terminates with commentary on Job 42:7. Thus, it does not contain an interpretation of the Lord’s restoration of Job’s fortunes (Job 42:10-17). The manuscript was first printed by Abbot Amelli, archivist of Monte Cassino."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-034",
      "id": "ap_ntb-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Schanz confused this commentary on Job with the "), _c('i', [_vm._v("Expositio interlinearis libri Job")]), _vm._v(", printed among the "), _c('i', [_vm._v("spuria")]), _vm._v(" of Jerome."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-035",
      "id": "ap_ntb-035-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" His mistake was slavishly copied by the writer of the article on Julian in the "), _c('i', [_vm._v("Dictionnaire de théologie catholique")]), _vm._v(". In an important monograph, A. Vaccari proved that Julian of Eclanum was the author."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-036",
      "id": "ap_ntb-036-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" His arguments were based on the doctrine, vocabulary, style, exegesis, sources, and the biblical text used (namely, Jerome’s new version)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-037",
      "id": "ap_ntb-037-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Vaccari showed that the incorrect attribution arose from a banal confusion between the authentic work of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXV",
      "title": "XXV"
    }
  }, [_vm._v("Philip and that of Julian, and also the fact that Julian knew the work of the disciple of Jerome. Vaccari also used the material collected by the French scholar G. Morin, who successfully attributed to Julian the "), _c('i', [_vm._v("Tractatus prophetarum Osee Iohel et Amos")]), _vm._v(", a work that had previously been published among the works of Rufinus."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-038",
      "id": "ap_ntb-038-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Morin’s work enabled Vaccari to demonstrate that even the "), _c('i', [_vm._v("Expositio in Iob")]), _vm._v(" was to be attributed to the author of the "), _c('i', [_vm._v("ad Florum")]), _vm._v(", which was considered a certain work of Julian. J. Stiglmayr persistently contested the result, yet Vaccari has prevailed."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-039",
      "id": "ap_ntb-039-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Vaccari showed that Julian’s "), _c('i', [_vm._v("Exposition")]), _vm._v(" was inspired by the Antiochene John Chrysostom and the Greek writer Polychronius (d. ca. 430),"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-040",
      "id": "ap_ntb-040-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" who is obscurely referenced in passages that are not well preserved in the manuscript."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-041",
      "id": "ap_ntb-041-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" There is also a connection to Olympiodorus, but since the latter lived a century and a half after Julian, it must be assumed that both of them drew from a common source."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-042",
      "id": "ap_ntb-042-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Julian was also familiar with views of Philip the Presbyter (d. ca. 455), disciple of Jerome."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-043",
      "id": "ap_ntb-043-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Philip, whose commentary dates around 393–397, appears to have been the first to adopt Jerome’s new Vulgate translation as his reference text."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-044",
      "id": "ap_ntb-044-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Philip’s "), _c('i', [_vm._v("Commentary on Job")]), _vm._v(" survives only in fragments but provides important evidence of the Vulgate. It exists in a long and a short recension."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-045",
      "id": "ap_ntb-045-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Julian imitates Philip by adopting Jerome’s version. Julian’s "), _c('i', [_vm._v("Exposition of the Book of Job")]), _vm._v(" is the oldest surviving patristic commentary on Job that covers (virtually) the entire book."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-046",
      "id": "ap_ntb-046-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" St. Gregory the Great’s famous exposition of Job dates to 579, thus 150 years after Julian. My own estimation is that Julian is unsurpassed as a Christian exegete of the books he took under his consideration.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Annecchino observes that Julian’s "), _c('i', [_vm._v("Expositio in Iob")]), _vm._v(" contrasts strongly with his anti-Augustine manifestoes, "), _c('i', [_vm._v("ad Turbantium")]), _vm._v(" and "), _c('i', [_vm._v("ad Florum")]), _vm._v(", because it is free from doctrinal controversy. The great motifs of Pelagian preaching are absent from it."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-047",
      "id": "ap_ntb-047-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" The "), _c('i', [_vm._v("Expositio")]), _vm._v(" is more of a “hymn to reason, not in the sense that rationalism itself is exalted, but in the sense that it highlights a great confidence in man’s rational abilities that make him free "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXVI",
      "title": "XXVI"
    }
  }, [_vm._v("from a frustrating fatalism.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-048",
      "id": "ap_ntb-048-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" The preface to the "), _c('i', [_vm._v("Exposition")]), _vm._v(" can be divided into two distinct parts."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-049",
      "id": "ap_ntb-049-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" The first half lays the foundations of Julian’s doctrine: (1) the importance of the teachings of a virtuous life for achieving virtue and (2) the recognition of an inborn natural human goodness, which allows a person to live virtuously. At the basis of these doctrines lies the awareness of a free will, which can be inspired by positive examples and which allows us to live a life free from sin. In the second half of the preface, the theme of human suffering and divine justice is announced through Job’s dialogue with his “friends.” The preface ends with the recognition of divine providence, which is realized, among other things, through the works of creation.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Julian opens his exposition of the speech by quoting the words of St. Paul: “All things whatsoever that have been written were written for our instruction” (Rom 15:4). Julian argues that if it is important that the things that have been written not disappear in silence, it is more important that the actions of the holy people, which have been set forth for our imitation or to teach us, not vanish into thin air. For Julian, the importance of the exemplary model for the achievement of virtue is one of the main purposes of Christ’s coming among people (cf. Job 10:9-11)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-050",
      "id": "ap_ntb-050-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Christ became human in order that humans, by looking at the model of perfection, could strive for perfection (cf. Job 17:8-9). We are justified in speaking about holy Job, so that in him we can recognize the goodness of human nature. In Julian’s theology, humanity is responsible for its own condemnation and salvation. These themes are significantly placed among the first lines of the preface to Job and thus occupy an emblematic role in Julian’s thought.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Julian says that when their merits are made public, just people will shine like a splendid lamp (cf. Job 12:4-5). They will be recognized for their merits because they acted in full freedom. This freedom is granted from creation to enable people to live according to the divine laws. It exists even among those outside of Christian revelation. It is a force activated by the law of God and the example of Christ. Julian justifies the choice of the life of the holy Job, not to honor him through the exaltation of his good works but to show posterity that the way of virtue is accessible to everyone. Praising Job, in short, does not increase the esteem that God has of him but rather strengthens the hopes of those who want to become virtuous, so that through Job’s example we become aware of the fact that virtue is not inaccessible (Prol).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is interesting to note the resemblance between Julian and Pelagius’s interpretation of Job. In Pelagius’s famous letter to Demetrias, "), _c('i', [_vm._v("Ad Dem")]), _vm._v(" 6.1-3 (which was attributed to various saints for most of its reception history), Pelagius describes Job as a man who fought against the devil to the very end. The Lord himself testified on his behalf "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXVII",
      "title": "XXVII"
    }
  }, [_vm._v("(Job 1:8; 2:3), and this testimony was not undeserved, for “he always feared the Lord,” and “at no time did he dare to scorn one whom he believed to be ever present with him but said: I am safe, for my heart does not reproach me for any of my days” (Job 27:6). Pelagius cites Job 31:29, 32, 13 and 24 as evidence that Job anticipated the behavior commanded by Christ and exemplified by Paul. Pelagius writes,")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("What a man Job was! A man of the gospel before the gospel was known, a man of the apostles before their commands were uttered! A disciple of the apostles who, by opening up the hidden wealth of nature and bringing it out into the open, revealed by his own behavior what all of us are capable of and has taught us how great is that treasure in the soul which we possess but fail to use and, because we refuse to display it, believe that we do not possess it either."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-051",
      "id": "ap_ntb-051-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Returning to Julian, in the second half the preface, Julian summarizes and anticipates the debate between Job and the “friends” who came to visit him. Job’s “friends” maintained that physical miseries are linked to moral decadence. The dispute reaches a crescendo after the accusations and defenses unfold in a series of very significant statements. Julian begins by noticing that the debate is divided into three parts. In the first round, Job defends himself from the accusations of his “friends,” who say that he has been complaining without moderation. Job affirms that this must not be ascribed to his guilt, since his sufferings have been utterly unspeakable. In the second round, Julian emphasizes the questionable attitude of friends, who came with the intention of consoling him but ended up afflicting Job’s dispirited mind by attributing to him the responsibility for the calamities that struck him. The third part highlights how the “friends” attempt to show that Job is guilty precisely because he was struck by misfortune. But this is invalidated by the fact that many people of a corrupt life lead a prosperous existence.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Julian notes that Job justifies his defense also by addressing those who have been silent, because they could not refute his words. Job enumerates actions he performed on various occasions that were in accord with justice and done with a spirit of deference to the divine will. Annecchino shows that the tendency of Julian’s discourse, through the lengthy dialogue between Job and his friends, wherein each one is the spokesperson for a well-constructed religious position, responds to the typical characteristics of an "), _c('i', [_vm._v("apologia")]), _vm._v(", in which the accusations and defenses are intertwined.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("The whole discourse, by exposing the earthly condition of man through the misfortunes of Job, tends, in the restoration of the latter, to the exaltation of divine justice. Sometimes one has the impression of being in the presence of a text that is following the typical canons of a legal defense."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-052",
      "id": "ap_ntb-052-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The preface concludes by exalting divine providence. Overall, Julian wants to show how even those who have been tested the most severely cannot be conquered by the devil "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXVIII",
      "title": "XXVIII"
    }
  }, [_vm._v("if they will to live their humble human condition according to the virtue and freedom with which humanity has been endowed. Job has become an example for achieving virtue. Julian recognizes in the first words of the biblical story the moral qualities of this man: Job was "), _c('i', [_vm._v("simple")]), _vm._v(" in that he was far removed from any contamination of vices (Job 1:1). This means he was not a hypocrite (8:20). Job was "), _c('i', [_vm._v("upright")]), _vm._v(" because he feared the Lord (1:1). True wisdom lies in respecting the divine prohibitions and obeying God (28:28), and this is how Job had lived. However, the greatness of Job’s soul was best praised in his endurance of hardships (1:2-3). Job recognized the inconstancy of ephemeral goods and never surrendered morally to the circumstances that afflicted him.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("K. Steinhauser commends Julian’s insight in understanding the main theme of the book of Job: “He is one of the few ancient commentators on Job who comes close to the actual theme of the book, when he states that God permits the good to suffer in order to demonstrate their devotion and increase their merit.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-053",
      "id": "ap_ntb-053-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" In fact, the word "), _c('i', [_vm._v("meritum")]), _vm._v(" appears sixty-four times in Julian’s text, which makes clear that for Julian human beings can earn merit before God. Steinhauser speculates reasonably that Julian’s motives for expounding Job were determined by his dispute with St. Augustine over grace and hereditary sin. Julian chose to write a commentary on Job rather than on Romans “because the book of Job provides a more benign environment for the development of Pelagian thought and a more effective vehicle for its expression.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-054",
      "id": "ap_ntb-054-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" We should recall, however, that Pelagius himself wrote substantial commentaries on the Pauline epistles. Steinhauser thinks that Romans was Augustine’s preferred battlefield with the Pelagians, whereas Job was theirs. Allegedly, Romans gave Augustine the tactical advantage whereas Job gave his opponents the high ground. Romans allegedly affirms the existence of hereditary sin whereas Job speaks of a sinless person."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-055",
      "id": "ap_ntb-055-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Dealing with Job left Augustine with the embarrassing task of proving that this Old Testament saint was a sinner:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("One is reminded of a similar development in the Donatist controversy. The Donatists continuously extolled Cyprian, the martyred bishop of Carthage, as their ideal teacher and model of courage, thus leaving Augustine in the embarrassing position of having to condemn Cyprian in order to condemn them. Julian of Eclanum, the Pelagian genius, perceived a golden opportunity and decided to capitalize on this opportunity by writing a commentary on Job."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-056",
      "id": "ap_ntb-056-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Citing Pelagius’s use of Job in his "), _c('i', [_vm._v("Epistle to Demetrias")]), _vm._v(", Steinhauser reasonably claims that the Pelagians found in Job a corroboration of the good Gentile who was living in accord with natural law that Paul testified to in Romans 2:15-16. Julian agrees "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXIX",
      "title": "XXIX"
    }
  }, [_vm._v("(cf. Job 23:12). Pelagius affirms from the Old Testament examples of Abel, Melchizedek, Abraham, Joseph, and Job that human beings have “the ability to reform themselves without any additional intervention on the part of God. Human beings, who do not exercise this freedom, insult God. The concept of natural sanctity without hereditary sin could only be scandalous to Augustine.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-057",
      "id": "ap_ntb-057-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" I would comment here that the words “without any additional intervention on the part of God” are Steinhauser’s, not Julian’s or Pelagius’s. They are really an inference drawn by Augustine and applied to those who did not identify his doctrine of grace with the teaching of the church. In my view, A. Dupont summarizes Pelagius’s views more accurately and in a manner that I believe could be applied to Julian as well:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("He rejects every thesis that alleges that God commends to man something impossible and that God’s commandments cannot be fulfilled by individuals separately but only by all in community. Notice that Pelagius states that it is possible for the individual to observe God’s commandments. This opens the possibility of a righteous, sinless life. Pelagius condemns those who with Mani reject marriage or those who like the Cataphrygi are against remarriage. Pelagius finally emphasizes human freedom ("), _c('i', [_vm._v("liberum arbitrium")]), _vm._v("), "), _c('i', [_vm._v("without denying the human need for God’s help")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-058",
      "id": "ap_ntb-058-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The italicized words are of great importance since critics of Pelagius and Julian often rely on an argument from silence. With respect to Julian, Ogliari says that for him, “although man remains responsible for his moral activity, God’s helping grace is also at work co-operating with him whenever something good is achieved.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-059",
      "id": "ap_ntb-059-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" We know that according to the report of Melania the Younger, Pelagius actually wrote,")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("I declare anathema anyone who thinks or says that the grace of God by which “Christ came into this world to save sinners” (1 Tim 1:15) is not necessary, not only at every hour and at every moment, but also for every act of ours. And those who attempt to do away with this doctrine deserve eternal punishment."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-060",
      "id": "ap_ntb-060-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I cannot imagine Julian disagreeing with Pelagius’s declaration. Yet it is commonly assumed that the “Pelagians” did not mean it when they anathematized those who denied the need for divine grace. In a carefully written study, Dupont and Malavasi conclude that the fact that Augustine and Jerome found fault with Pelagius’s interpretation of grace does not imply they shared the same theology of grace between themselves.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Our study of their respective exegesis of Rom. 9,16 and Phil. 2,13 clearly illustrated that they upheld a different vision on the relation between good human volition and divine "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXX",
      "title": "XXX"
    }
  }, [_vm._v("grace. Thus, we also find diversity within the anti-Pelagian camp. Whether Augustine was fully aware of Jerome’s doctrine of grace is not completely clear, but if he was, he likely deemed Jerome’s doctrine as incomprehensive and insufficient."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-061",
      "id": "ap_ntb-061-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What follows is a more detailed synopsis of Julian’s interpretation of the book of Job."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-062",
      "id": "ap_ntb-062-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" To begin with, he regards the book as composed by the Holy Spirit (1:8). This is noteworthy because Julian’s teacher, Theodore of Mopsuestia, whose "), _c('i', [_vm._v("Commentary on the Psalms")]), _vm._v(" he had translated into Latin and whose “Antiochene” approach to exegesis had greatly influenced him, apparently rejected the divine inspiration of the book of Job. Angela Kim Harkins reports that for Theodore, Job’s angry outbursts (cf. Job 3) were irreconcilable with the portrait of him being a moral exemplar and “raised serious questions about the book’s inspired status.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-063",
      "id": "ap_ntb-063-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" She further notes that the Acts of the Council of Constantinople in 553 preserve fragments of Theodore’s critical comments on Job in which he rejected the book in its present form.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Second, the text that Julian interprets is Jerome’s new Latin version of Job translated from the Hebrew, not the Old Latin translation of the Septuagint (LXX) version. The Hebrew version is about 20 percent longer than the LXX. In his preface to the Vulgate version of Job ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" 393), Jerome reports to his readers that the LXX version is significantly reduced:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Wherefore, let my barking critics listen as I tell them that my motive in toiling at this book was not to censure the ancient translation [the Old Latin rendering of the LXX], but that those passages in it which are obscure, or those which have been omitted, or at all events, through the fault of copyists have been corrupted, might have light thrown upon them by our translation; for we have some slight knowledge of Hebrew."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-064",
      "id": "ap_ntb-064-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Julian adopts Jerome’s text while making some seventy references to Greek readings. According to Annecchino’s analysis, Julian used the version of the LXX handed down by the Codex Alexandrinus (mid-fifth century)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-065",
      "id": "ap_ntb-065-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" Julian often offers several readings of a single passage introduced by "), _c('i', [_vm._v("uel uel")]), _vm._v(" and "), _c('i', [_vm._v("aut aut")]), _vm._v(", and about fifty introduced by "), _c('i', [_vm._v("aliter")]), _vm._v(". Annecchino notes that the use of the latter adverb, which is absent in the "), _c('i', [_vm._v("Tractatus")]), _vm._v(", is really interesting because, in addition to the cases in which it is used between one interpretation and another, it sometimes makes a transition between the translation of the LXX "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXXI",
      "title": "XXXI"
    }
  }, [_vm._v("and the comment linked to Jerome’s biblical text. In two cases it is placed between the text and explanation (14:5; 41:24); at other times it is placed between the biblical quotation, presented both in Jerome’s and the Greek versions, and explanation; in some cases it is not connected to the biblical text or to the commentary that comes before; in two cases it lies between the text of the LXX and the commentary based on the LXX."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-066",
      "id": "ap_ntb-066-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" Noteworthy is that Julian’s interpretive technique does not seem altered by the text forms. He puts the literal interpretation first, conforming to the context of the passage and in respect of the contextual coherence, which is considered decisive in establishing the real meaning of the text, beyond any subjective or symbolic interpretation.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In basing his commentary on the new Vulgate translation, Julian has followed the path taken by Philip, disciple of Jerome, as mentioned above. It is noteworthy, however, that Julian does not copy Philip’s heavily allegorical approach to interpreting Job. Simonetti and Conti describe Philip’s exegesis of Job in these terms:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("The interpretation proposed by Philip is on two different levels. The first is the historical level which deals with the misfortunes of Job and explains them in a literal way. The second level is characterized by an extremely allegorical interpretation that considers Job as a figure of Christ and his three supposed friends as symbols of the heretics. These two kinds of interpretations run in parallel lines throughout the work. For instance, the seven sons of Job prefigure the sevenfold grace of the Holy Spirit, and his three daughters the law, the prophets and the gospel. Job, who curses the day of his birth, signifies Christ, who has taken upon himself the entire mortality of the human race and deprecates the transgression of Adam."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-067",
      "id": "ap_ntb-067-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In contrast with such a strongly allegorical reading, Julian focuses on the historical level without denying the prophetic and messianic aspect of some of Job’s oracles.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thematically, and resuming the issues mentioned above in our discussion of the preface, Julian says that Job’s life is praised in Scripture because in him the goodness of human nature can be recognized, even without his having been taught by the law of Moses. Job shows that human nature was sufficient unto itself to know the one true God, to reject sins and pursue all virtues (Preface; 16:19; 23:13; 33:15-16). Job’s prudence and perfect circumspection concerning sin are shown by his response to his trials (Job 1:22). He did not sin with his lips or do anything wrong before God (23:15). The theme of the book, then, is that God takes pride in those who are innocent, who practice sincere and unfeigned virtue, and who live according to his law. Julian, commenting on Job 17:8-9, writes,")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("For the Lord wanted to conceal his own justice in order to broadcast the merits of his servant [Job], in order that by his example every innocent person will not only stand up confidently against the hypocrite, but, moreover, while proceeding down the continuous way of virtue, will always increase his own former pursuits for the sake of those who are following.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXXII",
      "title": "XXXII"
    }
  }, [_vm._v("Job’s friends, who measure merits on the basis of prosperity and misfortune (Job 12:6), argue that Job is suffering these things because of his previous sins (4:2). They say that God’s justice does not permit him to show vengeance to those who have done nothing worthy of censure (4:7), that Job had only affected a reputation of justice, and that he did not have any solid virtue (8:11-12; 34:5). Indeed, they say that Job had committed grave sins against charity (22:6-7). In fact, in their estimation, Job has received less chastisement than his merits deserve (20:1-2, 18). Yet according to Julian, it is Job’s friends (excluding Elihu) who are the hypocrites, not Job himself (27:8; 38:1-2). Innocent and just persons, like Job, are to be contrasted with those who displease God by feigning virtue. The “friends” accuse Job of sin, based on his sufferings, but his conscience is upright (10:3-4; 11:1-2; 23:15). Job is like Christ, who for the sake of saving the human race, endured the humiliation of the cross, so that by his example the innocent person could stand up strongly against the accusations of hypocrites (17:8-9). In addition to possessing the virtues of justice, chastity, and moderation (31:12-13), Job had served the poor and was merciful to them (31:16). He had invited the vulnerable to his table (31:17), since the virtue of humanity was ingrained in him (31:18). He also had done good in chance encounters with the poor, clothing the naked, and showing compassion and hospitality to strangers (31:19, 32). He had never cheated his laborers (31:38-40) and had even loved his enemies (31:29). Such behavior sprang from his fear of God (31:23, 35). Job did not worship idols, which shows that he not only strove after good morals but also held fast to right religious thoughts (31:26-27).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It seems important to add, however, that according to Julian, Job does not claim to have lived an entirely sinless life (Job 6:3; 13:14, 23; 31:33). Granted what the book itself tells us, that Job was an innocent, upright, and God-fearing man, who did not sin in his response to his losses (1:1, 22; 2:10). Granted that in 17:2 (Vulgate) Job himself says in the lemma, “I have not sinned.” Julian acknowledges the truth of these affirmations and says that the latter passage could refer to the continuous time of his life, or else that he has avoided vices since lapses in his adolescence (13:26; 20:11; 33:8-10). Granted that Job judges as false Bildad’s effort to expose him as a sinner on the basis of his calamities (9:1). Steinhauser raises the question, “What better way could there be to refute Augustine’s insistence upon universal hereditary sin than by putting forth the concrete example of a holy man who did not sin?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-068",
      "id": "ap_ntb-068-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" In Julian’s defense, it seems only fair to indicate that, whatever Julian may have thought about Augustine’s doctrine of hereditary sin, Julian states that Job does not claim sinlessness (13:14; 31:33). Rather, Job denies that he had been a hypocrite in his prior life (13:16), and he thinks that the measure of the punishment and torture inflicted on him has been excessive and incongruent with the life he had lived previously (6:1-2; 8:1-2; 10:19-21; 13:14, 23; 15:11; 19:6; 20:1-2, 3, 18). Job does not deny "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXXIII",
      "title": "XXXIII"
    }
  }, [_vm._v("that he deserved chastisement from God, but he thinks the reproof he received has been excessive. Moreover, Julian points out repeatedly that Job does not boast about his own virtues (6:1-2; 23:11; 30:27; 31:35); rather, he was forced to defend himself against the vicious charges of his hypocritical friends who accused him of insolence and bitterness and of having committed criminal acts (22:6-7). But Job recalls his virtues reluctantly and with a sense of embarrassment. These passages seem sufficient to refute the claim that Julian views Job as a model of utterly sinless perfection that is attainable apart from the constant assistance of the grace of God.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("By revelation Job recognizes that mysteries are coming later on that will bring him remuneration and consolation for his virtue (19:27). Yes, he will be vindicated, and his fidelity to God will be revealed and the accusations of his friends exposed (19:28). For Julian, the overall lesson of the book is that although Job is unable to know the justice of God’s judgments (39:5), the Creator had never ceased to care for him and Job had never been robbed of God’s providence (38:4, 5-6; 39:33-34 LXX & Vulg = RSV 40:3-4; 40:1-3; 42:3). It is noteworthy that according to Julian, Job prophesies the coming of Christ and predicts the Lord’s passion (9:24; 17:8-9), his incarnation and resurrection, and the resurrection hope for his followers (14:12, 14, 18-19; 15:12; 19:25, 27; 26:5-6; 38:13, 14, 16-18). Contrary to a seeming majority opinion of modern exegetes of the book of Job, Julian claims that Job does not deny the future resurrection hope (7:9; 14:7, 12, 14).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Ultimately, as Job stands before the greatness of God, with the help of reason, he discovers the divine mysteries and understands that he is a part of it. He humbly accepts his human condition and lays bare his conscience before God. From the examination of past life (Job 29) and present (Job 30), he shows how, both in prosperity and in misery, he never moved away from justice, mercy, chastity, and temperance (31:7-13). He rightly states that by his constant pursuit of kindness, the virtue of his humanity was engrained in him (31:18). The endeavor to practice virtue, which is born of the fear of God (31:23), frees humanity from pain because although the just and the sinner are subjected to the laws of death, not all will suffer death. In fact, after (physical) death, life will be restored (30:23-24). In the image of Behemoth and Leviathan, symbols of negative power that can be overwhelmed and defeated by humans through virtue, all the force that can spring from it and from the positive example is expressed (41:16).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Additionally, it is interesting to note that Julian thinks the language used in Job 1:6 and 2:1-3 is figurative, since angels do not literally stand before God in the manner of attendants. God is invisible and boundless (cf. Job 11:8-9), and Scripture frequently presents things that were "), _c('i', [_vm._v("said")]), _vm._v(" as things that actually "), _c('i', [_vm._v("took place")]), _vm._v(" (22:17). Julian here follows Jerome’s line of interpretation of a number of texts of Scripture, which describe things "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXXIV",
      "title": "XXXIV"
    }
  }, [_vm._v("that took place in spirit as things that were actually carried out."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-069",
      "id": "ap_ntb-069-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Finally, Julian does not deny spiritual and allegorical applications of the book. He thinks the Leviathan creature represents the power of spiritual wickedness (41:25).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In her study of the themes of Julian’s "), _c('i', [_vm._v("Exposition of Job")]), _vm._v(", Annecchino summarizes Julian’s theology as follows:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Julian, in this writing, summarizes all his doctrine. The human being, as gifted with free will, finds his salvation not in a fatalistic saving grace, which transcends him by crushing him irreparably, but in his dignity as a free man. Although the theme of grace does not constitute a central point of Julian’s discourse, since he is intent on claiming the native goodness of human nature, it is clear that he does not deny divine help in the life of man, indeed he recognizes its multiformity. This grace of God, however, can only help and not create good will; if it were not so, the freedom of will would be annulled which is the greatest manifestation of God’s benevolence towards men. Free from "), _c('i', [_vm._v("tradux peccati")]), _vm._v(" [transmission of sin] man—and this is the central core of Pelagian morality—who is born full of innocence; he can tend to virtue and live far from sin by virtue of his innate strength, freedom and the will, aided by the divine law and the example of Christ, supported by reason which, even within the limits of its creaturely condition, makes it fear God, making it go beyond the limits of human abilities."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-070",
      "id": "ap_ntb-070-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To this I would only add that it appears to me that neither Pelagius not Julian intended these emphases as directed against the idea that humanity constantly stands in need of the divine grace and assistance for the achievement of virtue. Rather, their theology is directed against Manichaeism and fatalism, which is apparently how they interpreted Augustine’s doctrine of irresistible grace.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Julian’s tractates on Hosea, Joel, and Amos.")])]), _vm._v(" In 1580, R. L. de la Barre published this work for the first time among the works of Rufinus of Aquileia."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-071",
      "id": "ap_ntb-071-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" This association presumably suggests that the theological content was assessed favorably. De la Barre was succeeded by D. Vallarsi, who in 1745 reissued the work as an appendix to his edition of Rufinus. In 1849 Vallarsi’s text was re-edited by J. P. Migne."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-072",
      "id": "ap_ntb-072-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" Carl Paucker proposed on linguistic grounds that Julian was the author of these commentaries that had previously been ascribed to “Pseudo-Rufinus,” but death prevented the fulfillment of his hope of a later and fuller study."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-073",
      "id": "ap_ntb-073-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" Then, in 1913, Germain Morin developed Paucker’s suggestion "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXXV",
      "title": "XXXV"
    }
  }, [_vm._v("and successfully attributed to Julian of Eclanum the tractates on Hosea, Joel, and Amos."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-074",
      "id": "ap_ntb-074-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" His principal evidence (drawn from Paucker) was the striking similarity in language and style between Julian’s "), _c('i', [_vm._v("Libri VIII ad Florum")]), _vm._v(" and the "), _c('i', [_vm._v("Tractates")]), _vm._v(". Bouwman describes Morin’s achievement as “one of the finest accomplishments in modern patristic studies.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-075",
      "id": "ap_ntb-075-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" The text in the Migne edition had been extremely defective, but thanks to new manuscript discoveries, aided by the research of Morin, Baxter, and Bouwman, Julian has now been edited in a modern critical edition by Lucas De Coninck and M. J. D’Hont, the basis of the present translation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-076",
      "id": "ap_ntb-076-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" Bouwman describes Julian’s "), _c('i', [_vm._v("Commentaries on Hosea, Joel, and Amos")]), _vm._v(" as a long forgotten pearl of ancient Christian literature, which is completely free from any taint of the Pelagian heresy (although he thinks Pelagian expressions are found frequently in the commentaries on Job and Song of Songs)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-077",
      "id": "ap_ntb-077-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Despite the initial attribution, it is hardly conceivable that Rufinus of Aquileia (345–410) was the author of these commentaries. There is no ancient evidence (from Jerome or Gennadius) that Rufinus composed such works. The author is rather critical of Origen’s allegories, whereas Rufinus admired them and had defended and translated Origen’s highly allegorical homilies on the Hexateuch. The author praises Jerome’s scholarship in the preface and actually adopts Jerome’s new Vulgate translation of the Hebrew as his base text. (He had also adopted the Vulgate for the Job exposition.) Yet Rufinus is known to have been a severe critic of both Jerome’s person and of his new translation of the Old Testament."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-078",
      "id": "ap_ntb-078-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" In fact, both Rufinus and Augustine argued in opposition to Jerome that the Greek Septuagint was the divinely inspired and ecclesiastical version of Scripture. This is all decisive evidence against Rufinian authorship of these commentaries.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When assessed against the backdrop of his own times, Julian’s adoption of Jerome’s new translation of the Old Testament as his base text of Scripture is strikingly bold and innovative. He had been preceded only by his predecessor Philip, disciple of Jerome. Julian’s extensive use of Jerome’s commentaries in his own work confirms the respect he held for Jerome’s overall scholarly achievement. Julian explicitly ascribes theological importance to Jerome’s new translation in these words:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Let the reader of our work recognize which version I followed and what was the main consideration I had in mind when I took up this very difficult task of writing a commentary. Especially if he belongs to those who train attention on the reading [in the liturgy],"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-079",
      "id": "ap_ntb-079-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" let him know that it was not for no reason that I deliberately chose this most recent version "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXXVI",
      "title": "XXXVI"
    }
  }, [_vm._v("known as “according to the Hebrew.” For in the earlier versions faults of expression frequently corrupt the meaning, of the doctrinal teaching or of the narrative, so that divination rather than work seems to be required. But this latest translation, although it has not added much rhetorical brilliance to the coherence of the original text itself, nevertheless by its integral soundness of expression it frequently avoids those previously mentioned losses of suppressed meanings."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-080",
      "id": "ap_ntb-080-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Julian’s attitude toward Jerome’s new translation and his effort to assimilate Jerome’s learning into his own stands out in contrast to the theory and practice of Augustine, who at least in his early period did not think Jerome was qualified to translate the Bible from Hebrew, and he tried to dissuade him from that task. Augustine wrote the following to Jerome in the inaugural letter of their famous dispute over the proper meaning of Paul’s conflict with Peter recorded in Galatians 2: “I would be very surprised if anything could still be found in the Hebrew texts which had escaped the notice of all those [Hexapla]"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-081",
      "id": "ap_ntb-081-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" translators who were such experts in that language.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-082",
      "id": "ap_ntb-082-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" He fashions the following syllogistic argument to dissuade Jerome in his effort: The passages that the Seventy translated were either obscure or plain."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-083",
      "id": "ap_ntb-083-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" If they were obscure, one must believe that Jerome’s new version is just as likely to be mistaken. If the passages were plain, it is not believed that the Seventy could have been mistaken. So how could Jerome’s translation be anything but erroneous or redundant?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-084",
      "id": "ap_ntb-084-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Jerome eventually replied to this logic (not without sarcasm) as follows: a whole series of Greek and Latin writers have composed commentaries on the Psalms; Augustine too has published a work on the Psalms, which is at variance with the other writers. Jerome asks, Why, after all the labors of so many competent interpreters, does Augustine differ from them in his exposition of some passages? If the Psalms are obscure, it must be believed that he is as likely to be mistaken as the others; if they are plain, it is incredible that these others could have fallen into mistakes. In either case, Augustine’s exposition of the Psalms has been an unnecessary labor, and on his principles, no one would ever dare to speak on any subject after others have pronounced their opinion. Jerome reproaches the incivility of Augustine’s attack: Why does Augustine grant himself the liberty to contribute to the church’s exegetical tradition of the Psalms yet is intolerant of Jerome’s effort to make a new Christian Latin translation of Scripture directly from the Hebrew? Jerome "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXXVII",
      "title": "XXXVII"
    }
  }, [_vm._v("writes, “No, it should rather be your duty, as a civilized human being, to show the same indulgence to others as to yourself.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-085",
      "id": "ap_ntb-085-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" Jerome goes on to say that he has not attempted to do away with the works of his predecessors by his fresh work on the Hebrew text. Therefore, Jerome adds, if Augustine is averse to reading his version, no one is compelling him to read it against his will. Let him drink with satisfaction the old wine; but Augustine should not despise Jerome’s new wine.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In a later letter, Ep. 82.34, Augustine claims to have become convinced of the benefits of Jerome’s translation of the Scriptures from the original Hebrew. Yet at least one modern scholar has noticed that Augustine seems to deliberately neglect Jerome’s scholarship in exegetical works that could have directly benefited from Jerome’s learning. E. Plumer, the modern translator of Augustine’s "), _c('i', [_vm._v("Commentary on Galatians")]), _vm._v(", finds it surprising that Augustine did not draw on Jerome’s erudite exegesis of Galatians in his own commentary on Paul’s text, though he had access to Jerome’s work and had criticized it in published letters.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("At the very least, one would have expected him to borrow some linguistic point or other from Jerome, particularly as we find Augustine very soon afterwards emphasizing the importance of linguistic expertise for the interpreter of the Bible, painfully conscious of his own lack in this regard, and (no doubt thinking primarily of Jerome) commending the work of the Hebraists to biblical interpreters ["), _c('i', [_vm._v("De Doctrina Christiana")]), _vm._v(" 2.11.16; 2.16.23]. Yet where is the evidence of Augustine’s having taken his own advice?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-086",
      "id": "ap_ntb-086-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In contrast to Augustine’s deafness to the value of Jerome’s scriptural exegesis and translation work, it appears to me that no reader of Julian’s "), _c('i', [_vm._v("Commentaries on Job, Hosea, Joel, and Amos")]), _vm._v(" could come away wondering about the evidence that Julian learned from Jerome’s Hebrew scholarship; it is found on every page. Julian has adopted Jerome’s text as his own. Where pertinent to the prophetic context, he has assimilated Jerome’s expositions. I have endeavored to aid the reader in detecting this by recording parallel passages in the footnotes. One can also learn a great deal by observing the way Julian differs from Jerome as an interpreter of these books.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Date and sources of Julian’s tractates on Hosea, Joel, and Amos. ")]), _vm._v("Scholars do not agree on when these commentaries were composed. Morin dates them early, between 421 and 423, before the translation of Theodore’s "), _c('i', [_vm._v("Commentary on the Psalms")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-087",
      "id": "ap_ntb-087-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" Bouwman places them in the late 430s (439) after Julian’s return to the West. He describes them as Julian’s last and most mature works."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-088",
      "id": "ap_ntb-088-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" De Plinval dates them 432–436."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-089",
      "id": "ap_ntb-089-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" He was followed by Duval."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-090",
      "id": "ap_ntb-090-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXXVIII",
      "title": "XXXVIII"
    }
  }, [_vm._v("I tentatively follow the suggestions of J. Lössl in placing them in the mid- to late 420s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-091",
      "id": "ap_ntb-091-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" In his preface to Hosea, Julian observes that among the Latins particularly there has been a long silence in commenting on the prophets, yet among the Greeks and Syrians some exegetes have arisen who have endeavored to discuss these writings. He says he has read a few things written by St. John Chrysostom, who adapted nearly his whole work to homiletical exhortation rather than commentary."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-092",
      "id": "ap_ntb-092-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" Julian goes on to report that on Hosea, Origen of Alexandria (ca. 185–ca. 254) composed “charming allegories rather than solid and tenable historical explanations.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-093",
      "id": "ap_ntb-093-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" Apparently, Julian read Origen’s Greek works on the Prophets."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-094",
      "id": "ap_ntb-094-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" Jerome had indicated that Origen also wrote a work in Greek titled “Why Is the Name of Ephraim Used in Hosea?” Jerome says that this work aimed to show that whatever was spoken against Ephraim in Hosea should be referred allegorically to the persona of the heretics."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-095",
      "id": "ap_ntb-095-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" Jerome himself adopted this antiheretical application extensively in his own commentary on Hosea, which in allegorical digressions contains an enormous amount of polemic against heretics. This feature is completely absent from Julian’s commentary. I have counted 246 occurrences of the term "), _c('i', [_vm._v("heretic")]), _vm._v(" or "), _c('i', [_vm._v("heresy")]), _vm._v(" in Jerome’s commentaries on Hosea (160), Joel (7), and Amos (79), whereas in Julian’s three commentaries these terms hardly occur at all."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-096",
      "id": "ap_ntb-096-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" Julian evidently felt that such allegorical excurses, which apparently originated in Origen’s Greek exegesis, were inappropriate and far removed from the commentator’s task of expounding the contextual coherence of the prophetic texts. As mentioned above, Julian also shied away from such diversions in his Job commentary. It does not seem just, however, to conclude from Julian’s criticism of Origen on this particular point that it means that Julian was generally hostile to Origen’s exegesis. My estimation is that Julian would have been quite sympathetic to Origen’s strongly anti-Gnostic (= anti-Manichean) exegesis of Romans, for instance, as was Pelagius for certain."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-097",
      "id": "ap_ntb-097-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" Such a stress found in Origen resembles Julian’s and Pelagius’s anti-Manicheism and stress on free will.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After mentioning John Chrysostom and Origen, Julian goes on to give us his opinion of Jerome himself:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Jerome, a man of enormous intellectual capacity and persistent zeal for scholarship, wrote commentaries on the books of the prophets to be sure, but he was content to navigate "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXXIX",
      "title": "XXXIX"
    }
  }, [_vm._v("between the two traditions [Greek Christian and Jewish], and he was either unwilling or unable to exhibit any concern to seek contextual coherence."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-098",
      "id": "ap_ntb-098-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" Thus his entire speech flowed either through the allegories of Origen or through the fabulous traditions of the Jews. Therefore, since it seems to me that he [Jerome] passed over many useful things, I have decided that the work would be a religious one before God and useful to men, if in obedience to you, I should undertake to write a commentary on the prophets, as our capacity has allowed by the help of divine grace. ("), _c('i', [_vm._v("Hos Prol")]), _vm._v(")")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Noteworthy here is that Julian recognizes Jerome’s scholarly contribution to the church and admits that he has been inspired to write his own commentaries on the prophets by his great predecessor, whom he regards as a man of great intellect and persistent scholarly zeal. Yet he simultaneously criticizes Jerome’s exegetical works for excessive attachment to Origen’s allegorical exegesis and for unfounded esteem for Jewish traditions. Julian thinks that Jerome should have paid more attention to expounding the historical context of the prophetic texts. Slightly later in the preface, Julian says that he himself is not interested in the investigations into “novelties.” I believe he means that Origen provided many novelties by his allegorical interpretations that related the details of prophetic texts to the heretics who were afflicting the church. Jerome incorporated many of these into his works and added more “novelties” from the Jewish exegetical tradition—that is, etymologies, stories, and explanations that had not previously been familiar in the Latin West. According to Julian, not all of these new things contribute to the coherent explanation of the prophetic texts. Even previously unknown Jewish traditions need to be sifted and compared to the context. In other words, in Julian’s view Origen’s and Jerome’s scholarly work on the prophets has left room for successors to achieve other tasks. J. Lössl comments on the lengthy passage cited above:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Julian’s notion of what is the meaning of his text is also far more restricted than Jerome’s. Having Jerome’s commentary on the Minor Prophets in front of him and indicating, without mentioning Jerome’s name, that he draws from it, Julian makes clear that he wants to discuss neither historical and philological "), _c('i', [_vm._v("quisquiliae")]), _vm._v(" [odds and ends] like the Jewish Rabbis nor indulge in allegorical and typological exegesis in the tradition of Origen. This criticism is directed against Jerome. Julian cannot but acknowledge the quality of Jerome’s translation, and his commentary reveals in every single paragraph its indebtedness to Jerome’s commentaries on Hosea, Joel, and Amos, but that does not prevent Julian from mercilessly pointing out that in Jerome’s commentaries the simple narrative, historical, and prophetic fabric of the text, its most basic, simple, meaning, is buried under an avalanche of marginal details."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-099",
      "id": "ap_ntb-099-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XL",
      "title": "XL"
    }
  }, [_vm._v("This seems to be a very accurate assessment. Yet it hardly seems fair to take Julian’s words cited above as an affront to Jerome, as Bouwman does."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-100",
      "id": "ap_ntb-100-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" Jerome himself tells us that he conceives the chief work of a commentator to be that of compilation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-101",
      "id": "ap_ntb-101-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" He admits that he does not necessarily endorse all the views he records, nor does he provide definitive interpretation of all texts, but rather leaves many interpretive choices open to the reader. Jerome says that his overall goal was to acquaint his Latin readership with the Greek Christian and Hebrew interpretive tradition."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-102",
      "id": "ap_ntb-102-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" These are very noble ambitions to which he dedicated his life, and it is a credit to Jerome that he supplied the Latin church with an enormous reservoir of exegetical and homiletical material. Yet Jerome’s aims do not determine how Julian understands the task of a commentator. Baxter summarizes Julian’s method under a discussion of his favorite words, "), _c('i', [_vm._v("consequentia")]), _vm._v(" and "), _c('i', [_vm._v("consequenter")]), _vm._v(":")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("These words are among the most characteristic and the most frequent in Julian’s vocabulary. As a sober commentator of the Antiochene school, despising the allegorical method of exegesis and intent on bringing out the literal and historical meaning of Scripture by the close study of the context and the natural development of narrative or argument, he keeps continually insisting on the sequence of ideas, the logical unfolding of the story, and he well defines his position in the words of Hos 10:10: “the rule of explanation is best which is taken from the context of the reading.” Hence his incessant use of "), _c('i', [_vm._v("consequenter")]), _vm._v(", "), _c('i', [_vm._v("consequentia")]), _vm._v(", and of "), _c('i', [_vm._v("contextus")]), _vm._v(", in all the treatises which flowed from his pen."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-103",
      "id": "ap_ntb-103-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("From Jerome, Julian learned that all three books of Hosea, Joel, and Amos reflect the historical circumstances of the reigns of the kings mentioned in Hosea 1:1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-104",
      "id": "ap_ntb-104-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" This view, Jerome tells us in the preface to Joel, is derived from Jewish tradition. Whatever modern exegetes may say about the tenability of this claim with respect to Joel, Julian accepts this theory and makes the corresponding historical background of these particular reigns, as testified in Kings and Chronicles, the fundamental context in which the prophecies were delivered. Moreover, Julian adopts from Jerome nearly all that he reports "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLI",
      "title": "XLI"
    }
  }, [_vm._v("about history, topography, biblical realities, Jewish exegesis, and alternate interpretations. Thus, from start to finish he is sitting at Jerome’s feet and learning from him as a teacher. According to Julian, the message of Hosea, which is also closely related to that of Joel and Amos, is that “our God declares that he has received the synagogue as his wife, as it were, but that she violated the terms of the union in the fashion of adulteresses, and, what is more, she subjected herself to the worship of different gods [in the form of Jeroboam’s calf-bulls]” (Joel 1:8-9). Therefore, God has threatened to bring disasters on the people of Israel, while also holding forth his offer of mercy to the penitent. In Joel the threat takes the form of a forthcoming locust plague that hopefully will inspire terror and remorse in the hearts of the listeners. It will be removed once God has been placated. In Amos, whose focus is on the ten tribes, God’s providential care for the surrounding nations is also revealed. He examines them in judgment as well as the Jewish nation (Amos 1:3-5), for he is the God of the Gentiles as well as the Jews. No human being’s pursuits are deprived of consolation or punishment in the divine recompense. Julian offers a beautiful summary of God’s singling out Israel from all nations under Amos 3:1-2. Elsewhere he says that many prophetic promises point to greater blessings under the Messiah (Joel 2:26-27), yet not every detail of these prophecies can be applied to the spiritual interpretation under the gospel times (Joel 3:4-8). Rather, digressions occur in the course of the words of the prophets that point to messianic times, but then the prophet reverts to his own times once again.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Julian agrees exegetically with Jerome (over against Theodore of Mopsuestia) that Hosea 5:10 refers to Judah’s rejoicing at the extent of the lands annexed to themselves when their brother Israel was driven out by the Assyrian captivity. He follows Jerome’s interpretation of Hosea 6:7 that Israel fell by imitating Adam, an interpretation that some modern theologians have reproached as a “Pelagian” interpretation. Scores of other examples of Julian’s discipleship to Jerome could be documented. Yet despite his tremendous debt to Jerome, both for his text of Scripture and for the exegetical and historical content, Julian does not simply copy Jerome’s interpretations in the manner of a plagiarist. On the contrary, he critically engages it and is capable of reproaching Jerome’s exegesis, sometimes impertinently, yet almost always anonymously (in the sense that he does not name Jerome as his target). Yet his criticism of Jerome is not personal but historical-critical."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-105",
      "id": "ap_ntb-105-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" At times Julian disagrees with Jerome’s exegesis as unbecoming to the historical context and coherence of the prophetic books. Julian frequently offers a range of possible interpretations of the text, introducing them with the "), _c('i', [_vm._v("vel")]), _vm._v(", "), _c('i', [_vm._v("aut")]), _vm._v(" (“or”) or "), _c('i', [_vm._v("aliter")]), _vm._v(" (“Here is another way”). To me this indicates humility and a spirit that does not aim to impose a dogmatic straitjacket on every text he interprets.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLII",
      "title": "XLII"
    }
  }, [_vm._v("Here are samples of passages where Julian seems to regard Jerome as having faltered in his interpretations.")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Under Hosea 1:2-5, commenting on the words, “I will visit the blood of Jezrahel on the house of Jehu,” Julian thinks that historical background in 2 Kings 9-10 might be adequate to explain Hosea’s reference to Jehu (this is Jerome’s interpretation), but the closer context in Hosea favors the view that here Jehu stands in place of the nation of Israel.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Under Hosea 2:14-17, Julian mentions a meaning of “Baal” Jerome had reported as stemming from the Jewish tradition, but Julian finds the context of Hosea alone sufficient for ascertaining the sense.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Regarding Hosea 9:8, Julian mentions that “some” (Jerome) think that the watchman of Ephraim refers to Jeroboam. Julian presents Jerome’s interpretation in full but then dissents from it based on the immediate context.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Under Hosea 9:15-17, Julian again reports that “some” (Jerome) have taken the passage to refer to Saul, but Julian finds this an overly subtle interpretation and presents one that he finds “clearer and more applicable.”")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("In his commentary on Hosea 11:8-9, Julian reproaches Jerome by name for his claim that in a certain sense God will never enter a city, which would put the verses in opposition to Psalm 87:2 and 46:5.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Under Hosea 12:11, Julian once more finds the immediate context sufficient to explain the meaning rather than far-fetched references presented in Jerome’s commentary.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("In his preface to Joel and under Joel 1:1, Jerome had discussed the etymologies of names of the Twelve Prophets and their sires and interpreted these terms allegorically. Julian finds this childish and criticizes the practice (Joel 1:1).")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("In distinction from Jerome, Julian interprets Joel as describing a real locust plague that fulfilled predictions made in Deuteronomy 28. The basic description is literal, not symbolic of nations harassing Israel, as Jerome had claimed based on Jewish tradition (cf. Julian on Joel 1:4; 2:19-20).")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Under Amos 7:4-6, Julian adds that Jerome’s interpretation of the locust plague as symbolic of Israel’s enemies is inconsistent with history, since the prophet says that these plagues were warded off by his prayers whereas the Assyrian and Babylonian enemies were victorious. Thus, contextual coherence is the leading principle of Julian’s exegesis and the basis for his dissent from Jerome (when he exhibits such dissent).")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Under Amos 2:13-16, Julian dismisses a Jewish interpretation Jerome had provided. At Amos 5:25-27 he strongly reproaches Jerome by name.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Under Amos 9:1a-c, Julian reports anonymously what Jerome and Theodore had thought, that the altar referred to was that of the temple in Jerusalem. Julian objects: “But the context of the passage refutes such an understanding. For no mention of Judah had preceded, but he was expressly threatening the ten tribes.” Contextual coherence and historical consistency is the main principle once again. Yet it is clear that Julian does not repudiate allegorical or symbolic interpretation in principle, since he offers an allegorical application of the locusts to human souls (Joel 2:4-11). Julian’s symbolic exegesis in this section has clearly been informed by Jerome’s commentary on Joel 1:4 and his commentary on Zechariah 1:18-21, which no doubt had been based "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLIII",
      "title": "XLIII"
    }
  }, [_vm._v("in Origen. This particular example shows the inadequacy of the scholarly attempt to make rigid dichotomies between Alexandrian and Antiochene approaches to exegesis."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-106",
      "id": "ap_ntb-106-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In general, Julian’s interaction with Jerome strikes me as that of the respectful engagement of a very intelligent pupil with the learned but not infallible views of a revered and pioneering scholar.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Many modern scholars claim that the logical and thematic tensions that exist in the writings of the prophets are to be attributed to the fact that different editors from different centuries were permitted to interpolate their ideas into the prophetic books."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-107",
      "id": "ap_ntb-107-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" Julian’s comment under Amos 5:3 deals with this question of whether there are inconsistencies in the prophets. He handles the problem as follows:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("The history of Kings makes clear that the misfortunes of captivity did not rush in all at once, but the people were chastised at many times, while their amendment was awaited."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-108",
      "id": "ap_ntb-108-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" And for that reason our God addresses them through the prophets by a voice that changes its tone. At one time he says that their ruin is definite, since ruin had to be declared. At another time, he promises them prosperity, if they amend. Therefore, do not surmise that there is any discrepancy in the statements, as though he were restricting them to one time; rather he distributes the judgments that have been set forth over long periods of time and they are appropriate for the circumstances. Then you will find that coherence is maintained in everything, and truly, the reign of the profane people was diminished bit by bit by increasing adversities, until it reached the destruction of the final captivity. Accordingly, we should understand that the decimation of the nation was carried out in those cities and regions, which were laid waste while the capital city of Samaria was still standing.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For Julian the discrepancies and seeming inconsistencies in the tone and message of the prophecies found in Hosea, Joel, and Amos can be attributed to their lengthy periods of ministry and to the varying historical circumstances they were addressing. Obscurity arises from the way the prophets intermingle judgments that pertain to various times into single oracles (Amos 3:13-14; 5:25-27). In my view, Julian’s rigorous historical and contextual approach to interpreting these books deserves consideration at the table of modern exegesis of Hosea, Joel, and Amos.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Use of Theodore of Mopsuestia? ")]), _vm._v("Scholars disagree on the question of whether Julian had Theodore of Mopsuestia’s "), _c('i', [_vm._v("Commentaries on the Prophets")]), _vm._v(" directly at his disposal while writing his own. He does not mention Theodore among his sources in the preface to Hosea, although he does mention Origen, Jerome, and John Chrysostom. Morin found evidence for Julian’s use of Theodore in Julian’s reference to the “Syrian” interpretation of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLIV",
      "title": "XLIV"
    }
  }, [_vm._v("Hosea’s real marriage to a prostitute, which agrees exactly with what Theodore says. Bouwman concedes that Julian knew of Theodore’s interpretation of Hosea’s marriage as factual but thinks that some of the corresponding interpretations between Julian and Theodore may have been derived from Theodore’s "), _c('i', [_vm._v("Commentary on the Psalms")]), _vm._v(" and not directly from the published form of Theodore’s exegesis of the prophets."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-109",
      "id": "ap_ntb-109-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" Julian’s comments about Hebrew idiom correspond with what Theodore says (Hos 1:2-5). Julian does not follow Theodore’s example in ignoring the Lord’s reference to Hosea 10:7-8 in Luke 23:30 and Paul’s citation of Hosea 13:14 in 1 Corinthians 15:55. Theodore agrees with Julian that Joel lived in the time of Hosea. Julian disagrees with Theodore that the locusts are figurative of Israel’s enemies.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Julian’s conception of prophecy. ")]), _vm._v("Julian recognizes the messianic dimension of particular prophecies. He thinks that Hezekiah foreshadows Christ (Joel 2:26-27) and that events fulfilled under Hezekiah are fulfilled more abundantly under Christ (2:32). Yet not everything the prophet weaves into his speech is connected to a spiritual understanding (3:4-8). Several passages from Julian’s "), _c('i', [_vm._v("Commentaries on Hosea, Joel, and Amos")]), _vm._v(" deserve special attention, since he seems to make use of his definition of prophetic vision ("), _c('i', [_vm._v("theoria")]), _vm._v(") to interpret Old Testament prophecies in the light of their New Testament fulfillment."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-110",
      "id": "ap_ntb-110-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" Hosea 1:10 is cited by St. Paul in Romans 9:25-26 as being fulfilled in the reception of the Gentiles into the church. Julian believes that in his original context the prophet Hosea is describing the return of the Israelites from the Babylonian captivity, but he does so with language that in no way corresponds to the historical facts, but transcends them by far—for example, when he says, “And the number of the sons of Israel will be like the sand of the sea which is without measure, and shall not be numbered” (Hos 1:10). With wording like this, the prophet wants to call attention to the fact that Israel’s return from Babylon is an image of a much more wonderful liberation, which alone corresponds to the description that is given. It is not that Israel’s return from Babylon is the text’s literal meaning whereas the Christian ecclesiastical application is the allegorical meaning. No, rather, the prophet has predicted both, so that the imperfection of the historical partial fulfillment points to the future messianic events. Hosea 1:10 provides the occasion for Julian’s definition of prophetic vision. He says that when Paul indicates that Hosea’s promise was fulfilled in the time of the gospel, his aim is not to deny what the whole context of the prophecy of Hosea drives home—namely, that a release from the Babylonian captivity had also been promised:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("He [Paul] merely wanted to show what principle we ought to observe in the interpretation of the prophetic writings, that is, when anything was revealed in a narration of Jewish matters that was vaster than the insignificance of one nation had room to contain, we need to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLV",
      "title": "XLV"
    }
  }, [_vm._v("know that it has been fulfilled partially in that people, and by [prophetic] vision ("), _c('i', [_vm._v("per theoriam")]), _vm._v(") it is applicable to others also, that is, to all the nations. But as the learned have agreed, [prophetic] vision ("), _c('i', [_vm._v("theoria")]), _vm._v(") is the perception of those realities which are of greater importance, considered generally in brief images or cases. Therefore, this summoning back of the Jews from Babylon was not properly spoken of according to history, but that liberation signified allegorically what has been acquired through faith in Christ.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Julian grants that the prophetic speech has promised both without qualification. Thus, the thing of moderate size that preceded made known the peaks that were to follow. “For what had first been expressed in exaggerated terms hardly equaled the magnitude of the things that were to come later” (Hos 1:10-11). What Hosea had said of the Babylonian times, Paul transferred to the facts of the Savior. Annecchino summarizes Julian’s exegetical principle this way:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("That is, the prophet has two objects of his prophecy in his mind and uses the first to announce the second. The prediction is one and occurs twice: first partially in Jewish history, then fully in the history of the Messiah. This happens when the anticipation of an episode in the life of Jesus is caught in Jewish history. The two events, as historically real, have a literal meaning in which there is no first and second but rather a sense virtually double literal."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-111",
      "id": "ap_ntb-111-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("No New Testament passage cites Hosea 2:16-24 as being fulfilled in the New Testament period. However, Julian provides an interpretation of it within the framework of a general typological correspondence between Israel and the church. He says it is fulfilled more clearly if we apply it to the calling of the gospel. Yet Hosea 11:1 "), _c('i', [_vm._v("is")]), _vm._v(" cited in Matthew 2:15 as a type in the technical sense. From what Julian says, it appears that in this instance the prophet himself is not aware of the higher fulfillment. Julian says that since the context of the prophecy shows that this was said concerning the Jewish people, apostolic authority pointed out that this can also be transferred to the person of the Lord Jesus Christ—namely, the one through whom those things that had been given to the Jews as insignia of the divine religion were conferred even more abundantly and more graciously on us. Bouwman comments that this is not a mere accommodation of the Hosea passage by Matthew but rather a unique allegorical interpretation within the framework of a general typology whereby Israel equals Christ.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The words of Hosea 13:14 are cited in 1 Corinthians 15:55. The miraculous liberation from the siege of Sennacherib is an image of the freedom that Christ has given to us. Julian says that he has already explained this in accordance with the history predicted by the prophet. Yet it is also capable of signifying even greater things: “Therefore, that liberation which was accomplished under Hezekiah is unfolded more abundantly and graciously by the freedom that Christ bestowed” (Hos 14:10). One observes that the New Testament citation provides the occasion to Julian for a broader typological interpretation that once again is based on the typology of Israel’s equivalence with the church.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLVI",
      "title": "XLVI"
    }
  }, [_vm._v("Although New Testament prooftexts are not found for Joel 2:23, the foundation of the typology is the correspondence between Hezekiah and Christ. Julian says that we should apply the things that were done by Hezekiah to the affairs of our Redeemer: “Thus though they were indeed fulfilled somewhat in [Hezekiah’s] time, yet under the gospel they seem to have acquired vast surpluses of meaning. For he [Christ] is the true ‘teacher of justice’ (cf. Joel 2:23 Vulgate) ‘in whom all the treasures of wisdom and knowledge are hidden’ (Col 2:3).” Joel 2:28-32 is quoted in Acts 2:17-21. Julian observes that Peter recalled this passage when the Holy Spirit came down into the apostles (cf. Acts 2:17-21). But the only point he wished to make initially is that the apostles’ miraculous gift of tongues fulfilled Joel’s prophecy about the outpouring of the Spirit. Yet Peter added to say that when the day of the Lord comes, it will be with the power and uproar described in Joel’s prophecy, when the stars are struck down and the world collapses (cf. Mt 24:29; 2 Pet 3:10-12). Faith alone will suffice for salvation at that time.")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Therefore, just as it does not interfere with the prophet’s meaning to apply what the whole book describes as Jewish history to the situation of the gospel, so also—or rather, far more, at least with the well-educated reader—it is never allowed to deny the credibility that is suitable to the context if some prophecy can be applied to the situation of believers from the nations too.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Julian thinks the audacity of those must be renounced who recklessly and ignorantly contend that the prophet had indicated solely that time about which the apostle Peter preached. For the entire context of Joel is shown to embrace first the times of the Jewish people but, secondly, ours, “as a finishing touch as it were.” Julian goes on to say that the prophecy of Joel was fulfilled in its first stage at the time of Hezekiah. However, the events of that time had not merely a historical but also a prophetic significance. This prophecy has even a third level of meaning: the eschatological. As Christ linked the downfall of Jerusalem with the end of the world, so shall the shaking of nature that occurred at the death of the Redeemer take place more fully at the world’s end.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The foundation of Julian’s interpretation of Joel 3:17-21 is the typological correspondence between Jerusalem and the church. Julian says that the blessedness of Jerusalem foretold in Joel embraces the mysteries of the church, which endured the assault of hostile power, of the Jews, and of the pagans:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Just as we read that this was done in part under Hezekiah, so also we proclaim it was fulfilled more abundantly under the “mediator of God and men” (1 Tim 2:5). He indeed . . . promised that he would dwell in the midst of the city of Zion when he said: “Behold I am with you all the days, even to the consummation of the world” (Matt 28:20).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Julian claims that the punishments Amos threatened against the Jews in Amos 8:7-12 were indeed fulfilled when they went into exile but also when they later rejected the Lord. He says that the context of the reading demands the continuance of historical application "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLVII",
      "title": "XLVII"
    }
  }, [_vm._v("to the Jews, but the same things are also valid for signifying future things—namely, those times in which the Jews sinned most criminally and fell most gravely. Amos 9:11-12 is cited in Acts 15:16-17. Julian explains,")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Therefore, by following the teaching of the apostles, we have come to know that the books of the prophets must be understood in such a way that the events of their own times are embraced according to the context. And through the sudden digressions or accumulations of senses, they also have indicated future events, and have taught that their greatness is seen in the narration of epitomes. For thus has the form of the present passage established, that, as far as the history is concerned, both the rule of the Babylonians has been dissolved, and the captivity which the Jews suffered has been abolished, and the long-awaited freedom that was often promised has shone forth upon the troubled. Nevertheless, if you examine this freedom against the measuring rod of virtue, you will say indeed that an excessively small amount happened to mortals and to those who endured the bitter things of this life. But this liberation, which the mysteries of Christ have brought to the faithful, when it has finally come, is limitlessly longer, incomparably higher.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Here Julian makes clear that the historical sense of the passage is the liberation from the Babylonian exile. However, Christ has delivered us in a much fuller sense. The remainder of the interpretation is strongly allegorical. The term "), _c('i', [_vm._v("digression")]), _vm._v(" ("), _c('i', [_vm._v("excursus")]), _vm._v(") is understood by Baxter as a literary digression."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-112",
      "id": "ap_ntb-112-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" For Vaccari it is “something subjective in the poet’s mind, a digression of thought, a kind of transient "), _c('i', [_vm._v("ecstasis")]), _vm._v(" which is then reflected in the extrinsic expression.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-113",
      "id": "ap_ntb-113-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" Bouwman adds that in Julian’s time, digressions frequently mean "), _c('i', [_vm._v("ecstasis")]), _vm._v("; however, he thinks that "), _c('i', [_vm._v("excursus")]), _vm._v(" concerns more the grammatical sense, while "), _c('i', [_vm._v("ecstasis")]), _vm._v(" the prophetic-mystical one. They allow the prophet to rise for a moment on the historical plane to look at the distant future, then return to the contemporary situation without ever abandoning the object that he penetrates more deeply."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-114",
      "id": "ap_ntb-114-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-011"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Conclusion")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("De Plinval concludes his study of Julian’s "), _c('i', [_vm._v("Tractates on the Prophets")]), _vm._v(" by criticizing the secondary and derivative character of his work. He finds that Julian has rewritten Jerome’s commentaries in a spiritually mediocre and secularizing fashion. Julian allegedly stands far below the works of Jerome and Theodore as a second-tier personality."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-115",
      "id": "ap_ntb-115-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" This assessment strikes me as unfair when one considers the degree to which Jerome’s own works are indebted to his Greek predecessors, whether Origen or Didymus the Blind, his commentaries on Ephesians and Zechariah, respectively, being cases in point.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("De Plinval correctly recognizes that for exegetes like Origen, Ambrose, Augustine, and Jerome, virtually every verse in the Bible could be interpreted spiritually as applying "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLVIII",
      "title": "XLVIII"
    }
  }, [_vm._v("to Christ and the church, whereas Julian allowed for this kind of interpretation for only a few privileged passages, primarily those cited by New Testament authors. Yet De Plinval thinks this has resulted in an impoverishment of Julian’s exegesis and ultimately in a wrongheaded theology. While I acknowledge that these significant differences exist in the extent of the use of allegory, I do not detect a resulting impoverishment on the side of Julian’s exegesis. In any case, at the very end of his "), _c('i', [_vm._v("Commentary on Hosea")]), _vm._v(", Julian admits that greater depths of spiritual interpretation are possible for the material he has treated primarily historically. But is Julian’s reduction or elimination of allegorical digressions that attack heretics, for example, an impoverishment or an improvement of Christian exegesis of the Old Testament? I see little harm in what Julian has done and think the church has room for both approaches and others as well. In general, I agree with J. Lössl, who has found some of De Plinval’s assessments unjustified:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("De Plinval was certainly right in calling the "), _c('i', [_vm._v("Tractatus")]), _vm._v(" a “re-writing” of Jerome’s commentaries on Hosea, Joel and Amos. He could have called it by an equally fashionable expression a “relecteur” (re-reading). It was a “re-writing” influenced in spirit, if not letter, by Theodore’s commentaries on Hosea, Joel and Amos. But De Plinval was wrong to consider the "), _c('i', [_vm._v("Tractatus")]), _vm._v(" an inferior work for that. He might have come to a different conclusion, if he had compared the three authors in detail. Bouwman had compared the texts, but had failed to appreciate Julian’s originality as a writer and thinker. His verdict that Julian has merely “copied” Jerome is contradicted by his own findings concerning Julian’s language, style, compositional technique, exegetical method and theological content. For these are not only similar, but also dissimilar to Jerome’s and Theodore’s. Both, similarities and dissimilarities alike need to be studied in more detail."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-116",
      "id": "ap_ntb-116-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I hope the present translation will facilitate the study of these ancient Christian commentaries.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Conventions Used in This Translation")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("My translation is based on the Latin text found in L. De Coninck and M. J. D’Hont, eds., "), _c('i', [_vm._v("Iuliani Aeclanensis expositio libri Iob, tractatus prophetarum Osee, Iohel et Amos, accedunt operum deperditorum fragmenta post Albertum Bruckner denuo collecta aucta ordinate")]), _vm._v(", CCL 88 (Turnhout: Brepols, 1977). Since Julian adopted Jerome’s Vulgate version as his base Scripture text, I have tried to conform his lemmata (the cue headings that contain the Bible text to be commented on) for Hosea, Joel, and Amos as closely as possible to those of Jerome in the latter’s commentaries on these books (ACT, vol. 2). As the starting point for rendering Julian’s other Scripture citations, I have used the online Douay-Rheims English translation of the Vulgate ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.drbo.org/",
      "target": "_blank"
    }
  }, [_vm._v("www.drbo.org/")]), _vm._v("), always updating the archaic English. For his references to the “Greek,” I have used the online Septuagint in Brenton’s version ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.ellopos.net/elpenor/greek-texts/septuagint/default.asp",
      "target": "_blank"
    }
  }, [_vm._v("www.ellopos.net/elpenor/greek-texts/septuagint/default.asp")]), _vm._v("). Although Brenton’s English rendering is of the LXX in Codex Vaticanus, whereas Julian’s Greek text corresponds most closely with Codex Alexandrinus, in the vast majority of cases the two texts agree. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XLIX",
      "title": "XLIX"
    }
  }, [_vm._v("In the commentaries, echoes of the lemma are indicated with italics. The critical edition does not contain an abundance of Scripture references and allusions. I have supplied as many as I could (using the Revised Standard Version Catholic Edition), often conjecturing as to which passages Julian may have had in mind. For the Scripture citations in the footnotes I have used English locations according to the RSV. These are not always identical to the LXX and Vulgate locations.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I wish to acknowledge the collaboration of the following students from Ave Maria University: C. M. C. Wood, Elise Larres, Rachel Corcho, and Andrew Kuenstle. In addition to these diligent students, the patristic scholars Stuart Squires and Giulio Malavasi, as well as the editors of InterVarsity Press’s Ancient Christian Texts series, gave me valuable feedback on the introduction.")])])])])])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("EXPOSITION OF THE BOOK OF JOB")])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-013"
    }
  }, [_c('h2', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Preface]")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The apostle testifies, “All things whatsoever that have been "), _c('i', [_vm._v("written")]), _vm._v(" were written for our instruction.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-117",
      "id": "ap_ntb-117-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" If this is true, how much more have those things that are reported as the "), _c('i', [_vm._v("deeds")]), _vm._v(" of holy people been handed down in tradition for us to imitate, to keep them from perishing due to the silence of the pen. They have been provided in advance for authoritative instruction. And so the life of saint Job is praised because in him the goodness of human nature can be recognized."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-118",
      "id": "ap_ntb-118-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Even without the teaching authority of written law, he shows that human nature was sufficient unto itself both to reject sins and pursue all virtues."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-119",
      "id": "ap_ntb-119-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" For it was indeed created that way by God. But Job is praised not because it advances his merits that such a man becomes known to all. For even if he had not been praised, in the sight of God he would not have lost anything in the estimation of his honor. But the reason was so that in him those who come after may realize that virtue is attainable for those who are willing to approach it. Due to his intimacy with virtue, the holy man was not distracted ("), _c('i', [_vm._v("deductus")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-120",
      "id": "ap_ntb-120-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(") either by his losses or by his bereavements. Secondly, it is pointed out how great God’s goodness is toward us. Whatever good things we do are so pleasing to him that he seems to point out our goodness, as it were, and brag about it, almost as if he were boasting."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-121",
      "id": "ap_ntb-121-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" We learn the following also from this book, that every saint of God often experiences temptations and tribulations. This is not due to his having offended [God], but in order to test the person’s devotion and to increase his merit."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-122",
      "id": "ap_ntb-122-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("It is asked, of course, whether we believe holy Job lived before the law [of Moses] or after the law."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-123",
      "id": "ap_ntb-123-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" But it seems more likely that he came before the time of the law, because that fits both with reverence for the lawgiver and with the justice of the man himself. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("Otherwise, this one who had pleased God"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-124",
      "id": "ap_ntb-124-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" would be believed to have shown contempt for the law of him whose authoritative instruction in any case he did not think it fitting to approach, being, as it were, sufficient in himself.")])]), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("One should know, moreover, that saint Job’s whole speech against his friends is divided into three parts."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-125",
      "id": "ap_ntb-125-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" For immediately in the beginning, when they blamed him for complaining excessively, he shows that even if he were roused to all bitterness by those things that had befallen him, this should not be attributed to him as a fault. And in order to convict them, he adds to this in various ways by relating his sufferings; and then he makes a transition. And, what is more, he shows that they are friends only in outward appearance, but in reality they are enemies. For though they came to console him, they heap up causes for grief by scoffing at his sufferings. For high and low they try to pin the blame of sin on him for his hardships. Finally, he shows that it is in vain that they want to prove him to be responsible for his misfortunes, since it is an established fact that many persons of a defiled life are not without prosperity in the present. However, when his friends are reduced to silence, since they were unable to refute the things that he said, as a greater apology for himself, he recounts as well those things that he had done justly and piously."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-126",
      "id": "ap_ntb-126-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" After this, Elihu undertakes a discussion of the providence of God, and he uses many arguments to prove it."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-127",
      "id": "ap_ntb-127-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" This speech is clearly helpful, and its theme corresponds to his purpose. For even God enters into the conversation and mixes it up in words of disputation with saint Job."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-128",
      "id": "ap_ntb-128-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" He, so to speak, adjudicates everything that had been said above and discourses on the providence of affairs. He cites as evidence those things that were done at the beginning of the world: that is, the visible creation, four-footed creatures, flying creatures, and the things native to the earth and things that take delight in the waters."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-129",
      "id": "ap_ntb-129-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Whoever stands out as a diligent reader [of this book] will be able to find these things in the reading itself.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 1]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-001"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:1 In the land of Uz ("), _c('i', [_vm._v("Hus")]), _vm._v(") there was a man by the name of Job.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("There is a simple narration of events, and it seems far removed from showing favoritism to persons. For his parents and ancestors are not praised, as is customary for eulogists, but the one whose good blessings are to be set forth is placed in the center of the discourse. "), _c('i', [_vm._v("In the land of Uz (Hus)")]), _vm._v(". People think that this refers to the land of King Sihon near the Promised Land, which was captured by saint Moses."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-130",
      "id": "ap_ntb-130-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" [The Septuagint] said, “In the land of Ausis.” “And he was simple and upright and fearing God.” The method of the narration is maintained, so that, since he had told who he was [and] where he was from, he added what kind of man he was. "), _c('i', [_vm._v("He was simple")]), _vm._v(", in that he was separated from any mingling with vices. He added "), _c('i', [_vm._v("upright")]), _vm._v(", lest his simplicity be believed to be in him not from his pursuit of virtue but from the kind of nature he had."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-131",
      "id": "ap_ntb-131-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" This is why "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("he clarified the two preceding words with the addition of a third, "), _c('i', [_vm._v("and fearing God")]), _vm._v(". The reason, then, that he was "), _c('i', [_vm._v("simple and upright")]), _vm._v(" was because he "), _c('i', [_vm._v("feared God")]), _vm._v(". “And avoiding evil.” He shows briefly what precisely it means to fear God—namely, to avoid being incited by any evil.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-002"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:2-3 And there were born to him seven sons and three daughters. And his possession was seven thousand sheep, three thousand camels, five hundred yoke of oxen, five hundred she asses, and a family exceeding great. ")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The fruitfulness of children and the extent of his wealth is shown in order to proclaim more fully the greatness of his soul, which patiently endured bereavement and losses. “And this man was great among all the people of the east.” He had everything that human beings believe make them happy: the adornment of good character, the comfort of affection, extensive property, and no scanty amount of inheritance.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-003"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:4 And his sons went and made a feast in their houses, everyone in his day. And they sent for and invited their three sisters to eat and drink with them.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This has in view the good of the father’s instruction. For his children live among themselves in such great harmony that at no time are they separated from a single banqueting table.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-004"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:5 Job sent to them and sanctified them.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Sanctified")]), _vm._v(", that is, he would cleanse them with water, just as it is commanded in Exodus, that the people should "), _c('i', [_vm._v("sanctify")]), _vm._v(" themselves."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-132",
      "id": "ap_ntb-132-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" And she is called Bathsheba ("), _c('i', [_vm._v("Bersabee")]), _vm._v(") because she "), _c('i', [_vm._v("sanctified")]), _vm._v(" herself after her adultery."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-133",
      "id": "ap_ntb-133-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" “And rising up early he offered holocausts for every one of them: Lest perhaps my sons have sinned.” A serious reproach is not precluded here, that he seems to be overlooking the sins of his children without correction, which certainly does not fit his being a just man. But, since there was nothing for him to reprimand, being solicitous and very devout, he does not neglect to pray for them and make amends for what could have happened. “Lest perhaps my sons have sinned, and have blessed"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-134",
      "id": "ap_ntb-134-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" God in their hearts.” In the Greek it does not say, "), _c('i', [_vm._v("Lest perhaps my sons have sinned, and have blessed God in their hearts")]), _vm._v(", but rather, “He offered holocausts for each of them and one calf for sin for their souls.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-135",
      "id": "ap_ntb-135-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-005"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:6 Now on a certain day when the sons of God came to stand before the Lord, Satan also was present among them.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Angels are called "), _c('i', [_vm._v("sons of God")]), _vm._v(" as a sign of their immortality. In order for there to be a fitting "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("occasion for the devil to request permission for himself to tempt Job, the angels are well said to "), _c('i', [_vm._v("stand before")]), _vm._v(" God, being observers of various human beings and actions. Thus, the devil seems to have been incited by the praiseworthy acts of Job. It makes no difference, then, whether we say that God truly appeared to the angels in the form that he desired, not in the truth of his nature, so that an occasion would be offered for the devil to attack Job; or the malignant power became visible; or whether we believe that he has rendered into words what was in the will and zealous desire of the devil and in the knowledge of God. For it is customary in Holy Scripture to record things that are "), _c('i', [_vm._v("said")]), _vm._v(" as things that have been "), _c('i', [_vm._v("done")]), _vm._v(", and conversely, to narrate those things that dwell only in our perceptions and thought in such a way as if they are carried out in reality and in works, so that invisible realities may more easily become known through visible actions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-136",
      "id": "ap_ntb-136-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-006"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:7 And the Lord said to him, Where do you come from? And he answered and said: I have gone round about the earth, and walked through it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By his answer, the devil wanted the following to be understood, that he had circuited the earth and had found no one who was not obedient to his rule. For that reason, the Lord presents Job to the one who was boasting, as it were—Job who was estranged completely from the devil’s interests and will.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-007"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:8 Have you noticed my servant Job, that there is no one on earth like him, a simple and upright man?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The testimony that was recorded at the beginning of the book is granted by God to Job."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-137",
      "id": "ap_ntb-137-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" This proves that this book was composed by the Holy Spirit.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-008"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:9-10 Satan answered and said to him, Is it for nothing that Job fears God? Have you not made a fence for him, and his house, and all his substance round about?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The favorable moment for the accusation arises from his material prosperity, when he says that Job fears God not from a religious frame of mind but due to the pile of his goods.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-009"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:11 But stretch forth your hand a little, and touch all that he possesses, and see if he does not bless"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-138",
      "id": "ap_ntb-138-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" you to your face.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("You will find the proof of his devotion when his prosperity has been taken away and adversities have been introduced.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-010"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:12 Behold, all that he has is in your hand.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The devil had said to God, “Stretch forth your hand, and touch all that he possesses.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-139",
      "id": "ap_ntb-139-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Lest the favorable moment for the accusation should be left to God, and the devil should say that the Lord had dealt too gently with his servant, power is given to the devil to vent his anger on Job. Thus, to the extent that he is the fiercer attacker, so much the more does the virtue appear of him who is to be attacked.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-011"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:13-15 Now on a certain day when his sons and daughters were eating and drinking "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("wine in the house of their firstborn brother, there came a messenger to Job, who said, The oxen were ploughing, and the asses feeding beside them, and the Sabeans rushed in, and took all away, and struck down the servants, and I alone have escaped to tell you.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("In the house of their firstborn brother")]), _vm._v(": the devil chooses the day of temptation so that he may then assail holy Job with a variety of losses and sorrows. It is while the feasts of his children were being carried out on the earth, while sacrifices were being offered. Job at that time would have been secure regarding God’s propitiousness. Not without reason on that day on which the report came concerning the stolen bulls and asses, mention is made also of his children’s feasting. But this shows that all the bitter things by which the spirit of the just man was to be struck happened simultaneously.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-012"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:16 And while he was yet speaking, another came and said, The fire of God fell from heaven, and it struck the sheep and consumed the servants.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Now it should not seem surprising that the devil is said to have brought down "), _c('i', [_vm._v("fire from heaven")]), _vm._v(", since it is possible even for humans to discover the nature of fire, either by rubbing sticks together, or with the insertion of water, or sometimes by means of glass vessels."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-140",
      "id": "ap_ntb-140-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('i', [_vm._v("The fire of God fell from heaven")]), _vm._v(". The reason the devil brings fire down from heaven is to throw Job’s mind into a state of greater confusion, so that he may not suppose that he is suffering evils by chance, but surmise that they are coming from God himself, whom he used to serve very devoutly.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-013"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:17 And while he was yet speaking, another came and said, The Chaldeans formed three companies, and fell upon the camels and took them; moreover they have struck down the servants.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “Horsemen formed three companies.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-141",
      "id": "ap_ntb-141-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" In all this, the messengers are announcing two evils: the stealing of the livestock and the killing of the shepherds. Thus, if the losses do not shake him up, at least feelings of compassion over the death of human beings may move him.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-014"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:18-19 He was speaking, and behold, another came in and said, Your sons and daughters were feasting in the house of their firstborn brother. A violent wind came and shook the four corners of the house, and it fell upon your children ("), _c('i', [_vm._v("liberos")]), _vm._v(") and they are dead.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The spirit of saint Job is tested by the devil’s great artifice. Thus, having started with the lighter temptations, he brought it about that the one that was more serious was the last to be reported. Thus, if he bore the loss of his inheritance patiently, and did not deem it worthy to shed tears over it, he would be shaken from the loss of his own children ("), _c('i', [_vm._v("pignorum")]), _vm._v("). And, if he was insufficiently pious to refrain from groans, if he showed himself too lacking in moderation, he would be convicted of having forgotten God.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-015"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:20 Then Job arose and tore his tunic.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("From this it is evident that all these things came to pass within a single day. For no sad news altered the joy of the children feasting together. Surely they would not have devoted themselves to feasting amid all the great losses of their father. "), _c('i', [_vm._v("He tore his tunic")]), _vm._v(", since he was about to reveal feelings of grief over the loss of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("his children. Thus, what he was silent about in respect to the loss of his inheritance is shown to have come not from having his spirit stunned but from virtue. “He worshiped and said.” "), _c('i', [_vm._v("He worshiped")]), _vm._v("; that is, he did not let go of his reverence for God, even when set amid so many adversities.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-016"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:21 Naked I came forth from my mother’s womb, naked shall I return thither.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The man’s great steadfastness is being shown. His many lost properties do not bother him, and the death of his children does not compel him to say anything unbecoming against God, as is customary for those who are grieving. Instead, he merely puts on the attire of one who is mourning. “The Lord gave, the Lord has taken away.” In these words in particular is the virtue of saint Job recognized. For although he was uncertain of [the identity of] his enemy, and he thought that the evils were being carried out against himself by the God whom he worshiped, he did not draw back from his pious pursuit of God. “Blessed be the name of the Lord.” I follow the decision of my Lord in all things. I do not refuse riches, when he "), _c('i', [_vm._v("gives")]), _vm._v(", nor do I become exasperated over the injustice of poverty, when he "), _c('i', [_vm._v("takes away")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-017"
    }
  }, [_c('h3', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("1:22 In all this Job did not sin by his lips, nor did he say any foolish thing against God.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Here is shown both the man’s prudence and his perfect circumspection concerning sin. For he abstains not only from those words by which God could have taken offense but also from those that in grief are normally attributed not to one’s reason but to sorrow.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-014"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 2]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-018"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("2:1 And it came to pass.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When the just man had given clear proof of his virtue in the midst of the initial commencement of the struggle, the angels were in awe, but the devil, who was vexed by the man’s resolution and steadfastness, attempts to challenge him to combat in some other way.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-019"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("2:1-3 And it came to pass, when on a certain day the sons of God came to stand before the Lord, Satan also stood among them, so that the Lord said, Where do you come from? He said, I have gone round about the earth. And the Lord said, Have you considered my servant Job, for there is none like him on earth? And does he still keep his innocence? But you have incited me to afflict him without cause.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is asked whether this took place in this way, as it says in the simple narration of the words. Or, as is customary in the Scriptures, is what the devil wished for and what God allowed being conveyed in the form of deeds that were carried out, so that it may stick more tenaciously in the memory of future generations?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-142",
      "id": "ap_ntb-142-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" For things "), _c('i', [_vm._v("done")]), _vm._v(" transmit a stronger remembrance of it than things "), _c('i', [_vm._v("said")]), _vm._v(". In fact, neither reason nor the faith allows that angels "), _c('i', [_vm._v("stand before")]), _vm._v(" God in the manner of attendants. For God is invisible and his nature is boundless, as is frequently asserted in testimonies from the Old and New Scripture."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-143",
      "id": "ap_ntb-143-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" And if the holy angels are not able to be present locally with God, how much more the devil? What, therefore, does this mean when it says that "), _c('i', [_vm._v("the angels stood before God, and Satan with them")]), _vm._v("? That just as the holy angels were rejoicing over Job’s manner of life, for there is equal joy with them and God over the salvation of human beings,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-144",
      "id": "ap_ntb-144-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" so the devil was vexed by his virtues, and he eagerly endeavored to shake him out of a tranquil state of mind by harming him by means of new misfortunes. And since he thought that the reason Job was devoted to God "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("was because he was rich in property and a father blessed with a throng of children, he meditated in his will that, if it were permissible to rob him of the goods in which that one rejoiced, he could then be exposed as one who was not truly religious. And so God, knowing both the wishes of the devil and the steadfastness of his servant, allows him to be robbed of possessions, deprived of children, filled with sores, in order to prove that Job had been devoted to God out of his zeal for virtue, not prosperity. Therefore, these things that were present in the will of the devil and permitted by God are spoken of as things that were done, so that the appearance of a contest that was hidden could meet the eyes, after the things in the future unfolded. "), _c('i', [_vm._v("Keep his innocence")]), _vm._v(": which the severity of misfortunes and the weight of grief customarily shakes. "), _c('i', [_vm._v("That I should afflict him without cause")]), _vm._v(": it should be noted that God says that what he allows to happen by some kind of dispensation is his own doing."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-145",
      "id": "ap_ntb-145-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('i', [_vm._v("Without cause")]), _vm._v(": so that I, as if ignorant, may make Job’s justice, which was known to me, come into scrutiny.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-020"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("2:4 Satan answered and said to him, Skin for skin, and a man will give everything for his life ("), _c('i', [_vm._v("anima")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The devil saw that he had not overthrown the steadfastness of the saintly man by the onslaught of the first temptation. Therefore, he came once again before the face of God and alleged that those things by which Job had been tempted were, so to speak, not great things. He says that Job should be tested not by things placed outside of him but by things that strike his very self. For he adds that Job, following the custom of the rest of men, had endured the loss of his things as a pretense, lest he should endanger his salvation"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-146",
      "id": "ap_ntb-146-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" by speaking insultingly of God. For it is common to human beings to ward off greater costs by smaller losses, and often by extending the hand in opposition, to ward off danger to the safety"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-147",
      "id": "ap_ntb-147-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" of one’s head.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-021"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("2:6 Therefore the Lord said, Behold, he is in your hand.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Behold he is in your hand.")]), _vm._v(" The devil’s allegation seems worth putting to the test, and the Lord does not refuse to do this. For if the request had been unjust, it never would have been allowed by the just One who has knowledge. Therefore, the test proposed by the devil comes from God. But just as that one who tries to attack by means of these things is convicted of being evil, so is he patient who knows that his servant is made and rendered more illustrious by means of these things. “But spare his life.” Because the devil’s whole contest was to oppose Job, the state of the holy man’s person needed to be kept intact, so that, just as he had resisted with his whole man in the first encounter, he could approach the second combat even with part of himself intact. For if the mind’s ("), _c('i', [_vm._v("animae")]), _vm._v(") reasoning capacity or the health of his life had been extinguished by the incursion of some disturbance or frenzy, all the terms of the contest would have been dissolved."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-148",
      "id": "ap_ntb-148-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-022"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("2:7 Satan went forth from the presence of the Lord and struck Job with a very grievous boil.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Some say that it was elephantiasis."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-149",
      "id": "ap_ntb-149-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-023"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("2:8 Sitting on a dunghill.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the Greek it says, “He sat on a dunghill outside the city,” and among the Greeks there is much more at this point."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-150",
      "id": "ap_ntb-150-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-024"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("2:9 But his wife said to him, Do you still continue in simplicity? Bless"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-151",
      "id": "ap_ntb-151-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" God and die.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By his wife’s words it is shown that Job continually gave thanks to God, while his limbs were being wrenched apart, and, what is more, amid all this extreme pain he said that he was being kept alive by mercy. This is why his wife says to him as if it followed logically, If he bestows life on you at the special pleading of your prayers, it is better for him to take it away, when he becomes angry at the sound of your complaint.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-025"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("2:10 He said to her, You have spoken like one of the foolish women. If we receive good things from the hand of the Lord, why should we not receive evils?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is calling wealth and poverty "), _c('i', [_vm._v("goods")]), _vm._v(" and "), _c('i', [_vm._v("evils")]), _vm._v(". The reason poverty must be borne very patiently is because it has many companions and comrades in it, though on the other hand one who has wealth is nearly alone. "), _c('i', [_vm._v("You have spoken like one of the foolish women")]), _vm._v(". The rebuke of the mind is not broken by a disability of the body; for he checked the harmful suggestion of his wife with a raised voice, not a soft one, and with a stern countenance. He says, "), _c('i', [_vm._v("You have spoken like one of the foolish women")]), _vm._v(": that is, you surpass them all in foolishness, you do not know what things pertain to the devotion of servants, [that we are] to embrace, not argue about, the will of the Lord, and to receive with a grateful heart both those things that seem bitter and those that are favorable.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-026"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("2:11 Therefore, when three of Job’s friends heard all the evil that had come to him, each one of them came from his own place, Eliphaz the Temanite, Bildad the Shuhite, and Sophar the Naamathite, to visit him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since the calamity of so great a man had been broadcast so far away, it makes sense in the context that many came together from different countries, either to have a look at this new development or to console him in his miseries. But only these three are named, whom either greater inquisitiveness had aroused or who were superior to the rest in honor. "), _c('i', [_vm._v("Eliphaz the Themanite")]), _vm._v(": In Greek it says, “Eliphaz the king of the Themans.” Now Theman is a city of the Idumeans, as the prophet Amos testifies when he says, “I will send a fire into Theman.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-152",
      "id": "ap_ntb-152-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('i', [_vm._v("And Bildad the Shuhite")]), _vm._v(": In Greek it says, “Bildad the sovereign ("), _c('i', [_vm._v("tyrannos")]), _vm._v(") of the Aucheans ("), _c('i', [_vm._v("Aucheon")]), _vm._v("),” which they say is a city of the Moabites. "), _c('i', [_vm._v("Sophar the Naamathite")]), _vm._v(": [In Greek it says,] “Sophar king of the Minaeans,” that is, of the Ammonites. "), _c('i', [_vm._v("To visit him")]), _vm._v("—that is, to alleviate the condition of his suffering by sharing his sorrow. What is shown to be understood from this is that for many days they sat by his side in silence.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-027"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("2:12 And when at a distance they had lifted up their eyes, they did not recognize him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The honor of his body was turned to horror,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-153",
      "id": "ap_ntb-153-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" so that the recognition of him by his familiar friends was eclipsed, though not completely "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("taken away. “And they wept aloud, and tearing their garments they sprinkled dust on their heads towards heaven.” In Greek it says, “And sprinkling earth on their heads they looked up towards heaven.” The dust is thrown up toward heaven not as an affront to the worship of the divine but to lay bare the feeling of compassion by making one’s head filthy by such a sprinkling.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-028"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("2:13 And they sat with him on the ground seven days and seven nights, and no one spoke to him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Their feelings of compassion had not given his friends opportunity to mingle in speech. Therefore, Job is the first to break out into words that give a clear indication of his great sorrow. They are not words that formulated a philosophic tenet. And amid his torments and reverence for the Creator, between these two indeed he does not dare to attribute his sufferings to anyone, yet he wishes that he had not been born."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-154",
      "id": "ap_ntb-154-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" And he detests the very commencement of his existence and utters curses against that time that lacked sensation and substantial existence. This is something that is customary for people who are filled with offense or bitterness. "), _c('i', [_vm._v("No one spoke")]), _vm._v(". Why are they silent, these men who had come together for the very purpose of alleviating by their speech the harshness of the evil that had occurred? Doubtless it is because the evils that they were beholding had exceeded the measure of their expectations.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-015"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 3]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-029"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:1-3 After this Job opened his mouth, and cursed his day, and he said, Let the day perish on which I was born, and the night in which it was said, A man [child] is conceived.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He shatters the obstinate silence, when some had departed, but these men remained, who had come in friendship and who had been emotionally affected by sharing in his sorrow and pain. He sees that temporal delay was becoming burdensome, because the silence was dragging on. He utters words not to reproach God but to express the misery of his condition."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-155",
      "id": "ap_ntb-155-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" He says that it would be better not to exist ("), _c('i', [_vm._v("esse")]), _vm._v(") at all than to exist like this. "), _c('i', [_vm._v("Let the day perish on which I was born")]), _vm._v(". So great was the onset of pain from the disease, which had spread through the body of holy Job, that no opportunity could be found for a speech that asks particular questions.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-030"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:4-6 Let that day be turned into darkness, let a darksome whirlwind seize on that night.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("With diverse imprecations he reproaches the time of day and night, and he heaps these things up into a pile of cursing. He mentions things that are accustomed to ruin the pleasure of rest and light. But in all this it is not reason or logic that is being expressed, but solely the bitterness of one who is suffering severely.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-031"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:7 May that night be solitary.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("May that night be solitary")]), _vm._v(", which due to its bitterness and horror cannot come into communion with the remaining [nights] that tranquility commends.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-032"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:8 Let them curse it who curse the day, who are ready to rouse the Leviathan.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("May this night and the day of detestation attack, for the terror and devastation of the dragon that is brought up from the deep onto the land deserves it. For the tradition of the Hebrews and Syrians understands the Leviathan to be that thing of which David says, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("“This is the dragon which you formed to play therein.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-156",
      "id": "ap_ntb-156-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Although it seems to hold forth the figure of spiritual wickedness, yet when he emerges and is cast onto the land, he is shown to be one who will cause such great slaughter of men and livestock that everyone’s curses would rightly be heaped up against it. In Greek [it says], “But let him who will curse that day curse it, [even] he that will capture the great whale.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-157",
      "id": "ap_ntb-157-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Just as the one who imprecates the day has referred this to God, in order that the outcome of his prayer may be fulfilled, and says, “Let not God above call for it,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-158",
      "id": "ap_ntb-158-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" so also he begs that God fulfill the accumulated curses against the night. “Let him curse it,” therefore; that is, may he cause the prayers of my cursing to be fulfilled. For with him alone is it possible to wrest the times of day and night from their order and course, to whose power it belongs also to kill that “whale,” whose strength is invincible.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-033"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:13 For now I should have been asleep and still.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If I had nothing to do with this life, which is full of work and distress, long periods of leisure would welcome me. There would have been no distinction between the condition of those who, after the cares of the world and the names of honor, pass into the place in which there is no distinguishing of conditions, ranks, or offices. “And I would have rested in my sleep.” That is, I would be free and safe from the evils I suffer.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-034"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:14 With kings and consuls of the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “With kings and councilors.” He has called them "), _c('i', [_vm._v("consuls")]), _vm._v(", therefore, not based on their office but their duty. “Who built solitudes for themselves.” Their riches are spent on superfluous uses, while from numerous buildings they strive to make solitary places into frequented places. They establish some of these buildings in order to perpetuate the memory of their own name. In passing he has touched on the vanity of mortal pursuits of those for whom speedily approaching death puts an end to their great endeavors.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-035"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:15 Or with princes who possess gold.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He shows the just reasons for his request. For if those also, who lived in honor and pleasure, return no profit from their past life when they are overtaken by death, how would it not have been advantageous to me, who am beset with bitter hardship, not to have come to the very commencement of life?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-036"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:16 Or as a hidden untimely birth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has recorded "), _c('i', [_vm._v("hidden ")]), _vm._v("for “unformed,” whose completion, because it is not present to our sight, is rightly called "), _c('i', [_vm._v("hidden")]), _vm._v(" and remote.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-037"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:17 There the wicked have ceased from tumult.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Though the state of the one who is suffering is one thing, that of the one inflicting the injury something else, yet one end will remove both, so that both the former rests from his pain and the latter from his deeds.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-038"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:18 They have not heard the voice of the taskmaster.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("After death, he says, there is no difference between king and private person, between the one who drives another on and that one who is driven, but one condition renders all equals.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-039"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:20 Why is light given to him that is in misery, and life to them that are in bitterness?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("He who is enveloped by the darkness of grief does not feel the pleasure of this "), _c('i', [_vm._v("light")]), _vm._v(". He for whom it is necessary constantly to groan and grieve lacks the gift of "), _c('i', [_vm._v("life")]), _vm._v(".")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-040"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:23 To the man whose life"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-159",
      "id": "ap_ntb-159-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" is hidden, and God has surrounded him with darkness"), _c('i', [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He does not seem to partake of "), _c('i', [_vm._v("life")]), _vm._v(", and somehow lives without it, who is estranged from the sensation of pleasure, sensation that various causes produce.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-041"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("3:25-26 For the fear that I feared has come on me, and that which I was afraid of has happened.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("For the fear that I feared")]), _vm._v(": those things that I am suffering did not befall me, as it were, without premeditation; for when I saw in others both the evils of poverty and the various disabilities of the body, our common bodily nature admonished me to be afraid that such a thing might also fall to my lot. And this is also why I am compelled to dread an increase of the evils that I am enduring. This expectation makes death seem better than life. Now as for what he added, “Was I not quiet?” the Greek has “I was not quiet.” That is, I have not continued in the enjoyment and prosperity of my possessions. He is saying that he "), _c('i', [_vm._v("feared")]), _vm._v(" that the evil of this crisis might strike, with the result that he would utter a voice of complaint contrary to the resolution of his seriousness, if he should suffer any torment. And therefore he says, "), _c('i', [_vm._v("Was I not quiet?")]), _vm._v(" That is, when the sharpness of the pain had struck me, I wanted silently to hide what I was suffering; but so great was the violence of the evil raging in me that I am compelled to reveal my torments with a voice of lamentation.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-016"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 4]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-042"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:1 Then Eliphaz the Themanite answered, and said.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Amid the justice of God’s judgments and the bitterness of the wound and the pain, his friends grew weary of his countless questions and his perplexity. They arrange the commencement of their address in such a way that they could agree both on the things proclaimed simply for consolation and on the things considered more deeply as a rebuke. And, as is usually done in uncertain cases, they prefer to impute what he is suffering not to the unjust judgments of God, as it were, but to Job’s deserts. Now to be sure, they commence the discussion with a milder speech, but as it progresses, it becomes clear that they are unleashing their own very harsh verdict.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-043"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:2 If we begin to speak to you, perhaps you will take it ill.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Here "), _c('i', [_vm._v("speak")]), _vm._v(" does not simply mean to engage in conversation but to oppose your statements and thoughts. The Greek has, “Have you often spoken in distress?” After Job cursed the time and moment of his birth, as a way of consoling himself in his hardships, Eliphaz does not bear to turn a deaf ear to his complaints, [treating them] as if they had been intended to offend God. Instead, he girds himself with zeal to defend the divine, and he thinks that he can convict saint Job concerning the harshness of his present words—namely, that he is suffering these things because of previous sins.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-044"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:3 Behold, you have taught many, and you have strengthened the weary hands.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Behold you have taught many")]), _vm._v(": the present facts are at odds with your former view. For you are the one who often illumined others who had fallen into sorrow, and you gave the aid of your "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("hand to the lowly, that they might rise up. How is it that you yourself do not hold to the firm tracks with constancy and are not strong enough to raise yourself from ruin? Those things that you frequently taught others ought to have sufficed to console you. These things are being said either in the usual manner of consolation, based on the pursuit of a higher life, or else with irony."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-160",
      "id": "ap_ntb-160-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" It is not that Job had done these things, but thusly had Job previously thought concerning himself.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-045"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:5 But now the scourge [has come] on you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By these words he wants to show that before the experience of these things, Job had a certain virtuous opinion of himself, virtue that is indeed proven not to have existed, since the case makes this certain.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-046"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:6 Your fear, your fortitude, and the perfection of your ways.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Those things in which you were boasting are also exposed as not having previously existed in you, when you could give them up so quickly, that amid your complaints of lamentation no vestige and sign of them remained in you. You had said that you were silent, quiet, and still at the onslaught of torments and sufferings."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-161",
      "id": "ap_ntb-161-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Why then are you bursting forth in words that indicate a weak mind?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-047"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:7 Remember, I pray you, who has ever perished being innocent?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("With an argument that is general in nature, he even attempts to drag him into agreement with his words, since the justice of the divine examination does not permit that he show his vengeance against those who have done nothing worthy of censure. Thus, it circles back on those who have been pernicious in whom it could lay claim to vengeance.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-048"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:8-9 On the contrary, I have seen those who work iniquity perishing by the blast of God.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is considering the proper duty of justice: just as it inflicts no evil on the innocent, so it does not allow the crimes of the guilty to go unpunished. "), _c('i', [_vm._v("Perishing by the blast of God")]), _vm._v(", “and consumed by the spirit of his wrath.” God requires no work, no effort to punish sinners, but he pursues the apportioning of his rebuke by his command alone.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-049"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:10 The roaring of the lion and the voice of the lioness and the teeth of the whelps of lions are broken.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the names he has invoked, he wanted to indicate that riches by their own power cannot protect any human being against the judgment of God, not one. By the names "), _c('i', [_vm._v("lion")]), _vm._v(", "), _c('i', [_vm._v("lioness")]), _vm._v(", and "), _c('i', [_vm._v("whelp of lions")]), _vm._v(" is shown the ferocity of powerful men and of their despoilments, which they carry out on their subjects, the savage fury against those on whom the severity of divine punishment is deservedly thrust. However, the speech subtly looks back to Job, so that he may recognize by the testimony of the correction received that he was one such person.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-050"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:11 The tiger has perished for want of prey.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “The ant-lion.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-162",
      "id": "ap_ntb-162-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-051"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:12 Further, a concealed word was spoken to me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To provoke him all the more by his authoritative words, he says that while he was, so to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("speak, submerged in deep thought, he has discovered these things that he is about to declare, and thus they are definitive and carefully weighed. Thus, he appears to have perceived these things with the magisterial authority of a revelation, and they have not been composed so much by the reflection of his own thought as by the voice of someone else who is issuing a warning. In Greek it says, “But if there had been any truth in your words, surely none of these evils would have befallen you.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-163",
      "id": "ap_ntb-163-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('i', [_vm._v("Concealed")]), _vm._v(" refers to one who denies rather than to the one who affirms.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-052"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:13-16 In the horror of a vision by night, fear seized upon me; there stood one whose countenance I knew not.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("At night time, when our senses are free from meeting corporeal things, we are accustomed to occupy ourselves entirely with thoughts and to examine every doubtful and uncertain thing with a deeper reflection of the mind. That is when a thought appears that occurs as more agreeable to the mind of the one who is deliberating. It bears the form and outward appearance of things, and we believe and it seems to be standing there. In order to express this, therefore, Eliphaz claims that he saw an image and heard a voice speaking. "), _c('i', [_vm._v("There stood one whose countenance I knew not")]), _vm._v(", “an image before my eyes, and I heard the voice, as it were, of a gentle wind.” In order to accuse saint Job of temerity in his words, he begins to discuss the dignity and nature of God. He says that no human being, however much he focuses his mind, is able to arrive at a perfect knowledge of him. And he tries to express under his own persona that which is proper to the nature of mortals—namely, what he experiences when he wants to think more deeply about God, what men who are overwhelmed by a deep sleep are accustomed to experience in the middle of the night, when various forms of things trick the senses and phantoms of diverse images without shape are discerned, or when the blowing of a light breeze is felt and nothing happens that can be seen by the eyes. In this way, therefore, also the human mind itself, as it thinks about God, is exhausted by the greatness and majesty of things, so that it understands that it has accomplished nothing.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-053"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:17 Shall man be justified in comparison with God?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The things that were said earlier were of general application, although Job could prove that they nevertheless are not fittingly said with respect to his own character. Therefore, Eliphaz adds something else that seems to properly touch Job, so that he would not be able to complain further about the things that he suffers. For if no one’s life is completed in such a way that he can be allowed to be compared with divine perfection, then no one ought to boast over the small measure of his justice. And if he cannot boast, because he is far inferior, he should not complain that what he is suffering is shown to be unjust, through the fact that he does not fall short of perfection in any way. "), _c('i', [_vm._v("Shall he be justified in comparison with God?")]), _vm._v(" His whole aim has this in mind, that no one can say that he is enduring [anything] undeservedly who understands that he falls well short of that measure that corresponds with the Deity alone.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-054"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:18 Behold, those who serve him are not stable.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He wants to show that it is impossible for human nature to live in such a way that it incurs no offense. For if those who were dedicated to virtue with great zeal, whom he calls his servants, were not able to escape blameworthy lapses, such as Moses, who so "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("offended [God] that he was denied entrance into the Promised Land,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-164",
      "id": "ap_ntb-164-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" what should we believe of those whose more remiss life pays regard to the basics of his body? “And in his angels he found wickedness.” He has said "), _c('i', [_vm._v("angels")]), _vm._v(" for priests, according to the following: “The lips of the priest shall keep the law, and they seek truth, because he is the angel of the Lord.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-165",
      "id": "ap_ntb-165-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-055"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:19 How much more those who dwell in houses of clay?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The state of weakness and the awareness of guilt takes away the liberty to complain; nor is he able to show that he is enduring the things he suffers undeservedly, who is not able to lay claim to the perfection of his virtues.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-056"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:20 And because no one understands, he will perish forever.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("No one understands")]), _vm._v(" that he should not place his hope in the merit of his own virtues, but in the mercy of God. And the reason he is far removed from pardon is because he does not approach to make amends.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-057"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("4:21 They will die, and not in wisdom.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The reason "), _c('i', [_vm._v("they will die")]), _vm._v(" is because the wisdom that taught them about the forgiveness of God was not present in them, that they should not have been secure concerning their own justice.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-017"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 5]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-058"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:1 Call, therefore, if there be any that will answer you, and turn to one of the saints.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Consult others about what you ought to feel in respect to your person, and learn from their response. You will find that no one guarantees security for himself on the basis of his own merit. Here is another interpretation: if when you bring forward evidence of some uprightness in yourself, you judge that the harsh words that you had uttered were just, ask anyone you please from among men or any of those who are placed in positions of intimacy with God, and see whether any one comes forward to approve your words.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-059"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:2 Anger truly kills the foolish one, and envy slays the little one.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To complain about one’s misfortunes is evidence of foolishness, which indeed is kindled with greater bitterness at that time when one sees the prosperity of another when you yourself have been afflicted.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-060"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:3 I have seen a fool with a strong root, and I cursed his beauty immediately.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Favorable circumstances do not expose excellent men. For even if those who are bad suffer no inconveniences, yet they are nevertheless worthy of repudiation, so that misfortunes may be called down on them justly.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-061"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:5 His harvest the hungry man shall eat, and the armed man shall take him by violence, and the thirsty shall drink up his riches.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is recounting different kinds of disasters, which usually happen to those who sink into misfortunes on account of the perversity of their character.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-062"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:6 Nothing on earth is done without a cause, and sorrow will not spring out of the ground.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If all things correspond to preceding "), _c('i', [_vm._v("causes")]), _vm._v(" and nothing comes about by chance, then merit has preceded as the source from which "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("the bitterness of this "), _c('i', [_vm._v("sorrow")]), _vm._v(" arose. For indeed this is the condition appointed to man, so that, since he is left to his own effort, he may be filled with rewards for the quality of his zeal. Here is another interpretation. He is saying, Since you overlooked those things that have been said, you should not have been completely shaken by those things that happened to you; nor should you have gone to court with the miseries of the earth, or of the waters, or of any inanimate thing, which have been formed for our use and service by the Craftsman. They are not to be attributed to common chance; things that have been brought on by "), _c('i', [_vm._v("causes")]), _vm._v(", they speak of an examination of judgment.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-063"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:7 Man is born to labor and the bird to fly.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To feel one’s misfortunes is only human; each thing keeps the law of nature imposed on it.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-064"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:8 Wherefore I will pray to the Lord.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is saying that he himself will do that which he wants to persuade Job to do, to give up seeking the why of the misfortunes that have come on him but rather turn his prayers and supplications to God, who is the Lord of all and whose laws all things obey. "), _c('i', [_vm._v("I will pray to the Lord")]), _vm._v(" since I can lay claim to no security for myself on the basis of my works.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-065"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:9 Who has done great and inscrutable things.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("[Eliphaz] recounts the riches of divine providence, which are suitably bestowed on each and all commonly throughout all generations.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-066"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:10 Who gives rain on the face of the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("From the greatness of his power and the outpouring of his kindness, he infers what is safer for human beings. By acknowledging that one is guilty, one places one’s hope of salvation not in one’s own merit but in God’s forgiveness.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-067"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:12 Who scatters the designs of the malignant.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he had pointed out the generosity of the divine goodness, which poured out benefits to humans through a large channel, now he points out the power from which hidden plans cannot escape, nor can those things come into effect that are ordained even by the wise"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-166",
      "id": "ap_ntb-166-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" contrary to his will.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-068"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:13 Who catches the wise in their craftiness.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That which they had thought they had provided, he makes so ineffective that it is as if they have been driven back in a narrow space and are unable to move themselves forward. At the end of the verse, he divulges what was veiled earlier, when he says, “And scatters the counsel of the wicked.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-069"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:14-15 They shall meet with darkness in the day, but he shall save the poor from the sword of their mouth and from the hand of the violent.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The gift of divine power looks to one and the same thing, to nullify the attempts of the wicked, not to allow those things that are done contrary to justice to come into effect, and to bring help to those who are weary and who are deprived of solace."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-167",
      "id": "ap_ntb-167-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-070"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:17 Blessed is the man whom God reproves.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since saint Job was very discouraged that such things had happened to him against his hopes, [Eliphaz] says also that after the plague he should not despair about God becoming propitious to him again; for it is a kind of testimony to divine love that he bridles the freedom to sin by means of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("scourges. "), _c('i', [_vm._v("Blessed is the man whom God reproves")]), _vm._v(". He had recounted various kinds of miseries that have come on sinners for this reason, because they did not want to appear guilty themselves in some respect, or to approach satisfaction by the confession of their iniquity. Therefore, he says that when one is compelled to correction or knowledge by his scourging and severity, he should not be reputed to be amid miseries.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-071"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:19 Out of six troubles he shall deliver you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To be sure, the sum total of the number that is recorded seems to agree with these things that he has added."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-168",
      "id": "ap_ntb-168-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" But generally what he wanted to demonstrate is this: if Job trusted in God and believed that God had reproved him not by anger but by his providence, Job would plead from then on that due to God’s protection he was free and safe from many dangers.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-072"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:21 You will be hidden from the scourge of the tongue.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Not from the curses of detractors but from the arrogant commands of enemies who abuse their captives.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-073"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:22 You will not be afraid of the beast of the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Because of the savageness of their manners, he calls his enemies "), _c('i', [_vm._v("the beast of the earth")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-074"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:23 But [you will be] in league with the stones of the field.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("You will grow old within the boundaries of your inheritance that were established long ago, and a hostile attack will not drive you from your place of habitation.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-075"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:24 And visiting beauty ("), _c('i', [_vm._v("speciem")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “And the visitation of your beauty ("), _c('i', [_vm._v("pulchritudinis")]), _vm._v(") will not sin.” “And visiting your beauty you will not sin.” That is, when he looks at the prosperity of your home, he will keep it for you continually, and he will not allow that you be prevented from retaining these things by any change. The following words in the psalm are also like this: “And none of them that hope in him shall offend.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-169",
      "id": "ap_ntb-169-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-076"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:25-26 You will know also that your seed shall be multiplied; you will enter into the grave with an abundance.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The number of multiplied offspring will attend you with greatest honor in the last rites.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-077"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:26 You will enter into the grave with an abundance, as a heap [of wheat] is brought in its season.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Not in the manner of chaff will you be worthlessly cast away, but you will be eagerly stored up like a ripened crop.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-078"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("5:27 Behold, this is even so, as we have searched out.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He shows in this brief verse that what he spoke about earlier was not a vision, but the thought of an attentive mind. “When it has been heard, consider it carefully in your mind.” That is, the vengeance of God is not lacking to the bad, nor his mercy to the good.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-018"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 6]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-079"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:1-2 But Job answered and said, O that my sins and the calamity that I suffer were weighed in a balance.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("The argument both of holy Job and of his friends begins with less weighty things and grows hotter as it advances. For Eliphaz the Themanite applied goads of remorse, just as if Job were a guilty man. He did this not from the outspokenness of his words but from the subtlety of their meaning, while he reduces Job to the company of those who are unable to promise themselves any perfection of justice."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-170",
      "id": "ap_ntb-170-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" And holy Job responds not as one who is loudly defending himself by asserting his own justice, but he simply complains about the excessiveness of the reproof.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-080"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:3 As the sand of the sea, this appears heavier.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Just as I recognize that I am not perfectly just, so I know that what I am suffering is unjust. “Whence also my words are full of sorrow,” because the reproof, by exceeding moderation, compels me to break out into the words of my complaint and to say that I am not experiencing my Lord as judge but withstanding an enemy and an assailer.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-081"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:4 For the arrows of the Lord are in me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is saying, You all indeed whom no feeling of pain affects discuss philosophers in respect to foreign evils, and you discourse on suffering; but I, who am experiencing the bitterness of plagues in my body, am forced to indicate what I suffer by wailing. “The indignation of which drinks up my spirit.” He has continued with the metaphor taken up and says, as if struck by an arrow, I am experiencing the “poison” of infixed iron. “And terrors.” He persists in the words with which he had begun, wanting to explain the magnitude of his torments and compare his wounds to arrows shot into his guts. In Greek it says, “When I begin to speak, they pierce me.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-082"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:5 Will the wild ass bray when he has grass?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is a subtle rebuke that would have struck back at the insults of his friends against him. He is saying, If nature has given these senses to wild and domesticated animals, so that they are not forced to make noise except when they need food, could I have wailed about my sufferings, unless the bitterness of pain compelled me, unless a cause exists that compels me?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-083"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:6 Or can an unsavory thing be eaten?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("No one consumes "), _c('i', [_vm._v("unsavory things")]), _vm._v(" as food or things full of bitterness. “To the thirsty soul even bitter things seem to be sweet.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-171",
      "id": "ap_ntb-171-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Necessity, therefore, extorts what the will did not admit or suffer.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-084"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:7 The things that before my soul was unwilling to touch, now, through anguish, are my food.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “My spirit ("), _c('i', [_vm._v("anima")]), _vm._v(")"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-172",
      "id": "ap_ntb-172-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" cannot cease; for I perceive my food as loathsome, as the smell of a lion.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-085"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:8 Who will grant that my request may come?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I am compelled to this due to the excess of pain. Thus, I go around in order to display this through my prayers, which is wont to be a terror to other men.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-086"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:9 And that he who has begun may himself crush me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("He who has begun")]), _vm._v(" to lead me away from the pleasantness of life by the tortures that have been applied, may that very one hasten the end of my life through the accumulation of suffering. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("“That he would release his hand, and cut me off.” May he not allow me to be beaten and vexed slowly with a suspended hand, but one that has been applied more firmly, so that it may accomplish that through which I can be extinguished. And from the necessity of the plea may I pass on to be delivered to the place of favor, if by the intervention of death the voice of lamentation will be snatched from me.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-087"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:10 And this would be my comfort.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("While the violence of the disease fatally assails me, may I who am certain about my exit not complain about the extent of my pains.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-088"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:11 For what strength do I have to hold out?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("What constancy of spirit, or what perfection of purpose and virtue will be so great, that I could disguise what I am suffering?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-089"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:12 My strength is not the strength of stones.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That I should bear what I suffer without feeling pain.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-090"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:13 Behold, there is no help for me in myself, and my familiar friends also have departed from me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the absence of endurance and of reason, which could heal me, I am also destitute of the solace of friends.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-091"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:14 He who takes away mercy from his friend, forsakes the fear of the Lord.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Deeply and justly shaken by his desolation, he brings to light the full meaning of truth and the weighty consequence, which he does as one who does not feel the affection of compassion of his friends in his adversities, one who has forgotten the fear of the divine.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-092"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:15 My brethren have passed me by as the torrent.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("During the period of delay of conversation,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-173",
      "id": "ap_ntb-173-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" they did not take in any of the horror or pain; or else, by their passing contact, they did not perceive any of my misfortune.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-093"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:16 The snow shall fall on those who fear the hoary frost.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “Like snow or congealed ice melts at the approach of heat, and it is not known that they existed, so I also have been deserted by everyone; I am ruined, and have become an outcast from the home.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-174",
      "id": "ap_ntb-174-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('i', [_vm._v("The snow fell")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-175",
      "id": "ap_ntb-175-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _c('i', [_vm._v(" upon them")]), _vm._v(". He had said that his brothers passed by with quick passage due to their horror of contamination."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-176",
      "id": "ap_ntb-176-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" Therefore, he announces what punishment awaits merciless souls and those who form cowardly counsels for themselves. He says, “They that flee light evils will be driven into far greater and heavier ones.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-094"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:19 Consider the paths of Theman, the ways of Saba.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, [consider] the people who came from these countries. “Theman, the ways of the Sabaean.” Such is the exposition in Greek. He adds that he found Thema, not Theman, and Seba, not Saba, whose path is through impassible land or desert."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-177",
      "id": "ap_ntb-177-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" Thus, the sense would be the following: like those who make a journey through the desert in the hope of finding water, and they do not find either springs or running water, and they easily perish from "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("thirst, so also I have been deprived of the hope I had placed in my relatives and ancestors.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-095"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:20 They were confounded, because I had hope; they came to me and were covered with shame.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("They that had been glad of my familiarity when I was in my regular condition now blush at my friendship and loathe and despise me as one who lacks his wealth.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-096"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:22-23 Did I say, Bring to me, and give me some of your wealth, or deliver me from the hand of the enemy?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, bring some solace for my miseries.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-097"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:24 Teach me, and I will be silent.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is saying, You have blamed me, as one who had behaved bitterly and immoderately. But if I was burdensome to you and because of this you took the opportunity of shaming me, say so. Or, if those things that fell on me are not grave, prove it. But if both my suffering is grave and I was not burdensome to you, you were obligated to interpret my words charitably. “And if perchance I have been ignorant in anything, instruct me.” Since I do not seek any of your wealth, I ask this alone, that you convict me of the error, if I argued something wrongly about the arrangement of this troubled life amid my miseries.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-098"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:26 You concoct speeches only to rebuke.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Though you are able to bear witness when questioned by me—that is, whether I am in a grave condition in your eyes, whether I am weighed down by a light suffering, and you must admit to both—yet you are willful transgressors of the truth in respect to my injustice.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-099"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:27 You rush in on the orphan.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Upon the orphan")]), _vm._v(", as it were—that is, on one who is destitute of all help, I who do not deserve your afflictions but who am convenient to injure.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-100"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("6:29 Answer, I beg, without contention.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By convicting them of not acting amicably and of speaking against conscience, Job tries to show that just judges cannot rightly blame him for his harsh words or for his longing for death. “And by speaking that which is just, judge ye.” Be the very judges of common sayings, but only in such a way that the reckoning of your verdict complies with justice, not contention.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-019"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 7]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-101"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:1 The life of man on earth is a military service.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When I discuss the condition of mortal nature and am roused to be filled with bitterness over the day of my birth,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-178",
      "id": "ap_ntb-178-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" I do not say what folly and error would seem to dictate, but I bring out what acquaintance with common life acknowledges. "), _c('i', [_vm._v("The life of man upon earth is a military service")]), _vm._v("; that is, it is brief, unrecoverable, full of anguishes. For just as "), _c('i', [_vm._v("military service")]), _vm._v(" is not undertaken for the entire lifespan of a man, but it terminates with a pension, so also the life of mortals ends after a short number of days. “And like the days of a hireling”: because no man knows leisure, no matter what the rank of the state in which he is placed, but employs care and labor to the present life.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-102"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:2 As a servant longs for the shade, as the hireling looks for the end of his work.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Nothing separates all of us human beings from the condition of slaves; for there is no human "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("being who leads life without fear. For the poor man fears the power of the rich; the rich man the envy of another, whether his equal or a superior; the superior fears the proscription of kings; kings fear lawless rebellion and the plots of conspiring subjects. What "), _c('i', [_vm._v("shade")]), _vm._v(" (that is, nighttime) offers to slaves, then—namely, that they are relieved from the burden of labor and from the presence of the master, this is what the final end of life gives universally to mortals, whom various cares vex. Again, here is another way [to interpret this]. The burdens of diverse forms of anguish also draw near to the condition of a short life, so that what is lived briefly is also lived with the greatest affliction.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-103"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:3 So I also have had empty months.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says, Nearly all of us human beings exert ourselves in divine worship in the hope of receiving a reward, and the expectation of repayment makes us devout; but for me, as I see it, the wages for my devotion have been taken away. Not only have [my months] received no good things, but they have received grave evils. However, he referred the whole thing to a cause by saying this: if the rest of men desire death, since they cannot endure the miseries of the life they share in common, how is it that you believe that I am to be faulted if, when beset by such grave evils, I judge it better not to exist at all than to exist like this? "), _c('i', [_vm._v("Empty")]), _vm._v(" means empty of rest or of the feeling of pleasure.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-104"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:4 If I sleep, I say, When shall I arise?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The time of rest contributes to the increase of my suffering, for when the senses are distracted from thinking about other things, then I am driven to think about and feel my sufferings all the more.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-105"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:5 My flesh is clothed with rottenness and filth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “I waste away, scraping off the bloody gore with clods of earth.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-106"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:6 My days have passed more swiftly than the web is cut by the weaver, and are consumed without any hope.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Not only do I hold on to nothing good, but neither can I hope any longer, as the end of life approaches.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-107"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:7 Remember that my life is [like] the wind.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Why do I infer from the sight of sufferings that my end is fast approaching, when I should turn my eyes to the very nature of mortals, which vanishes as easily as a breeze?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-108"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:8 Your eyes [are] on me, and I shall subsist ("), _c('i', [_vm._v("subsistam")]), _vm._v(") no more.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “My eyes [are] on me, and I am ("), _c('i', [_vm._v("sum")]), _vm._v(") no more.” By this he has expressed the suddenness of death.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-109"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:9 So he that shall go down to the lower world does not come up.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is not denying the resurrection here, but he is saying that there is no return and going back to the condition of the present life."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-179",
      "id": "ap_ntb-179-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-110"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:11 Wherefore I will not spare my mouth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So many bitter things converge into the state of my life, so that it is of short duration and full of hardship, and it is not allowed to call back my foot to it from the "), _c('i', [_vm._v("lower world")]), _vm._v(". Rightly, therefore, do I complain about my birth, and I accuse the day of my conception."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-180",
      "id": "ap_ntb-180-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-111"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:12 Am I a sea, or a whale, that you have enclosed me in a prison?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Every great thing, not feeble things, should perceive the greatness of your power. "), _c('i', [_vm._v("In a prison")]), _vm._v(": he said "), _c('i', [_vm._v("prison")]), _vm._v(" for calamity.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-112"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:13-14 If I say, My bed shall comfort me, you will frighten me with a dream.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I am so worn out by continuous evils, and at no time do the adversities that I suffer become inactive, so that the duration of night in which the cares of minds are relieved brings me no reprieve or rest.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-113"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:16 I have done with hope, I shall now live no longer.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is what he said earlier: “Behold, there is no help for me in myself.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-181",
      "id": "ap_ntb-181-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" With the strength of my endurance shattered, I cannot promise myself anything concerning the end of evils and a change to good things.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-114"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:17-18 What is a man that you esteem him? You visit him early in the morning, and you prove him suddenly.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As far as pertains to the logical coherence of the statements, here is the meaning that arises. Though you employ so much proof of your goodness toward man, so that you testify from your bounty that he matters to you, when you gift him with honor and prosperity, suddenly, as if you do not know him, you test him and want to prove him by means of conflagrations. If therefore you inquire into my life by means of scourges, no torments are necessary. Accept the confession and bring out the death sentence against the guilty one. Another subtle meaning occurs concerning the same passage. Why do you hide your knowledge? Is it to make the merits of your servants appear? For you assume the outward appearance of one who is ignorant, so that you may manifest who they are, not to yourself but to others. Whence, if this is the cause of my vexation, “I have sinned,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-182",
      "id": "ap_ntb-182-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" because I uttered a voice of complaint and lamentation. Here is another way. Since you fashioned us with an infirm and contemptible nature, why do you stand forth as a diligent examiner of our daily actions?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-115"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:20 I have sinned: what shall I do to you?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “If I have sinned, what can I do to you?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-183",
      "id": "ap_ntb-183-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" That is, how have my wrongly done deeds injured you? “O keeper of men?” He means, watcher and observer of every work. In the Greek another verse begins here: “O keeper of men,” and then it has, “O you who understand the mind of men. Why have you set me opposite to you?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-184",
      "id": "ap_ntb-184-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" In the Greek it says, “And [why] am I a burden to you?” while I respond outspokenly and I, a slave, bring the Lord into a contest. "), _c('i', [_vm._v("Why have you set me opposite to you?")]), _vm._v(" He is saying, Since you knew that I would be a sinner, why did you allow me even to come into life? Or was it for me to add to the accumulation of offenses, when I am compelled to expostulate against you concerning my misery? “And I have become burdensome to myself.” Life has become burdensome to me because it is destitute of evidence of your propitiousness.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-116"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("7:21 Why will you not remove my sin?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Will you take away the voice of my complaint either by the intervention of death or by the cessation of torment? “Behold, now I shall sleep in the dust.” The continuation of my torment will quickly cause me to be buried and will "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("remove me from the number of those on whom the providence of your kindness is expended. “And if you seek me in the morning, I shall not exist ("), _c('i', [_vm._v("subsistam")]), _vm._v(").” The affection of pity is introduced due to the swiftness of the passage.")])])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-020"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 8]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-117"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:1-2 But Bildad the Shuhite answered and said, How long will you say such things?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This one who contradicts Job’s long-winded errors strives to accuse the entire content of the debate, in which saint Job had complained about the excessiveness of punishments, just as he had failed to defend his own justice. After he satisfied himself about his birth, Job showed from the greatness of suffering that the complaint and causes of his indignation were not unjust. And disputing with God as if with a just plea, he said that such severe vengeance of sins should not be demanded from a man of such a corruptible and short life. Bildad accuses him of insolence and bitterness and says, Give a rest to the bitterness of your words, and do not think that if you talk a lot you can improve your case. Here is another way. Without a doubt, the friends believe that the plagues have been inflicted by God, and holy Job continues in the same opinion complaining.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-118"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:3 Does God pervert ("), _c('i', [_vm._v("supplantat")]), _vm._v(") judgment?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So that it remains to be understood that such a sentence against Job has been given because his offenses ("), _c('i', [_vm._v("meritis")]), _vm._v(") demanded it.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-119"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:4 Even if your children have sinned against him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Even if")]), _vm._v(" your person is purged from fault by your words, do not the sins of your house reflect the fault of your instruction? Therefore, it does not suit you to spend your time complaining, but it is to your advantage to be purged by a confession and by offering prayers.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-120"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:5 Yet if you will arise early to God.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("All things can be read by changing the times, which is indeed customary in the Holy Scriptures, so that the sense is this: although the perverse instruction of your children involves you in a guilty charge, yet the punishment by their death would never have been apportioned to you if you had continuously and meritoriously pursued your devotion.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-121"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:6 If you will walk clean and upright, he will presently awake onto you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Your prayer will be efficacious if you take care not to have merely the appearance of justice, but the reality ("), _c('i', [_vm._v("veritatem")]), _vm._v("). You will easily appease God, and he will quickly bring you back into your former state.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-122"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:8 For inquire of the former generation.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In order to give authority to his words, [Bildad] summons the testimony of the previous generation. His aim is to show Job that what he has said or is about to say is clearly known by long experience. Here is another way. From the examples of those who came before him, he wants him to learn what he had said, that God is easily won over by the prayers of the just, and that not only are adversities removed by his appeasement but also prosperous and favorable things are restored. So, for example, consider the way Abraham and his descendants were protected amid adversities by calling on God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-185",
      "id": "ap_ntb-185-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Here is another way. The reason I want you to look back to the examples of the ancients is to keep you from despising our counsels in view of our youthful age.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-123"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:9 For we are but of yesterday, and are ignorant.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The reason testimony must be sought from elders is because our brief span of years could not confer to us perfect knowledge of things. “For our days are but a shadow.” Since we began to exist only a short time ago, after a short time we will not exist.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-124"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:10 And they will teach you. They will speak to you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("After the insertion of the line in the middle, he added what he ought to listen to from the thoughts of the fathers.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-125"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:11-12 Can the rush be green? When it is yet in flower it withers before all plants.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By seeking a comparison from things that have no firmness in themselves, he wants it to be understood that saint Job only affected a reputation of justice, and he did not take care to have any solid virtue. And for that reason he was deceived by a tenuous hope. For those things that grow not from their own roots but thanks to liquid perish when that same liquid ceases to exist.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-126"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:13 Even so are the ways of all that forget God, and the hope of the hypocrite shall perish.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has revealed what he wanted to be understood by the metaphor that was cited.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-127"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:14 His folly shall not please him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When he sees that he possesses no fruit from the shadow of virtue, which he has followed, [Job] will understand that he has been deceived in his own opinion of himself.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-128"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:16 It seems full of moisture before the sun comes up.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Before the time of testing, he flatters himself about his abundant virtue.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-129"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:17 His roots are on a heap of stones.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These verses are similar to that parable that is introduced in the Gospel, where the seed that is described as having fallen on rocky soil is said to be unable to grow deep roots and subsequently withers in the heat of the sun."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-186",
      "id": "ap_ntb-186-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-130"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:18 If one swallows him up from his place, he will deny it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He continues with the metaphor. He says, Why do I say that a hypocrite is like a field of reed grass or a rush that lacks water?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-187",
      "id": "ap_ntb-187-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" Nay, rather, he is no different from those things, which enjoy moisture, which, when they arise on a heap of stones, perish as quickly as if they had never existed. And if one could inquire about the "), _c('i', [_vm._v("place")]), _vm._v(" in which they had arisen,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-188",
      "id": "ap_ntb-188-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" he would "), _c('i', [_vm._v("deny")]), _vm._v(" those things and say that he does not know.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-131"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:19 For this is the joy of his way, that others may spring again out of the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is the law of nature, that others are substituted in the place of those who perish.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-132"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:20 God will not cast away the simple.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has set the name "), _c('i', [_vm._v("simple")]), _vm._v(" over against the hypocrite.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-133"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("8:21 Until your mouth is filled with laughter.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Septuagint has “But he will fill with laughter the mouth of the true, and their lips with thanksgiving.”")])])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-021"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 9]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-134"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:1 But Job answered and said, Indeed, I know it is so, and that man is not justified when compared with God.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is not saying that he agrees entirely with Bildad’s view, but only with part of it. For Bildad had maintained that God, endowed with both justice and power, opposes the impious just as he cherishes the good."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-189",
      "id": "ap_ntb-189-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" Saint Job says that this is true. But when Bildad wanted to expose him as a sinner on the basis of the things that had happened to him, this Job pronounces to be false."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-190",
      "id": "ap_ntb-190-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" Here is another way. Job did not support the judgment of the one who was railing against him by assenting to his words; but he pronounces to be true what Bildad had said earlier—that is, “Inquire of the former generation, and search diligently into the memory of the fathers.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-191",
      "id": "ap_ntb-191-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" For no man is found who does not choose and make distinctions in matters, yielding in his respect for a superior to come down hard on the person of the inferior.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-135"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:3-4 If he [man] wants to contend with him [God], he [God] is wise in heart and mighty in strength.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Each thing is listed that pertains both to the divine wisdom and power. Surely, by considering these things no one would dare to testify that Job is enduring adversities undeservedly.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-136"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:5 He who removed mountains and they did not know it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By consideration of all these things, the men choose to say that Job lacked the merit of innocence rather than that God was lacking justice.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-137"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:6 Who shakes the earth out of its place, and the pillars thereof tremble.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He speaks of "), _c('i', [_vm._v("pillars")]), _vm._v(" in view of the stability of their unshakable mass and for their firmness.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-138"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:7 Who commands the sun and it rises not.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is saying, Not only do the things on earth but also the things in the sky feel his power; for he stops even the course of the sun when he wants, and changes the arrangement of the stars, as was done under Joshua, son of Nun."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-192",
      "id": "ap_ntb-192-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" Here is another way. All things are mentioned as an indication of the divine power, through "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("which the scales of human testing are thrown into confusion.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-139"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:8 Who alone spreads out the heavens.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is saying, It is no wonder if he uses the elements for the sake of his own will, through which he has willed a thing, since he is the one who created these things when they did not exist.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-140"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:9 Who makes Arcturus and Orion."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-193",
      "id": "ap_ntb-193-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The cause of his power is revisited, whereby either the rising of the sun can be prevented by his command or the quick motion of the stars be made invisible. For all things obey the will of him by whose command they came into existence. “And the inner parts of the south.” The "), _c('i', [_vm._v("inner parts of the south")]), _vm._v(" are said to be that part of the world that is inaccessible to mortals on account of the excessive heat of the sun.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-141"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:10 Who does things great and incomprehensible.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Those things that are being done constantly confess the greatness of his works, the changes of the atmosphere, the change of times, the succession of seasons, the interchange of nights and days. Therefore, by the heavenly signs he wished to indicate atmospheric changes that help and bring benefits to human beings.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-142"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:11 If he come to me, I shall not see [him].")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Something else is added to the things earlier through which terror can be increased. He says, Not only is he wise and powerful, but also invisible, so that by coming unforeseen, he can be justly feared.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-143"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:12 If he examine on a sudden, who shall answer him?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Reason yields to power, and it does not dare ask into the causes of his works when reverence for the maker is thought of.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-144"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:13 God, whose wrath no man can resist, and under whom they stoop that bear up the world.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For the same reason no one dares seek from him a rational accounting of his works. Here is another way. Above he had said, “The pillars thereof tremble,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-194",
      "id": "ap_ntb-194-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" and here, "), _c('i', [_vm._v("under whom they stoop that bear up the world")]), _vm._v(". He wanted nothing else to be understood by each, except that the stability and firmness of the earth bow to his will.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-145"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:15 Even if I should have something just, I will not answer him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Overwhelmed with wonder at his power, I can set forth nothing concerning the purity of my conscience, but it is necessary that I hasten to the helps of my supplications.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-146"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:16 And though he should hearken to me when I call, I do not believe that he hears me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is the limit of his appraisement; that is, while I think how great he is, he does not allow me to believe that my words could easily be admitted to his hearing. He listed everything that was relevant to pointing out the divine strength and power, in order to show that he knows all the more that God is almighty. And he summons this very thing as evidence in defense of his case. For that reason he cannot protect himself against those things by which he is beset, because his strength is no match for him that strikes him, and that power is "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("removed that he uses while taking a stand on the opposite side.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-147"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:17 For he shall crush me in a whirlwind without a cause.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("All that he recounted as proof pertained to his power, not justice. That is why here he adds "), _c('i', [_vm._v("without a cause")]), _vm._v(", in order to show his good reasons, if justice were to preside over his examination.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-148"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:19 If [it be a question of] equity of judgment, no man dare bear witness for me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As the sides are summoned into court, no one will dare absolve me from blame in the divine judgment.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-149"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:20 If I should want to justify myself, my own mouth shall condemn me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, if I apply my defense speech to my justification ("), _c('i', [_vm._v("purgationem")]), _vm._v("), I will accomplish nothing more than offending your ears, since you do not want me to be innocent. I will incur the bad repute of being a blasphemer. Here is another way. He will change my words. “If [I wanted] to show myself innocent, he shall prove me in the wrong.” He takes this from the comparison to judges who affix a criminal charge in whatever cases they have submitted. According to your opinion, my justification ("), _c('i', [_vm._v("purgatio")]), _vm._v(") will not be an acquittal but the onset of a guilty charge.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-150"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:21 Although I should be simple.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I am so thrown into disorder amid those things of which I am conscious and those that I suffer in confusion, that I seem to myself to have lost the knowledge of good and evil.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-151"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:22 One thing there is that I have spoken, he destroys the just and the wicked.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is as if when discernment [between the two] is removed, which looks to the duty of justice ("), _c('i', [_vm._v("iustitiae")]), _vm._v("), the justice ("), _c('i', [_vm._v("ius")]), _vm._v(") of power alone is set in motion.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-152"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:23 If he scourge, let him kill at once, and not laugh at the pains of the innocent ones.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is a familiar cry [for] those who are beset by excessive pain. Here is another way. "), _c('i', [_vm._v("Let him not laugh")]), _vm._v(" at those who are tried by bitter and hard things, but at those who want to assign blame on the basis of sufferings.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-153"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:24 The earth is given into the hand of the wicked one; he covers the face of its judges."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-195",
      "id": "ap_ntb-195-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “But the just are laughed at from the earth.” "), _c('i', [_vm._v("The earth is given into the hand of the wicked one")]), _vm._v(". As far as concerns the context of the passage, he seems to be saying this: the part of him that is earthly (namely, his body) has been surrendered to torments and distresses, and the power to afflict it has been given to the wicked one. Surely, through this it has come to pass that those who look on cannot bear a sound judgment concerning the merits of the afflicted one. But as far as concerns the prophecy that is laid claim to by the merits of the person, Job leaps from the context of the argument and has opened his mouth about future mysteries. He predicts the Lord’s passion, saying that due to the paltriness of the outer, which they had crucified, they were unable to recognize the worth of the inner."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-196",
      "id": "ap_ntb-196-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-154"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:25 My days have been swifter than a runner.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek the order of the words is not the same, nor do the lines begin at the same point. For instead of this it is recorded as follows: “The just are laughed at from the earth.” The explanation is this: he despises the distresses "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("received by the just for the sake of virtue and cares little if they suffer any adversity. But as for what he added, “from the earth,” it is as if he were to say, Such is this life, and mortal affairs are filled with much unfairness. But he refers everything to his own persona, as if he were to say, I endure such things when placed in the pursuit of piety, and he does not free me from the onrushing evils. For just as his friends make a general speech that could apply to the just and the wicked, so even holy Job makes use of a discourse with general application. They speak so as not to be openly cruel to him, but he speaks so as to flee from the vice of bragging. Another verse says the same thing: “They are handed over to the hands of the wicked ones.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-197",
      "id": "ap_ntb-197-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" Explanation: it is a frequent occurrence to see the just handed over as plunder to the wicked, as if he were to say, I have been allowed to endure such things from wicked men. Another line says, “He covers the faces of its judges.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-198",
      "id": "ap_ntb-198-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" Explanation: he makes them worthy of honor and contemptible of authority. “But if it be not he, who ***"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-199",
      "id": "ap_ntb-199-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" is it?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-200",
      "id": "ap_ntb-200-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" But if these things do not happen in such a manner, prove it. In everything, he produces proof by making proper distinctions.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-155"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:26 They have passed by as ships carrying fruits.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the addition of words he has amplified what he had said at first. For he added "), _c('i', [_vm._v("as ships carrying fruits")]), _vm._v(" as though he had not explained the flight of the passing time by the comparison to the steps of a runner; and as if this were still not sufficient, he added, “As an eagle flying to the prey.” Here is another way to read this in a different manner. In its speed, my life competes with ships, whereby he indeed indicates the swiftness of the human passage. Here is another way: [Ships] that indeed are driven along by very strong winds at the end of autumn, or that cannot suffer delay in view of the zeal of the merchants.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-156"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:27 When I say, I will not speak so, I change my appearance.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When the resolution for patient endurance draws me back from complaining, yet the violence of the pain impels me again to the same things.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-157"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:28 I feared all my works, knowing that you did not spare the offender.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “I quake in all my limbs, for I know that you will not forsake me in my innocence.” Here is another way: this is why I wanted to moderate my tearful cries.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-158"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:29 But if I too am so wicked, why have I labored in vain?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “Since I am wicked, why have I not died?” Here is another way: If my rather strict life and my solicitous intentions, which is the examiner of works, was not able to defend me from guilt, why have I lost that sense of enjoyment that arises from a more negligent life?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-159"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:30-31 If I be washed, as it were, with snow waters, yet you shall plunge me in filth, and my garments shall abhor me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The horror of his sores fights against the purity of his life, so that his skin is believed to have been corrupted from the filth of his mind.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-160"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:32"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-201",
      "id": "ap_ntb-201-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" For I shall not answer a man that is like myself.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So that I could freely inquire of him about the rationale and justice of my affliction.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-161"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:34 Let him take his rod away from me, and let not his fear terrify me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Let the whole face of terror be removed, so that the equity of judgment can stand firm under the protection of freedom.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-162"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("9:35 I will speak and will not fear him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("And may I live free from besetting evils. In the future may I fear nothing in respect to outspokenness of speech. In Greek it says, “For I am not conscious of iniquity in myself.”")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-022"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 10]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-163"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:1 My soul is weary of my life.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("[My soul] that is settled in the denial of those things which I ask about. “I will let go my speech against myself.” Although he will say nothing of importance about his great reverence, he comes to fear that his speech may commit some offense. Another way: I will turn my complaints against myself, since I can lay claim to my justice before no one. “I will speak in the bitterness of my soul.” He adds what he will speak "), _c('i', [_vm._v("in the bitterness of his soul")]), _vm._v("; namely, I will neglect complaining about my sufferings, and inquire into the reasons for my condemnation.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-164"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:2 I will say to God, Do not condemn me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “Do not teach me to be impious.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-165"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:3-4 Does it seem good to you?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Greek it says, “Does it seem good to you if I be impious?” Here is another way: it is a peculiar feature of calumny, when the reliability of the truth is neglected, to say what is not real. Job experienced something like this, so that though he was not guilty, yet he endured the blame of a guilty man. “Do you have eyes of flesh? Does it seem good to you if you falsely accuse [me] and help the counsel of the wicked?” They are the ones who think they can rightly conjecture about the nature of the blame of my torments, and they declare what sort of thing the pain of my body shows. “Or will you see as man sees?” So that you inquire into my life based on the torments, not knowing about the uprightness of my conscience.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-166"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:5 Are your days as the days of man, and your years as human times?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So that something done in the past or in earlier time could be hidden.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-167"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:6-7 That you should inquire after my iniquity, and search after my sin, and should know that I have done no wicked thing, whereas there is no one who can deliver out of your hand.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is a matter of human ignorance, that when blame is at issue, he wants to bring into the light that which is unknown by the torments. An appeal of this very serious verdict often acquits, and the judicial examination is transferred to another. But though you are carrying out a lawsuit involving a severe judgment, no one’s intervention can correct what you have decreed.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-168"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:8 Your hands have made me and fashioned me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Nothing in my condition is foreign to you, nothing estranged from the rights of your dominion, [nothing] which you think little of, and which you would meanly abuse as an irrelevant thing.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-169"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:9-11 Remember, I ask, that you made me as the clay. Have you not milked me as milk, and curdled me like cheese, and clothed me with skin and flesh?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("Why do you forget your goodness in respect to me, which was my sole reason for existence? Since you have caused us to have the beginning of our nature from such worthless material, he says, yet you did not cause us to perish quickly, as those who were responding to the substance from which we had taken our origin. For we who were mortals in view of the paltriness of our constitution, you granted us to imitate immortality by the substitution of offspring. You brought about, by much application of your providence in the very coming into being of individuals, first that the liquid substance of our seed did not perish in the insides of our mothers, but what was fluid "), _c('i', [_vm._v("was put together with skin")]), _vm._v(", "), _c('i', [_vm._v("flesh, bones and sinews")]), _vm._v(". Some of these things you provided for strength, others for feeling, others were supplements of perfection.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-170"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:12 And your visitation.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says, Not only did I take form by the working of your hand in the secret place of my mother’s uterus, but even when I came forth into the light, I shared in the life that you were responsible for.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-171"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:13 Although you conceal these things in your heart, yet I know that you remember all things.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Although my ill treatment attests that you are neglecting your possession, yet reason does not allow you to be affected by feelings for the things you have created.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-172"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:14 If I have sinned, and you have spared me for an hour, why do you not suffer me to be clean from iniquity?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If the sins of my past life have earned pardon from you, why do you summon them back to the present day, and establish me as so guilty that you believe I was not forgiven?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-173"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:15 And if I be wicked, woe unto me; and if just, I shall not lift up my head, being filled with affliction.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("With two opposites set forth, he added the new and the same end. For he applied punishment to the wickedness, but he linked to justice the humility that affliction customarily brings about. “And if I should be just, I cannot breathe out, for I am filled with dishonor and I am captured like a lion for slaughter.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-202",
      "id": "ap_ntb-202-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-174"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:16 And for pride you will take me as a lioness.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Though I consist of such paltry and abject material, he says, when I consider what is the inspiration of your goodness, the life that I enjoy, why do I experience the violence of your severity, again as a force of great strength, as a force of great power?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-175"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:17 You renew your witnesses against me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the added words in which he says, “And pains war against me,” he has made known who these witnesses are of whom he complains that they have been brought forth against him.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-176"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("10:19-21 I should have been as if I had not been. Dismiss me, therefore, that I may lament my sorrow a little, before I go to a land that is dark and covered with the mist of death.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the first part of the book, where he complains about the excessiveness of his torments, he offers the underworld as a comparison to his tearful life, and he recounts the advantages of death."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-203",
      "id": "ap_ntb-203-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" Here, where he is discussing the whole condition of mortal life, he describes the state of sad places, in order to increase the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("heap of miseries, because after the present afflictions it is necessary for human beings to reach such an end. "), _c('i', [_vm._v("Dismiss me, therefore, that I may lament")]), _vm._v(". “Allow me to rest a little.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-204",
      "id": "ap_ntb-204-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])])])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-023"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 11]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-177"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("11:1-2 Then Zophar the Naamathite answered, and said, Shall not he that speaks much, hear also? Or shall a man full of talk be justified?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Do you think that by talking a lot you will improve your case and reduce us to silence, as if we revered your lengthy oration? By making use of just arguments, saint Job not only showed that he was estranged from criminal charges, but he also called God forth to his trial to reveal his uprightness. Zophar tries, therefore, to convict him first of verbosity, then of a lack of uprightness. And with his prejudiced opinion about God’s power and wisdom, he tries to show that Job had erupted in the outspokenness of his words without proper consideration. For it would have been fitting instead for Job to remember the weakness of his nature. Here is another interpretation. They accuse both the sense, which arises from the context of the argument, and the prolixity of his speech, and they endeavor to lead him into a confession of guilt, which he himself refuses to do.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-178"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("11:3 And when you have mocked others, shall no man confute you?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("You have mocked")]), _vm._v("; that is, you have convicted [us] of being in error.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-179"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("11:4 For you said, My speech is pure.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The public expression of his "), _c('i', [_vm._v("speech")]), _vm._v(" did not make this claim, but the context of the argument shows it.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-180"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("11:5 And I wish that God would speak with you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In order that you would be overwhelmed by the profundity and reasoning of his statements, and cease to weary him in your defense. It amounts to a serious accusation to equate your own works with the works of God and to claim for yourself the testimony of justice.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-181"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("11:6 And he would show you the secrets of wisdom.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, the rational manner in which he created everything. He is saying, If he would now make manifest those things that long ago he removed from our sight, you would understand how great his power is and the magnitude of his wisdom. “And that his law is manifold.” If "), _c('i', [_vm._v("his law is manifold")]), _vm._v(", and the lineage of his commandments is diffused far and wide, you are forced to admit that you do not comprehend his precepts or that you were unable to carry them out.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-182"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("11:7 Perhaps you will comprehend the tracks of God, and will find out the Almighty perfectly?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Lest you be able to confine within the comprehension of your own thought him who knows no limits to time and who rejoices in his own eternity. By the forms of the proofs that have been summoned, he is unable to demonstrate what he said. Therefore, he takes refuge in a general declaration about the divine power, and he compensates for his own failure by praising the measureless God above.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-183"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("11:8-9 He is higher than heaven.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek says, “Heaven [is] high, but the earth is deep. And what will you do?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-205",
      "id": "ap_ntb-205-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" He is "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("saying, If we are unable to comprehend the visible things that have been made by God who measured them, how is it not a matter of ultimate insanity that our impudent tongue takes up arms against God? “He is deeper than the underworld, and how do you know? The measure of him is longer than the earth, and broader than the sea.” By the measures of all the elements that are spread out far and wide, he seems to have set forth the measure of the divine wisdom. For higher up he mentioned it. Here is another way. Just as he is immeasurable in his nature, so is he incomprehensible in the rational reckoning of his works. "), _c('i', [_vm._v("The measure of him is longer than the earth")]), _vm._v(". He is saying, Why do I question you about the lower parts of the earth—that is, about the underworld? By what measures is the earth itself extended, which meets your eyes, and why has it been compacted into such a size, so that it was made neither larger nor smaller? And by what limits is the sea enclosed, what is its measure in length and breadth? What gulfs does it have and what curves? You will not be able to answer these questions when asked. Surely by this you are admonished about human weakness.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-184"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("11:11 For he knows the vanity of men.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He also is not ignorant of the actions of men, just the rational account of his works is not known by men. For he is so much aware that he does not permit what is done perversely to be unavenged.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-185"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("11:12 A vain man is lifted up into pride.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As if he manufactured something great by his subtle disputation, he employs this conclusion, which stings Job and accuses him openly of having vain convictions. “And he thinks himself born free like a wild ass’s colt.” Since the reason of nature and of God’s works is profound, foolish human beings think that nothing that comes from the contemplation of him applies to themselves. Instead, they live in the fashion of beasts in whom the force of reason is a foreign thing.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-186"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("11:13 But you have hardened ("), _c('i', [_vm._v("firmasti")]), _vm._v(") your heart and have spread your hands to him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("You have hardened ("), _c('i', [_vm._v("obdurasti")]), _vm._v(") it in obstinacy, and with a stretched forth hand you have complained that you are experiencing injustice. "), _c('i', [_vm._v("Your hands")]), _vm._v(": as if he is challenging God to a fight.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-187"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("11:14-16 If you will put away from you the iniquity that is in your hand, then you could lift up your face without spot and also forget misery.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As if he convicts him using reason, so he recommends beneficial counsel.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-188"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("11:18 And being buried you shall sleep secure.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Here "), _c('i', [_vm._v("buried")]), _vm._v(" does not refer to the grave but to the protection of a more remote location.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-024"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 12]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-189"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:1 But Job answered and said.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He himself asserts for himself and vehemently extols that argument by which his friends want to depress and come down hard on saint Job. For they endeavor to prejudge him concerning the omnipotence of God, whereas he says that they have corrupt judgments out of fear of the divine omnipotence.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-190"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:2 Are you then men alone?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Do you think that there has been no one before you, nor will there be any wise man like you after you?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-191"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:3 For who is ignorant of these things that you know?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("“Are you alone?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-206",
      "id": "ap_ntb-206-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" Since Zophar was convinced that he himself had made use of subtle arguments and had prepared things by his discussion that were unanswerable, saint Job says, the things that Zophar had brought up were not matters of great intelligence. Since indeed not only are human beings able to perceive the things about which he had lectured concerning the power of God, but also speechless animals and those elements too that are inanimate. “I also have a heart as well as you.” Since you and I have one nature, I too can know what you know.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-192"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:4-5 He that is mocked by his friend, as I, shall call on"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-207",
      "id": "ap_ntb-207-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" the Lord, and he will hear him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The very fact that you are all trying to humiliate me and wish to make a laughingstock of me can itself commend me to God. “For the simplicity of the just man is laughed to scorn, the lamp despised in the thoughts of the rich is ready for the time appointed.” "), _c('i', [_vm._v("The simplicity of the just man")]), _vm._v(", which provokes unjust scorn among you and is scoffed at in your "), _c('i', [_vm._v("thoughts")]), _vm._v(", will shine like a bright "), _c('i', [_vm._v("lamp")]), _vm._v(" at a time when it should have been necessary to publicize his merits. "), _c('i', [_vm._v("The thoughts of the rich")]), _vm._v(", that is, yours.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-193"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:6 The tents of robbers abound, and they provoke God boldly, though it is he who put everything into their hands.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The subtlety of your entire conjecture tends toward this, that you measure merits on the basis of prosperity and misfortune. Thus, you want to show that I am guilty, and that you men are just, because no opposing breeze blows against you. This is openly to accuse the justice of God, or a way to find fault with his patience. "), _c('i', [_vm._v("The tents abound")]), _vm._v(". Those whom previously he had called “rich”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-208",
      "id": "ap_ntb-208-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" he now accuses by the name of "), _c('i', [_vm._v("robbers ")]), _vm._v("with respect to the bad portions.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-194"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:7 Doubtless, ask the beasts, and they shall teach you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("From that line where he said, “For who is ignorant of these things that you know,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-209",
      "id": "ap_ntb-209-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" up to this passage, things have been inserted in between. For contextual coherence demands the following arrangement: “For who is ignorant of these things which you know? Doubtless, ask the beasts, and they shall teach you,” that, if God is the maker of all things,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-210",
      "id": "ap_ntb-210-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" he is singularly endowed with ineffable wisdom and power.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-195"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:11 Does not the ear discern words, and will not your jaws eat up the taste?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “[The ear] discerns words of understanding.” Here is another way. Just as the teaching of nature holds that one senses a diversity of sensations by the different functions of the members, and human effort did not bring it about that the ears would register sound, the palate [registers] the diversity of tastes, so by the instruction of nature one attains to the knowledge of the divine immensity and power."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-211",
      "id": "ap_ntb-211-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-196"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:12-13 Is there wisdom in the ancients and prudence in length of time? With him is wisdom and strength; he has counsel and understanding.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One should read this as irony, so that it can be linked to what follows. Here is another way. Lest they think that they are saying something "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("great or that they have introduced something profound, in his speech holy Job likewise describes these same things in detail that they recounted with great effort in order to reproach him. Here is another way: this is what he has grasped, that nothing can be compared with the divine power.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-197"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:14 If he pulls down, there is no one who can build up, and if he shuts up a person, there is none that can open.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is proof of the divine power, he says: if he dissolves the fabric of a human being, when his soul departs, and he drives him into the bars of his tomb, no one can call him back to life.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-198"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:15 If he withhold the waters, all things shall be dried up, and if he send them out, they shall overturn the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The proof of lesser things is being cited from greater things. He says, Why do I speak of individual human beings? He can destroy everything, either by great rainstorms or by extreme drought.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-199"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:17 He brings counsellors to a foolish end and judges to insensibility.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When they are robbed of success in the things they have foreseen.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-200"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:18 He looses the belt of kings and girds their loins with a cord.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When supreme power is transferred to others, he lays them low from their heights and strips them of power.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-201"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:19 He leads away inglorious priests.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("His purpose is to render human wisdom null and void by comparing it with divine wisdom. Hence he very finely said that "), _c('i', [_vm._v("inglorious priests")]), _vm._v(" are led, surely meaning those persons who are likewise teachers to others. It is as if he had said, Compared with the divine wisdom, even those who profess the duty of being teachers are not wise.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-202"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:20 He changes the speech of those who speak truly.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is not referring here to those who speak truly, but to those who were thought to speak truly. He convicts them of falsehood when he makes what they had predicted turn out in a different way. Here is another way. He has called them "), _c('i', [_vm._v("those who speak truly")]), _vm._v(" whose plans he could let falter into nothingness. Here is another way. “He takes away the doctrine of the elders.” Job shows them that the frustration of their deliberations occurs without any following of their authority.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-203"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:21 He pours contempt on princes.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Both those who are concerned with teaching and the leaders of the people who are in charge of running common affairs. When God opposes them, they lose the whole summit of dignity by which they had been eminent. “And he lifts up those who were oppressed.” After showing what God can do to those persons who are considered to be illustrious, he adds what help and protection he imparts to the lowly, so that the divine power may be known by both [these classes of people].")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-204"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:22 He reveals deep things out of darkness and brings forth into the light the shadow of death.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When he causes those who had been oppressed to breathe again, once the iniquitous rule has been expelled, then he will bring forth into the light those things that had previously been pressed together and overwhelmed by the night—that is, the merits of both the upright and the wicked.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-205"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:23 He multiplies nations and will destroy them, and he will restore them to wholeness after they have been overthrown.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says, By means of prosperity and adversity he frequently brings about increases and decreases among the peoples.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-206"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("12:24 He changes the heart of the princes.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He himself is said to do what he permits to be done by the intervention of someone’s merit."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-212",
      "id": "ap_ntb-212-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" "), _c('i', [_vm._v("He changes the heart of the princes")]), _vm._v(" “and deceives them that they walk in vain where there is no way.” So that they either choose or follow harmful things instead of beneficial. Here is another way: they often promise great things from their awareness of their strength; after they are invaded they turn their backs to their enemies out of fear and in their confusion look for wastelands and seek hiding places.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-025"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 13]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-207"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:1 Behold, my eye has seen all these things.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Things that they believed provided proof of their singular prudence. By lowering these things to the level of common knowledge,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-213",
      "id": "ap_ntb-213-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" he does not allow them to sense great things about themselves.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-208"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:3 But yet I will speak to the Almighty.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since the speech of my argument showed that I perceived the same things that you had spoken of as things that were unknown to others, yet it is something else that your accusation of my case and questioning calls for: that I recognize that what I am suffering is just.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-209"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:4 Having first shown that you are forgers of lies.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “For you are all unjust physicians and bad healers”; that is, you make the wounds worse and do not cure them. Here is another way. Whoever applies the truth of grace, even though he considers it an honor of him to whom he thinks this truth can help, he does not escape blame for falsity, since the outward appearance of virtue never excuses vice.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-210"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:5 And I wish you would hold your peace, that you might be thought to be wise men.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is a foolish thing to wound the person who needs to be cured. You came to console,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-214",
      "id": "ap_ntb-214-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" and you are increasing the causes of grief. The speech brought forth badly must not have convinced you of your folly.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-211"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:7 Has God any need of your lie?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As if what God does could not be excused in any other way, thus do you vindicate his whole work under the name of power. Here is another way. You who want to bring a legal defense, look into those cases of yours. For you cite words contrary to conscience; for you know some things about me, and you do not fear to falsify other things.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-212"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:9 Or shall it please him, from whom nothing can be concealed?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The form of your public speech will not prevail with him to the extent that a lie could be proof in the injury to the truth.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-213"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:10 He shall reprove you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It does not concern his honor but is a false charge, because you defend him not by means of justice but flattery.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-214"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:11-12 As soon as he shall move himself, he shall trouble you. Your remembrance shall be compared to ashes.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It will not be acceptable in such a great duty of your praise that it be necessary for you as well to incur an offense against him; and when you vindicate the movements he displays against you, you will so perish that the calamity brought in does not allow anything to remain as a sign of you.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-215"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:13 Hold your peace a little while, that I may speak.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So much so has your discussion not frightened me, that I myself am even confident in searching for the causes of my afflictions, and I declare to you the evils of applying correction.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-216"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:14 Why do I tear my flesh with my teeth and carry my soul in my hands?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Though he does not dare to excuse himself from sin entirely, yet he complains about the excessiveness of the tortures. Why, he asks, am I tortured by such great tearing of my internal organs that my soul, placed in my hand, as it were, is in danger of being poured out?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-217"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:15 Even if he should kill me, I will hope in him. But yet I will reprove my ways in his sight.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In order to render null and void the judgment of his friends who were endeavoring to prove that he had acted against God by the bitterness of his complaints, he says both that he will seek the reason for his troubles and he promises that he will hold fast to the steadfastness of hope during the graver misfortunes. "), _c('i', [_vm._v("I will reprove")]), _vm._v(": that is, the examination and the judge.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-218"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:16 For no hypocrite shall come before his presence.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I want the rational account of my life set forth because I am not in doubt that I am being tested by his knowledge. Surely I would not do this if I were concealing one thing in my conscience, alleging something else in my speech. Here is another way. In accordance with his own statements higher up, he says that they will not have confidence in the judgment of God in which assuredly there will be no place for feigned justice.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-219"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:17 Hear my speech and perceive with your ears hidden truths ("), _c('i', [_vm._v("aenigmata")]), _vm._v(")."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-215",
      "id": "ap_ntb-215-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the term "), _c('i', [_vm._v("hidden truths")]), _vm._v(", through the inspiration of the Holy Spirit, he seems to be promising grander and even concealed things, that is, future mysteries. He said "), _c('i', [_vm._v("hidden truths")]), _vm._v(" because by the brevity of the statements he had left more to be understood than he had articulated to be heard.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-220"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:18 If I shall be judged, I know that I shall be found just.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The reason he confidently wants his ways to be brought before the public is because he is not in doubt not only about his acquittal but even about his being approved.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-221"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:19 Why am I consumed holding my peace?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says that he is "), _c('i', [_vm._v("consumed holding his peace")]), _vm._v(", not that he did not say anything but that his claims and defense do not seem to have been acknowledged.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-222"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:20-21 Two things only may you not do to me: withdraw your hand far from me and let not your dread terrify me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He scoffs at his audience as if they are inexperienced and unequally matched, and he turns his words to God and asks him to remove from him both the bitterness of the threat and the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("violence of the blows, and then he promises that he will be confident in his own assertion.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-223"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:22 And call me, and I will answer you; or else I will speak, and do thou answer me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Then an equal format to the disputation will be preserved, and I will be able to answer boldly, or if it has seemed so, to occupy the first step of the questioner, when no terror overwhelms one’s confidence.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-224"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:23 How many iniquities and sins do I have? Show me my crimes and offenses.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In his customary manner he does not claim that he has not sinned, but he says that he has not done things deserving of such great blows. Thus, he asks not that the class or species of sin be pointed out to him, but its measure.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-225"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:24 Why do you hide your face?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has held to the scheme that is preserved in a trial before judges, that when a guilty enemy is convicted before the laws and justice, the verdict is declared against him after a veil has been spread before the face of the judge."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-216",
      "id": "ap_ntb-216-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" For he applies it to fulfill the comparison that he had invoked. “Do you write bitter things against me?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-217",
      "id": "ap_ntb-217-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" “And do you think me your enemy?” My worthlessness does not permit me to come into that suspicion, that I am believed by you, as it were, equally as an enemy, though I do not differ from a dry leaf."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-218",
      "id": "ap_ntb-218-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-226"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:25 Against a leaf, that is carried away with the wind, you show your power.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the worthlessness of the comparison he has expressed that he was speaking not from the impudence of his mind but from the purity of his innocence.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-227"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:26 For you write bitter things against me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Bitter things")]), _vm._v("—that is, judgments that are bitter to me. “And you want to consume me for the sins of my youth.” It is an established fact that the life of the present time cannot be called to court when the suspicions are directed against lapses during childhood.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-228"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:27 You have put my foot in a fettering band and have observed all my paths.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("You have applied such a great watch over all my actions and you have looked on whatever I have done with such focused vision that you did not allow my foot to move forward beyond the course of what is right, and to be free to wander by turning aside.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-229"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("13:28 I who am to be consumed as rottenness.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The fragile propensity of my nature to fall does not allow such an attentive guardian and such a strict severity of the examiner.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-026"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 14]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-230"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:1 Man born of a woman, living for a short time, is filled with many miseries.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Our nature, in order to proclaim the end from the beginning, attests to its destruction by its birth; necessarily, one born from a mortal is mortal.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-231"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:2 He comes forth like a flower, and is destroyed, and flees as a shadow.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Many things come together that yield to your reproach and strictness: the brevity of life, the continuance of miseries, and the constant race toward death.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-232"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:3 And do you think it fitting to open your eyes upon such a one?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the legal defense of his own action, he invokes the general situation of all living things, that when communion with the human race was commended to him, he adds the pursuit of his own virtue to the heap of words out of which his speech is composed.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-233"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:4 Who can make clean him who is conceived of unclean seed? Is it not you who are alone?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-219",
      "id": "ap_ntb-219-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This comparison of yours, which seems to burden humanity, acquits. For it is a matter of great praise that what has been composed displeases you."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-220",
      "id": "ap_ntb-220-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('i', [_vm._v("Who can make clean?")]), _vm._v(" An accusation of nature amounts to saint Job’s purification from guilt."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-221",
      "id": "ap_ntb-221-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" For if that [accusation] cannot be referred to its author in view of the condition of frailty that is inborn to itself, how is it blameworthy that a holy man could be charged with being inferior to God? "), _c('i', [_vm._v("Who can make clean?")]), _vm._v(" According to the Septuagint, “For who will be clean from filth? Not even one, even if his life on earth is one day long.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-222",
      "id": "ap_ntb-222-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-234"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:5 The days of man are short, the number of his months is with you, you have appointed his bounds which cannot be passed.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("“But you have appointed his months to be numbered, you have established his time, which shall not be exceeded.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-223",
      "id": "ap_ntb-223-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" Here is another way: one person will indeed die, though he lived but one day, but another has months of life that have been predetermined, and perhaps to someone else there may be a longer amount of time; yet it is necessary for him to die and to fulfill the debt of his condition. Here is another way. The same meanings are often repeated for one and the same case.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-235"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:6 Depart a little from him, that he may rest.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He does not want God’s providence to be removed from man, as it were, from an irreligious mind, but he asks that his inquisition and censuring be suspended. Here is another way. The Greek says, “Depart a little from me, that I may rest.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-224",
      "id": "ap_ntb-224-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-236"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:7 A tree has hope; if it be cut, it grows green again.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is why I most justifiably ask for a remission of my griefs in the present, since that hope is not mine after death, which there is for a cut tree, that I could sprout again from my roots and be restored. "), _c('i', [_vm._v("A tree has hope")]), _vm._v(". In the things said previously he had described the brevity of mortal life, the lengthening of the afflictions, the fact that time does not stand still, the hastening of man’s race toward death."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-225",
      "id": "ap_ntb-225-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" Now in the comparison with a "), _c('i', [_vm._v("tree")]), _vm._v(" he endeavors to prove his worthlessness, that a thing cut down could quickly rise again from the roots, but a "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_vm._v("dead man cannot return to life. "), _c('i', [_vm._v("A tree has hope")]), _vm._v(". Here is another way. He is describing the case of the human condition, and he utters words not suited so much to his faith as to the matter at hand, words that can indeed suffice in response to those who did not have knowledge of such a great hope, or else that could most rightly fit the present state of man.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-237"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:12 When a man has fallen asleep he shall not rise again; till the heavens be broken, he shall not awake.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is not possible for him to appear to be casting doubt on the resurrection by the things he said higher up,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-226",
      "id": "ap_ntb-226-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" since he predicts and signals the very time of the resurrection, and he confesses that those whom he claims will awake from their slumber do not perish but live.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-238"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:14 Do you think that a man that is dead may live again?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This doubt comes from the greatness of the thing, not from the feeling of hopelessness, which surely he already excluded by his words higher up. “All the days in which I am now in warfare ("), _c('i', [_vm._v("milito")]), _vm._v("), I expect until my change come.” Since it is necessary for a soldier ("), _c('i', [_vm._v("militem")]), _vm._v(") to be involved in constant dangers, he nicely calls the time of the present life "), _c('i', [_vm._v("military service")]), _vm._v(" ("), _c('i', [_vm._v("militiam")]), _vm._v("). "), _c('i', [_vm._v("My change")]), _vm._v(" is close to the apostle’s statement: “It is necessary that this corruptible be clothed with incorruption and this mortal be clothed with immortality.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-227",
      "id": "ap_ntb-227-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-239"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:16 You indeed have numbered my steps.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The severity of a parent is evidence of love. The parent who does not allow his son to wander off from his own chastisement wants to have a proven son.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-240"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:17 You have cured my iniquity.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek says, “And you have marked if I have sinned unwillingly.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-241"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:18-19 A mountain falling passes away, waters wear away the stones, so in like manner do you destroy man?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When he was filled with a prophetic spirit, he had shown that the hope of resurrection undergirds the human being."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-228",
      "id": "ap_ntb-228-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" Therefore, he wants to prove it even by the application of reason, while he vindicates it by a comparison with worthless things.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-242"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:20 Have you strengthened him for a little while, that he may pass away forever?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This whole thing needs to be read as irony all the way to the end of the speech ("), _c('i', [_vm._v("eclogae")]), _vm._v(")."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-229",
      "id": "ap_ntb-229-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" "), _c('i', [_vm._v("Have you strengthened him for a little while?")]), _vm._v(" Similar to this is the following passage from the psalm: “Have you made all the children of men in vain?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-230",
      "id": "ap_ntb-230-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" “Will you change his face, and send him away?” Will you convert favorable circumstances into adversities? Will you repay a needy man from one who abounds, and a dejected man from one who is honored?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-243"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:21 Does he not understand whether his children come to honor or dishonor?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When death takes away all feeling for one’s own posterity by which the living are influenced.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-244"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("14:22 But yet his flesh, while he lives, shall have pain.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("From a speech with general application, at the end he has turned to his own role in the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("discussion, that by God’s chastisement he was leading a life filled with pain.")])])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-027"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 15]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-245"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:1 And Eliphaz the Themanite, answered, and said.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Saint Job had not only shown that Zophar’s words deserved ridicule, but he also had reproved all the men in common, because they thought that wisdom had to be judged according to the ends of a lifetime. And since he had also discussed many things not only concerning human nature but likewise concerning the divine power, Eliphaz takes offense. He tries to accuse [Job] openly of multiple iniquities. And since he is lacking proof, he takes refuge in making a comparison with the people of antiquity. And in this he does not bear a humble mind with respect to himself, but he thinks that he is wiser than everyone else.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-246"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:2 Will a wise man answer as if he were speaking in the wind, and fill his stomach with burning heat?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("[Eliphaz] wants the proof of Job’s foolishness to appear in the length of his speech, and he thinks that Job’s words were dictated by anger; they were not brought forth by reason. “Will a wise man answer as if he were speaking in the wind?” Since saint Job, after the beginning of his speech, had left his fellow disputants behind and had turned his words to God, Eliphaz says that it does not befit a wise man to neglect the person of his fellow disputant and to speak, as it were, to the air, and to orate to the end on whatever pleases him without the fear of being contradicted.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-247"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:3 You reprove him by words, who is not your equal, and you speak what is not profitable to you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Your purification from guilt is an accusation against God;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-231",
      "id": "ap_ntb-231-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" for if you are afflicted undeservedly, he who is afflicting you is most justly branded with iniquity.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-248"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:4 As much as is in you, you have made void fear and have taken away prayers from before the Lord.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By your complaints, you put aside reverence for God and subject him to scorn as you attack his justice. For no one will care about appeasing by prayers the one whom your speech fearlessly made light of.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-249"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:5 For your iniquity has taught your mouth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Language is formed based on the nature of your heart, and speech expresses what the perversely afflicted mind dictates."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-232",
      "id": "ap_ntb-232-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-250"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:6 Your own mouth shall condemn you, and not I.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("More correctly, you will attribute the bitterness of our response not to us but to your own statements, which required this. "), _c('i', [_vm._v("Your own mouth shall condemn you")]), _vm._v(". Compare your words and subject matter, and you will mark yourself down for error, when you see that you have transgressed the measure of your nature by the insolence of your speech.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-251"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:7 Are you the first man that was born?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So that you refuse to be judged according to that rule by which all are checked, but all are checked by that form of assessment that you yourself have established. "), _c('i', [_vm._v("Are you the first man")]), _vm._v(" so that you claim for yourself greater knowledge of all things based on the experience of a longer life?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-233",
      "id": "ap_ntb-233-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-252"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:8 Have you heard God’s counsel, and shall his wisdom be inferior to you?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Was it at your discretion that he granted his own statutes and decrees, so that you should constantly chastise his mistakes as one who is superior?")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-253"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:10 There are with us also aged and ancient men, much older than your fathers.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By whose teaching and authority we learned those things that we did not know.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-254"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:11 Is it a great matter that your God should comfort you?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Even if the measure of chastisement had surpassed the measure of your transgressions, the justice of the censor could have revoked that which exceeded your deserts, had not the obstinacy of your speech stood in the way.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-255"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:12 Why does your heart elevate you, and why do you stare with your eyes, as if you were thinking great things?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Amid his feelings of pain, Job was pointing out the inspiration of the Holy Spirit by the appearance of his body. And, as if forgetful of the present, he was rendered more attentive to the viewing of deep realities. Thus, without any ambiguity he perceived and spoke of the mystery of the Mediator, of his faith in and of the time of the resurrection. For this reason, Eliphaz believed that from the elation of his mind that appearance of his body was formed.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-256"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:14 What is man that he should be without spot?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Eliphaz is convicted by the rebuke that saint Job had perceived well about the nature of man. He would not have blamed holy Job by accusing the nature of man if he had said the same and not different things. For this reason Eliphaz means that the nature of human beings is subject to suffering. It is likewise prone and inclined to sin. "), _c('i', [_vm._v("What is man that he should be without spot, and that one born of a woman should appear just?")]), _vm._v(" From the words of saint Job he reckons that an occasion has been given him to argue against Job. And he reckons that he can bind him on the basis of what he has conceded. Saint Job had said, “Man born of a woman, living for a short time, is filled with many miseries.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-234",
      "id": "ap_ntb-234-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" Eliphaz infers from this and says, “If this is the nature of mortals, as you yourself testify, so that in view of the frailty of mortality and the constant change of his state, it would not be able to be compared with God, you too are forced to confess that you are a sinner.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-235",
      "id": "ap_ntb-235-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" But the defect that Job applied to [human] bodies, Eliphaz attributed this to their moral character.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-257"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:15 Behold, among his saints no one is unchangeable.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("No one is so devoted to virtue that he is incapable of the opposite. Now by "), _c('i', [_vm._v("saints")]), _vm._v(" here he means Abraham and his descendants. “And the heavens are not pure.” He is not saying that the "), _c('i', [_vm._v("heavens")]), _vm._v(" are blackened by the filth of anyone’s sin but that the only nature subject to no change is God’s. For often the calm appearance of the "), _c('i', [_vm._v("heavens")]), _vm._v(" is obscured by an overlay of clouds.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-258"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:16 How much more is man abominable?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To whom the pursuit of evil customs creates an eagerness and longing to sin.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-259"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:17 I will show you, hear me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By saying, "), _c('i', [_vm._v("I will show you, hear me")]), _vm._v(", he wants him to learn from him what he says he received from the elders. This is a sign of a wise man, to know that man is incapable of complete justice and perfection.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-260"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:18 Wise men confess and hide not their fathers.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, they do not conceal by whose authoritative instruction they were educated.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-261"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:19 To whom alone the earth was given.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To the wise whose thought this is, that they set their salvation in supplications for themselves more than in the pursuit of virtue, since they are incapable of it. "), _c('i', [_vm._v("The earth was given")]), _vm._v("—that is, as an inheritance that is long and secure, with no fear of a robber.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-262"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:20-21 The wicked man is proud all his days. The sound of dread is always in his ears.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The alarm that comes from conscience lacks security even in times of quiet.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-263"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:22 He does not believe that one could return from darkness.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When adversity occurs, the good of his conscience is unable to guarantee better things for him.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-264"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:23 When he moves himself to seek bread, he knows that the day of darkness is ready at his hand.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Even if he is not involved in great labor and behaves as one who is remiss in activity, the horror of death always stands over him.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-265"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:25 For he has stretched out his hand against God.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He adds the reason and renders an account for why an arrogant man would encounter those things that he recounted. And he explains the vices of the mind under the form of the body.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-266"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:26 He has run against him with his neck raised up.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he had put on the role of one fighting against God, he describes by whose aid the rash man is accustomed to stir up ventures.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-267"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:28 He will dwell in desolate cities, and in desert houses.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To the previously stated calamities that he says are owed to the impious, he adds other adversities as well: that the exile hunts from his desert house and does not enjoy his wealth inexhaustibly.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-268"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:29 Neither shall his substance continue, neither shall he push his root in the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Not only will his "), _c('i', [_vm._v("substance")]), _vm._v(" and wealth be diminished, but he will not even have hope of propagating offspring.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-269"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:30 He does not depart out of darkness.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He will not alter the sad situation by any change to joyful things. “The flame shall dry up his branches.” He has preserved the metaphor in order to say that "), _c('i', [_vm._v("his branches")]), _vm._v(" are to be dried out by the burning wind. He has indicated posterity in the comparison to trees.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-270"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:31 He would not believe, being vainly deceived by error, that he may be redeemed with any price.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A handful of money will not redeem someone whom vice and guilt dooms to a death sentence.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-271"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:32 Before his days be full, he shall perish.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He will not be allowed to reach old age but will be snatched away by a premature death.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-272"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:33 He shall be struck as a vine when its grapes are in the first flower and as an olive tree that casts its flower.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By means of a simile he says that he is to be deprived of all succession of goods, the way a vine or olive tree loses its fruit when cold strikes the former in its first flower, when summer heat strikes the latter.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-273"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:34 For the congregation of the hypocrite is barren.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He strikes at the character of saint Job by this generalization of speech. “And fire shall devour their tabernacles.” This applies either to the corruption of judges or to the avarice of robbers.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-274"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("15:35 He has conceived sorrow and has brought forth iniquity.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When he steals things that belong to others and does not allow the use of things that have been seized, the only fruit of his work is the labor alone.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-028"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 16]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-275"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:1-2 Then Job answered and said, I have often heard such things.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("With one line he accuses them of two errors. They are recalling as novelties things that were overused in the speech earlier, and they are forgetful of the duties of friendship when they heap up the causes of his pain. Just as Eliphaz and his friends want saint Job’s suffering to be a testimony to his sins, so on the other side saint Job endeavors to summon the things that had happened to him as his own justification from guilt. For under the outward form of a rhetorical training exercise, as an affront to Job, Eliphaz had recounted things that customarily happen to the impious.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-276"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:3 Shall they have no end?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The reason no limit is applied to their inane words is because your speeches are not balanced with prudence and well-considered, nor is what you all speak full of importance, whatever effort is applied.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-277"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:4 I also could speak like you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If I behaved idly as you all do, and the sensation of my pain did not restrict me to words of importance, I could easily pour forth whatever words came to my tongue.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-278"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:5 I would comfort you also with words.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This kind was easy, [a speech] that announces a reproach rather than applies the compassion of consolation to you.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-279"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:7 But what shall I do? If I speak, my pain does not rest.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("From this inanity of your speeches, I am led off, as it were, with a kind of bridle of my vexation, which is so great that the intention neither to speak nor be silent diminishes it. "), _c('i', [_vm._v("Does not rest")]), _vm._v(": [Theodore has]"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-236",
      "id": "ap_ntb-236-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" instead “Does it not rest?” “And if I hold my peace, it will not depart from me” instead of “Does it not depart?”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-280"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:9 My wrinkles bear witness against me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("All the vigor of a man in the very bloom of life has been consumed. The whole form of my body has changed into that of an old man whose appearance is summoned as testimony "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }, [_vm._v("of my accusation, while my sufferings are attributed to my offenses. “And a false speaker is raised up against my face.” My accuser is armed with private testimony against me.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-281"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:10 He has gathered together his fury against me, and threatening me he has gnashed with his teeth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Using a comparison to human custom, he has expressed the bitter attacks of pain within himself and the violence of the raging evil. "), _c('i', [_vm._v("He gathers together his fury")]), _vm._v(". As far as is revealed in the speeches of saint Job, it appears that his fellow disputants are incensed by the progression of his speech and have gone beyond the moderation of a disputation. They have reached the point of bitterness in the quarrel and the wrath of those who are wrangling.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-282"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:11 They have opened their mouths upon me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the Greek all these things are recorded in the singular."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-237",
      "id": "ap_ntb-237-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" “They have struck me on the cheek.” The strivings of the undisciplined customarily reaches the point of this outcome, that they abandon moderation in disputation and arm themselves with reproaches and wrangling, with the result that they are scarcely able to contain themselves even by hands. Either this is indicated in the present lines or else all these things are spoken with rhetorical stress.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-283"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:12 God has shut me up with the unjust man and has delivered me into the hands of the wicked.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He refers to God as the cause of the insult that he endures from the speech of his friends. And he says that he would not have been able to endure anyone’s injury except that he had been stripped of so many helps. This is why he added:")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-284"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:13-15 I who was formerly wealthy have been suddenly broken to pieces. He has set [me] up to be his sign.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He did not train on me alone the gestures of an angry man, as it were, but for the display of his power and proof of his skill, he cheaply reckoned [me] against whom he directed his javelins. "), _c('i', [_vm._v("I who was wealthy have been suddenly broken to pieces")]), _vm._v(". So that he deprived me both of bodily health and the consolation of wealth. “He has held my neck. He has compassed me round about with his lances; he has wounded my loins. He has torn me with wound upon wound, he has rushed in on me like a giant.” Since he had said that he was laid prostrate by God his assailer, he pursues in his speech the comparison to an enemy and to a powerful adversary. And he endeavors to explain things situated in the intellect by means of physical indications, and he announces what he feels by means of what customarily has met the eyes.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-285"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:16 I have sowed sackcloth on my skin.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is what he said: “He has torn me with wound upon wound.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-238",
      "id": "ap_ntb-238-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" Thus, he showed that two serious things happened to him, that he lacks that with which the body is covered and healed.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-286"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:17 My face is swollen from weeping.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He shows that he expended tears not as a penance but out of pain. “These things have I suffered without the iniquity of my hand.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-239",
      "id": "ap_ntb-239-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" Surely he means that if he were guilty he would have paid for what he had done by weeping, not for what he was suffering.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-287"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:18 These things have I suffered without the iniquity.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("You are grieved for good reason, for there were no grounds for such great torment. "), _c('i', [_vm._v("I have suffered these things")]), _vm._v(". He feels pain, well aware that it goes contrary to his merits; therefore, he does not want the fact that he has been surrendered to torments to be concealed, but he wants his suffering to come into the light. He does not want the memory of his suffering to be buried in oblivion, but he wants his suffering to reach everyone’s ears because he is confident"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-240",
      "id": "ap_ntb-240-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" about the uprightness of his life."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-241",
      "id": "ap_ntb-241-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" And this is why he added:")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-288"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:19 O earth, do not cover my blood.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is fitting for one who has been beset by such pain as surpasses human nature to endure to authoritatively address the "), _c('i', [_vm._v("earth")]), _vm._v(", so that it does not seem undeserved for him by the inspiration of the Holy Spirit to lay claim to such great confidence for himself. For while situated outside the law, the man says that which is found in the writings of the sacred law. For the voice of God says to Cain, “The voice of your brother’s blood cries out to me from the earth.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-242",
      "id": "ap_ntb-242-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" Therefore, it pertains uniquely to the just that their sufferings, deaths, and battles are not hidden.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-289"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:20 For behold, my witness is in heaven.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The words by which he had professed the virtue of his innocence and the purity of his prayers seemed to be asserted in opposition to realities that pointed in a different direction. Therefore, the confident one takes refuge in the worthiness of an incorrupt witness who is able to judge not based on things that meet the eyes but on his very conscience.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-290"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:21 If my friends are full of words, my eye pours out tears to God.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is understood here that his friends revealed his offense by their murmuring, while he spoke things greater than suited human measure. And this is the reason he turns and accuses them of garrulousness and testifies that his case is with God.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-291"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:22 And O that a man might so be judged with God as the son of man is judged with his companion!")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Because you show yourselves offended by my outspoken speech, O friends, greater confidence has arisen in me to assert myself, if the assailer’s persona would stand by me as an equal. But now, as my conscience raises me up, so the weight of divine reverence drives me back.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-292"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("16:23 For behold, short years pass away.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is consistent that he comes into doubt, as it were, concerning the benefit of his justice and he complains about the shortness of life.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-029"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 17]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-293"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:1 My spirit shall be wasted.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In view of the greatness of the afflictions, he believes that he is to die before joyful times succeed in place of the sad times. “My days "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "title": "45"
    }
  }, [_vm._v("shall be shortened, and only the grave remains for me.” [The Greek has] “I pray for burial, and it does not happen to me.”")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-294"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:2 I have not sinned, and my eye abides in bitterness.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Either this is to be referred to the continuous time of his life or else he is saying that after lapses during his adolescence, which he corrected by better pursuits, he has solicitously avoided vices.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-295"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:3 Deliver me and set me beside you, and let any man’s hand fight against me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since these adversities that I suffer bear witness that you hate me, release me from such a prejudice, so that constituted under the fairness of your examination, I may confidently welcome the incriminations of any accuser.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-296"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:4 You have set their heart far from instruction.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He repeats in his own speech the words that his friends cited in respect to his suffering, that the reason his children perished was because they mishandled their education and their claim that Job himself had stood forth as such a violent man during the time of his prosperity that he won the loyalty of his own servants by sharing the plunder with them."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-243",
      "id": "ap_ntb-243-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" This is why he coherently added, “He has made me, as it were, a byword of the people.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-244",
      "id": "ap_ntb-244-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-297"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:5 He promises plunder to his companions, and the eyes of his children shall fail.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “For they have turned away their heart from wisdom.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-245",
      "id": "ap_ntb-245-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" Willingly and knowingly, he says, they transgress justice and behave as those who have forgotten the truth. Another line [in the Greek says], “Therefore you shall not exalt them.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-246",
      "id": "ap_ntb-246-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" “You shall not exalt”; that is, I am not able to exalt: I am not able, he says, to prefer their words to my statements, nor to reckon their thoughts better than mine. And he gives the reasons why he could not do this: “You have stood by on the side of iniquity.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-247",
      "id": "ap_ntb-247-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" It is not surprising, he says, if you prepare contradictions to my statements contrary to my conscience, you who have striven to place perverseness before what is right. Whence, he says, is this true? “My eyes have failed over my children.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-248",
      "id": "ap_ntb-248-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" You cannot confess ignorance of my evils, since the plundering of my property and the loss of my children, which impaired my eyesight, reached the ears even of those situated far off.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-298"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:6 He has made me, as it were, a byword.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The horror and cursing over my suffering is constantly on everyone’s lips.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-299"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:7 My eye has grown dim from indignation.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is aroused at the bitterness of the wounds, likewise by the curses of those who speak reproaches.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-300"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:8-9 The just shall be astonished at this.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “Wonder will hold true men upon this.” Not those, he says, who will be of the right judgment, as you are affected by a similar rumor, but they will collapse into ultimate grief since they see that what I suffer has happened beyond the limits of human power. “For the unjust has risen up against the just.” Consequently, he says, they will be of such "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46",
      "title": "46"
    }
  }, [_vm._v("a will and thought that they even render testimony to my justice, and those who rob me will accuse me of impiety. "), _c('i', [_vm._v("The just shall be astonished at this")]), _vm._v(", “and the innocent shall be raised up against the hypocrite, and the just man shall hold on his way.” From the context of the disputation, he advances to greater things while being filled with illumination into higher matters. Thus, he utters what he feels about the end of his suffering, or else about the Lord’s dispensation. Both these things can be understood in one way; namely, "), _c('i', [_vm._v("the just shall be astonished")]), _vm._v(" at the depth of the divine counsel and will. For the Lord wanted to conceal his own justice in order to broadcast the merits of his servant, in order that by his example every innocent person will not only stand up confidently against the hypocrite but, moreover, while proceeding down the continuous way of virtue, will always increase his own former pursuits for the sake of those who are following. "), _c('i', [_vm._v("The just shall be astonished at this")]), _vm._v(". Either saint Job understands as much as he declared or he spoke things greater than were capable of occurring to his understanding. When these things are fulfilled, they convince us that what he said was a prophecy. For who is not "), _c('i', [_vm._v("astonished")]), _vm._v(" either that holy Job, for the sake of testing his virtue, was surrendered to tribulations or that the Son of God, for the sake of the salvation of the human race, arrived at the humiliation of the cross, so that by his example the innocent person could stand up strongly"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-249",
      "id": "ap_ntb-249-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" against the one who hypocritically feigns virtue and not be terrified by any kind of punishments?")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-301"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:10 Wherefore be ye all converted.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("You are furnished with eyes only for the images of things of the present, and you are unable to view with the eyes of the mind those that are concealed in the depths of the [divine] superintendence.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-302"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:11 My days have passed away; my thoughts are dissipated.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("After touching on the great matters, he returns again to the course of his own insignificance, and he says that in the agitation of his mind he could not track down what he should hold on to for certain.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-303"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:12 They have turned night into day, and after darkness I hope for light again.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is a familiar experience, that sleepless nights pass that are occupied either by stirred up emotions or pains.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-304"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:13 If I endure, the underworld ("), _c('i', [_vm._v("infernus")]), _vm._v(") is my house.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The constant horror of death shuts out the moderate endurance of sufferings. For when can I promise a change to prosperity, since I already see the time of my life spent in miseries?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-305"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:14 I have said to rottenness, You are my father, my mother.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I have been so corrupted by the long and continuous decay of my body, that to me it does not seem to have occurred at any particular time, but I believe I was either born from this rottenness or with it.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-306"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:15 Where is now then my patience?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Here he is not calling the virtue of endurance "), _c('i', [_vm._v("patience")]), _vm._v(", but the very cause of his suffering.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-307"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("17:16 All that I have shall go down into the deepest hell ("), _c('i', [_vm._v("infernum")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The whole time of my life has been consumed, when I might have hoped for better things.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-030"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47",
      "title": "47"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 18]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-308"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:1-2 Then Bildad the Shuhite answered and said, How long"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-250",
      "id": "ap_ntb-250-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" will you throw out words?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("There is one intention both for saint Job in all his statements and for his three friends, that he show himself estranged from their recriminations, and that they, as if in defense of God, endeavor to show him to be guilty, based on those things that have happened to him. "), _c('i', [_vm._v("How long?")]), _vm._v(" By the occasion of his response, it is understood that it was not written down in the same order and manner in which the disputation was conducted. For neither the words full of saint Job’s bitterness nor the heated and incited speech of his friends would have preserved their ordered measure, nor would a book of controversies and speeches have been contained by that brevity that it does contain. Whence Bildad too complains about those making a racket about his speech and those claiming that it lacks discipline, to express that which occurred to each one in the conflict. And he demands that an opportunity be given to himself as to one who is not inferior.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-309"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:3 Why are we reputed as beasts?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("You claim for yourselves alone the opportunity to speak, as those who are wiser, while excluding it from us.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-310"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:4 You who destroy your soul in your fury.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Having, as it were, procured silence from his friends, he hurls the javelins of his words against saint Job, against whom he was particularly seeking an opportunity for himself to speak. “Shall the earth be forsaken for you, and are rocks being removed out of their place?” He is saying, Just as the elements have received a definite status by the arrangements of their Creator, so the merits of things are checked off as paid, in view of their characteristics, as is decreed by the same Creator. Therefore, although you are complaining about the fairness of God’s judgments and do not want to undergo what sinners deserve, doubtless you wish that the entire ordering of God’s works be changed.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-311"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:5 Shall not the light of the wicked be extinguished?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For the standard of fairness established by God and presiding at the judgment demands this.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-312"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:7 The steps of his strength ("), _c('i', [_vm._v("virtutis")]), _vm._v(") shall be constricted.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the different forms of afflictions, he explains what fruits follow wickedness. “His own counsel shall cast him down headlong.” It is a common thing in the Holy Scriptures to speak as follows. They are said to have undertaken by their own desire and pursuit that condition into which people fall headlong when the verdict of judgment is passed. It is not that someone desired the adversities but that he behaved in such a way that it was necessary that he reach the outcome of the adversities. Therefore, the end of the business is appraised from the nature of its commencement."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-251",
      "id": "ap_ntb-251-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-313"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:8 For he thrust his feet into a net.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("No effectual achievement will follow the aim of his works; rather, on the contrary, he will be chained inextricably to the adversities."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-252",
      "id": "ap_ntb-252-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" This customarily comes to pass to the one seething amid anguishes.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-314"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:12 Let his strength be wasted with famine.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Ever since he said that adversities advance unto sinners as a consequence of God’s judgments, he was delighted, as it were, by the justice that assesses"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-253",
      "id": "ap_ntb-253-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])]), _vm._v(" merits, and he adopts the outward display of one wishing for something.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-315"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:13 Let it devour the beauty of his skin and consume his arms.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “While he is still alive, death shall devour his firstborn ("), _c('i', [_vm._v("primogenitum")]), _vm._v(").”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-254",
      "id": "ap_ntb-254-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" Firstborn ("), _c('i', [_vm._v("primogenita")]), _vm._v(") death. He said "), _c('i', [_vm._v("firstborn death")]), _vm._v(", wanting to indicate the one and only, as it were, in respect to eminence, and the one that could not be compared with others, in view of his own bitterness. For every firstborn is preferred to those born later. Or one should understand "), _c('i', [_vm._v("firstborn arms")]), _vm._v("—that is, sons whose death customarily afflicts parents very grieviously.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-316"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:14 Let his confidence be rooted out of his tabernacle.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("With all resources consumed that can provide solace or bring aid to one who is lying at the point of death, let no hope be left in which one who is about to fall could lean. “And let destruction tread on him like a king.” The Greek has “And let distress ("), _c('i', [_vm._v("necessitas")]), _vm._v(" = "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("ἀνάγκη")]), _vm._v(") and a charge from the king seize him.” He says indeed that he found this more clearly in another passage where it says, “Let actions on the necks be exhibited to the king.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-255",
      "id": "ap_ntb-255-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" And the sense is, He says, not only does the wicked one suffer evils from inferiors, but he is even reduced to miseries from those who preside and hold command.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-317"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:15-16 Let the companions dwell in his tabernacle.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Elsewhere it says more clearly, “Let him dwell in tabernacles not his own.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-256",
      "id": "ap_ntb-256-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" This indeed has been recorded very coherently in accordance with the Greek version. For the one who incurs an offense meriting royal confiscation becomes an exile even from his own house as well as in other affairs. "), _c('i', [_vm._v("Let the companions of him who is not dwell in his tabernacle")]), _vm._v(". “Let his roots be dried up beneath, and his harvest destroyed above.” The explanation that reckons "), _c('i', [_vm._v("him who is not")]), _vm._v(" as said of the devil is far removed from the contextual coherence of the reading."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-257",
      "id": "ap_ntb-257-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" Thus, it befits God to say that he always is, in accordance with the following: “I am who I am.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-258",
      "id": "ap_ntb-258-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])]), _vm._v(" The devil, on the other hand, is not said “to be.” But here the intention of the statements pleads for complete desolation and abandonment by saying "), _c('i', [_vm._v("the companions of him who is not")]), _vm._v(". "), _c('i', [_vm._v("He who is not")]), _vm._v(" surely has no companions. It is as if he were to say, Let no one dwell in his tabernacles. He has made this meaning obvious in the verse that follows.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-318"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:17 Let the memory of him perish from the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In order that Bildad may not appear to have spoken inconsistently, so that, when he said, “Let his roots be dried up beneath,” he added, “and his harvest destroyed above,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-259",
      "id": "ap_ntb-259-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" he added what he wanted to be understood through such a series of statements, by saying, “Let the memory of him perish from the earth.” For it could happen that the maturation of the crops "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("would occur before the drying up of the roots, which takes place over a long period of time. "), _c('i', [_vm._v("Let the memory of him perish from the earth.")]), _vm._v(" All the things indeed that customarily happen to the unjust are spoken of in general, but these words refer obliquely to saint Job, because he suffers such things in view of his own merits, as God marks him down as paid.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-319"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:20 The last ("), _c('i', [_vm._v("novissimi")]), _vm._v(") shall be astonished at his day.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One should refer "), _c('i', [_vm._v("first")]), _vm._v(" and "), _c('i', [_vm._v("last")]), _vm._v(" either to the genealogical family of the race or to distinguish the sequence.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-320"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("18:21 These then are the tabernacles of the wicked man, and this the place of him who does not know God.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is as if he were to say, Here is the fruit and these are the wages of sins.")])])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-031"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 19]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-321"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:1-2 Then Job answered and said, How long do you afflict my soul?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Saint Job understood that he in particular was being bitten by the teeth of his friends, although they were making assertions in general terms, or rather, obliquely, about what wickedness deserves. And therefore, when they are not receptive to clearing him from guilt in his statements, he complains about his compulsion to respond that has been imposed on him.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-322"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:3 Behold, these ten times you confound me and are not ashamed.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is a matter of shame and disgrace to oppress one who is lying on the ground and to step on someone who has fallen.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-323"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:4 For if I have been ignorant, my ignorance shall be with me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This charge by which you pursue me comes to you not from necessity but from perversity of mind. For my sins will not injure you, who rise up in such bitter speeches against me. In fact, it will tell against me if I have committed anything either in deed or in speech that truth would not approve of.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-324"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:5 But you have set yourselves up against me and reprove me with my reproaches.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("You summon testimony against me not from my deeds but from the vexation of my body.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-325"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:6 At least now understand that God has not afflicted me with an equal judgment.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If your determination to contradict seduces you, at least the facts themselves, which you perceive, ought to procure certainty for you. For what is concealed in the kind [of affliction] is revealed in the measure [of it]."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-260",
      "id": "ap_ntb-260-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])]), _vm._v(" For the tortures are greater than the guilt; surely the appearance of punishments is manifest, though suspicion rummages about looking for sins.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-326"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:7 Behold, I shall cry suffering violence, and no one will hear me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The silence of the judge proceeds from the form of the deed. Therefore, the voice of the objector is not allowed, since it more cruelly excelled the one who was established. My outcry ought either to be curbed by reason or soothed out of pity.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-327"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:8-9 He has hedged in my path round about, and in my footpath he has set "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50",
      "title": "50"
    }
  }, [_vm._v("darkness. He has taken the crown from my head.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By this metaphor, he says that his hope of escaping from his miseries has been taken away from him; for he says that even "), _c('i', [_vm._v("darkness")]), _vm._v(", which removes the ability to look ahead, has been employed to hinder escape.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-328"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:10 He has destroyed me on every side and has taken away my hope, as from a tree that is plucked up.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In order to increase the evil of hopelessness, he was not content to say "), _c('i', [_vm._v("a tree")]), _vm._v(" that is “cut down” but "), _c('i', [_vm._v("plucked up")]), _vm._v(". When its roots perish with itself, it is not able to rise into another sprout by germinating.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-329"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:11 His wrath is kindled against me, and he has counted me as his enemy.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has excluded judicial moderation by the terms "), _c('i', [_vm._v("wrath")]), _vm._v(" and "), _c('i', [_vm._v("enemy")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-330"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:12 His robbers have come together and have made themselves a way by me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Either Job is complying with the simile that he had adopted in order to say that he is exposed to the attack of the enemies and that they more often go back and forth without any obstacle on their open road, or else he is referring to the fact that messenger followed messenger, who announced to him those evils that had befallen him. For it is reported as follows: “While he was still speaking, behold, another messenger came.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-261",
      "id": "ap_ntb-261-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" "), _c('i', [_vm._v("His robbers have come together")]), _vm._v(". He has developed the metaphor that he had introduced with the term "), _c('i', [_vm._v("enemy")]), _vm._v(". In fact, since Job said that God came to attack him, as a kind of hostile king, he now added, "), _c('i', [_vm._v("His robbers have come together")]), _vm._v(". It is as if he said, his soldiers. For scriptural usage calls the spies of enemies "), _c('i', [_vm._v("robbers")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-262",
      "id": "ap_ntb-262-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" Therefore, even by the things he added he has adorned the form of the desired comparison:")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-331"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:16 I called my servant, and he gave me no answer; I entreated him with my own mouth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He looks toward greater mistreatment. A situation that is not far off, but present, can be despised.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-332"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:17 And I entreated the children of my womb.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “children of my concubines.” "), _c('i', [_vm._v("Children of my womb")]), _vm._v(", on whom I had expended no less affection than if they had come forth from my flesh.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-333"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:18 Even fools despised me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As it were by certain stages he says that he has been brought down ("), _c('i', [_vm._v("deductum")]), _vm._v(")"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-263",
      "id": "ap_ntb-263-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])]), _vm._v(" from the highest heights to the deepest depths. For first of all, he says he was robbed of his kingdom when he says, “He has taken the crown from my head.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-264",
      "id": "ap_ntb-264-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" But since it did not immediately follow that, since he had been stripped of honor, he likewise seemed exposed to attack, he added, “Thus, he has counted me as his enemy.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-265",
      "id": "ap_ntb-265-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" Still, the solaces of parents, or dependents, had remained. He says that he lost even these when they were all taken away.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-334"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:19 My counselors, and he whom I love most is turned against me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is what he said previously: “And I entreated the children of my womb.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-266",
      "id": "ap_ntb-266-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-335"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_51",
      "title": "51"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:20 The flesh being consumed, my bone has cleaved to my skin.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The violence of the raging disease has attacked not merely on the surface, but down deep. “And nothing but lips are left about my teeth.” He recorded lips for thin skin.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-336"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:21 Have pity on me, have pity on me, at least you my friends.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When such a dire appearance of my calamities meets your eyes, it did not become you to insult my miseries, but it would have been befitting to be struck with the affection of pity and with compassion.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-337"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:23-24 Who will grant me that my words may be written? Who will grant me that they may be marked down in a book with an iron pen, and in a plate of lead, or else be graven in flint stone?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When our souls are troubled, we often express things that are disordered, and we desire that afterward these things be consigned to oblivion, as things to be ashamed of. But, on the other hand, we want those things that are said seriously and in a considered fashion to be fixed in the memory and to remain in the mouth of many people. Therefore, saint Job too wants to show that it was not with a deeply troubled mind that he had poured out what he had said, but that his words were well arranged and filled with truth and reason. Thus, he desires that they be written not merely on paper but also engraved on "), _c('i', [_vm._v("lead")]), _vm._v(" and "), _c('i', [_vm._v("flint stone")]), _vm._v(", so that they may be preserved unto a great age and for a long time.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-338"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:25 For I know that my Redeemer lives, and in the last day I shall rise out of the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("[The Greek has] “For I know that he is eternal who is about to deliver me on the earth; my skin that endures these things will rise again.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-267",
      "id": "ap_ntb-267-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" "), _c('i', [_vm._v("For I know that my Redeemer lives")]), _vm._v(". The Greek has “For my body that draws such things will rise again.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-268",
      "id": "ap_ntb-268-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _c('i', [_vm._v(" For I know that my Redeemer lives")]), _vm._v(". Just as he wanted there to be testimony to his sound statements, if he defended them from oblivion by having the writings carved into metals, so he gave the reason why he wanted them consigned to a longer remembrance—namely, in order that they would receive testimony of approval by a judge’s verdict when brought into examination. Therefore, being filled with a prophetic spirit, he foretells our Savior and his incarnation and resurrection, as he says, "), _c('i', [_vm._v("I know that my Redeemer lives, and in the last day I shall rise out of the earth")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-339"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:27 Whom I myself shall see.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he was afflicted by his present troubles, by the revelation of the Holy Spirit he recognizes that mysteries are coming later on, clearly to bring remuneration and consolation for his virtue. Thus, he says that he will see God clothed with the nature of his own flesh."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-269",
      "id": "ap_ntb-269-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])]), _vm._v(" This very clearly concerns the mystery of the Lord’s incarnation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-270",
      "id": "ap_ntb-270-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" And this does not have in view a testimony to a lesser grace, because he so fully and openly declares his hope in the resurrection already at that time! "), _c('i', [_vm._v("Whom I will see")]), _vm._v(". In this passage the Greek is far different."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-271",
      "id": "ap_ntb-271-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-340"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_52",
      "title": "52"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:28 Why then do you say now, Let us persecute him?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since, therefore, in that judgment that I now already behold with the eyes of my mind, the faithfulness of one’s works and statements is to be revealed, why do you want to claim obstinately by your statements that I am guilty? Why do you endeavor to affix guilt on me, which my conscience does not acknowledge?")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-341"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("19:29 Flee then from the face of the sword.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, by repentance and amendment prevent the wrath of the coming avenger’s sentence of judgment.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-032"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 20]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-342"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:1-2 Then Zophar the Naamathite answered and said, Therefore various thoughts succeed one another in me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since saint Job said that he was justly complaining, if not of the kind of punishment but of the amount, Zophar tries to snatch even this from him in the speech of the respondent. Thus, he says that Job was enduring things less than his merits deserved. For indeed he says that he has reached this conclusion not from any prejudice or dislike but from a due weighing of both sides."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-272",
      "id": "ap_ntb-272-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" For among the excuses of Job, by which he said that he did not deserve such a great calamity, Zophar says that the umpire, as it were, established even the appearance of the things that Job suffered. And it seemed more correct to fasten sins on Job himself, not a charge of injustice on God.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-343"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:3 The doctrine with which you reprove me, I will hear, and the spirit of my understanding shall answer for me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Although the things that you allege move me in some measure—namely, when you say that the reckoning of punishments exceeds the measure of sin—nevertheless, by carefully considering that what the spirit’s intention suggests is true, the defect is to be found in your merits rather than in God’s justice.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-344"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:4-5 This I know from the beginning, since man was placed on the earth, that the praise of the wicked is short, and the joy of the hypocrite but for a moment.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Not without reason he adds what is lighter to what is heavier—that is, when he recorded "), _c('i', [_vm._v("hypocrite")]), _vm._v(" after "), _c('i', [_vm._v("wicked")]), _vm._v("—but [he said this] to touch him properly whom he thought always had the outward appearance of a holy man but with an awareness of guilt. "), _c('i', [_vm._v("Praise of the wicked")]), _vm._v(". He has recorded "), _c('i', [_vm._v("praise")]), _vm._v(" for glory and honor. "), _c('i', [_vm._v("And the joy of the hypocrite but for a moment")]), _vm._v(". If the censure of equity demanded this, that the prosperity of the wicked be short, it follows that adversities and griefs should be longer. You see, therefore, that your voice of complaint is not able to suit you, due to the very status of the judgments.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-345"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:6-7 If his pride mount up even to heaven, and his head touch the clouds, in the end he shall be destroyed.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By a variety of comparisons he proceeds to show the fleeting glory of the wicked. “And those who had seen him shall say, Where is he?” A sudden change in conditions customarily causes a sense of wonder.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-346"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:8 As a dream that flees away, he shall not be found.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is similar to what the psalm says: “They have suddenly ceased to be, they have perished by reason of their iniquities, as the dream of them that awake.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-273",
      "id": "ap_ntb-273-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-347"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_53",
      "title": "53"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:9 The eye that had seen him shall not see.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is not that the same person does not meet the eyes of those who see, but that the whole sphere of action has been changed by the introduction of the calamity. “Neither shall his place any more behold him.” "), _c('i', [_vm._v("Place")]), _vm._v(" is recorded here not for a piece of ground or a building but for social standing and honor.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-348"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:10 His children shall be oppressed with want, and his hands shall render him his sorrow.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Appropriate fruit will follow his works, and the wages will reveal the merit of the preceding action.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-349"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:11 His bones shall be filled with the vices of his youth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He did not say that the sins of youth are to be imputed to the old man, but he says that he so continuously practiced the vices to which a youth was accustomed that he dragged these things out all the way to old age. And as though he was not content with having indicated the final period of life, he adds, “And they shall sleep with him in the dust.” It is as if he were saying, He reached the final end of life with intimate knowledge of disgraceful acts.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-350"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:12 For when evil shall be sweet in his mouth, he will hide it under his tongue.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he had said "), _c('i', [_vm._v("sweet")]), _vm._v(", he recorded "), _c('i', [_vm._v("mouth")]), _vm._v(" and "), _c('i', [_vm._v("tongue")]), _vm._v(", which have the proper function of judging tastes. "), _c('i', [_vm._v("For when evil shall be sweet in his mouth")]), _vm._v(". He was brought by the long practice of sinning to the point that no horror over the vices arose in him but delight. And zeal came along to keep him from losing out on any evil habit. "), _c('i', [_vm._v("He will hide it")]), _vm._v(". That is, he carefully guards it.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-351"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:13 He will spare it and not leave it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has referred to the affection of a lover. For we are accustomed to treat more mildly those things that we embrace with passionate love ("), _c('i', [_vm._v("amore")]), _vm._v("). For he expressed this in the things he added:")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-352"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:14 His bread shall be turned in his belly, the gall of asps within.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As long as he was speaking about tastes, he linked the services of mouth and tongue. When he now comes, as it were, to dissolved food, he has fittingly found a place for the belly, where all food ordinarily is sent through the mouth and tongue. Now what he wanted to say is this: That which he had believed to be sweet, he will not only experience it as bitter but will find it even to be lethal.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-353"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:15 The riches that he swallowed, he shall vomit up.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has preserved the form of the comparison undertaken. Thus, what he had said was first taken in by the mouth, and was later sent to the belly, he added that it is to be vomited up.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-354"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:16 He shall suck the head of asps, and the viper’s tongue shall kill him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The nature of its own works will be harmful to it, so that the venom derived from it becomes the cause of its death.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-355"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:17 Let him not see the streams of the river, of the brook of honey and of butter.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("After the invocation of so many evils, it does not seem for the sake of any increase that he added that he will not have an abundance of favorable conditions. Whence, lest that which the conclusion of the speech asked for seem forgotten, he has denied in an exchange of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_54",
      "title": "54"
    }
  }, [_vm._v("good things he will have an end of grievous things. "), _c('i', [_vm._v("Let him not see the streams of the river")]), _vm._v(". The Greek has “May he not see his herds coming to the milk-pail.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-274",
      "id": "ap_ntb-274-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-356"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:18 He shall be punished for all that he did and yet shall not be consumed.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is not oblivious to the charge of his response. For since saint Job had pleaded about the excessiveness of his own sufferings, Zophar himself says that if he is enduring all these adversities that he has recounted, yet he suffers less than he deserves; that is, the punishment cannot be equated to or exhaust the merits of his faults.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-357"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:19 Because he broke in and stripped the poor.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Lest the general nature of his statements not graze him whom no evidence of sins had convicted, Zophar tries to prove him already guilty and pernicious by specific cases. “He has violently taken away a house which he did not build.” That is, he did not correct what he had done wrongly by a subsequent repentance.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-358"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:20 And though he has the things he had coveted, he shall not be able to possess them.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When the vengeance that is owed takes away the enjoyment of sin.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-359"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:21 There was nothing left of his meat, and therefore nothing shall continue of his goods.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Zophar wants to brand Job with the vice of avarice and say that his inhumanity was the reason for his poverty.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-360"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:22 When he shall be filled, he shall be brought into straits.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He wanted what he said to provide proof of Job’s great inhumanity, that the abundance of possessions, which often made him inebriated, brought to him the disposition of generosity and sharing. "), _c('i', [_vm._v("When he shall be filled")]), _vm._v(". This is said with a change of the tense—that is, when he had been filled and by the ingestion of food had reached the point of a distended stomach and a bellyache.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-361"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:23 May his belly be filled, that [God] may send forth the wrath of his indignation on him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Here too, just as higher up, the disputant was moved, as it were, by the credibility of things and breaks out with the feelings of one wishing for something, with the orderly sequence plainly overturned. For when the examination of judgment has been removed, we approve of those things that we want to happen, whereas here he pursues them by his wishes, as if the consideration had already been weighed in the balance. “And rain down his war on him.” The constant persistence of his scourging seems to imitate the concourse of raindrops. By the continuance of the evils, [God] never allows him peace, that is, rest.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-362"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:24 He flees from weapons of iron and shall fall on a bow of brass.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The preceding evils are followed by others that are more severe.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-363"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:25 [The sword] is drawn out, and comes forth from its scabbard, and glitters in its bitterness; they shall go and come upon him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To increase the attack, he does not want the hostile persons to encounter him, but that the very weapons be taken up against him, and the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_55",
      "title": "55"
    }
  }, [_vm._v("grim things themselves and the hostile elements to rise up against him.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-364"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:26 All darkness is hid in his sight."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-275",
      "id": "ap_ntb-275-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The darkness grows dim by its own spreading out in view of the space of atmosphere. It becomes heavier by the denseness and gathering. “Has devoured him.” The Greek has “A fire that burns will devour.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-276",
      "id": "ap_ntb-276-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" “A fire that is not kindled.” That is, continuous. It does not require the service of human beings for its maintenance.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-365"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:27 The heavens shall reveal [betray or expose] his iniquity, and the earth shall rise up against him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Each of these elements will experience rage in view of his offenses ("), _c('i', [_vm._v("meritis")]), _vm._v(").")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-366"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("20:28 The offspring of his house shall be exposed.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Stripped for eradication."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-277",
      "id": "ap_ntb-277-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])])])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-033"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 21]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-367"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:1-2 Then Job answered and said, Hear, I beseech you, my words, and do penance.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Their arguments attempted to cause the possibility of Job being convicted as a guilty man. With two propositions they said, If you are innocent, he who afflicted you is unjust; but if he is just, you are proven completely guilty. He promises that he will expose these arguments with such ease that he would not merely compel them to silence but even to repent of their statements and opinions. "), _c('i', [_vm._v("Hear, I beseech you, my words")]), _vm._v(". He is confident about the uprightness of his response, and demands patient ears from them, so that his speech received in silence may not merely shut out their contradicting voices but even compel the impeachment of their previously spoken statements. "), _c('i', [_vm._v("And do penance")]), _vm._v(". He says not to Zophar alone but to all of them that they should receive his statements with attentive ears, since their verdict against him was equivalent and similar.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-368"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:4 Is my debate against man, that I should not have just reason to be troubled?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Neither scorn for the injustice nor vengeance consoles the sensation of my pain. For if he who harasses me were inferior, I would not grieve but summon the magnanimity of soul. But the equivalent thought of storing up the injustice would have averted the sting of the pain. But now the just cause of my grievance presses down on me, since I am beset by him whom I admit stands forth prominently in the distance on a singular height.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-369"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:5-6 Hearken to me and be astonished, and when I remember, I am very afraid.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Hard and excessive questioning was set forth at that time. He says not only that they must be filled with astonishment but even that they themselves endure a lot of fear and trepidation by reflecting on deep things. For even the present proofs testify to how much the Creator’s providence or justice over human affairs is assailed: providence, when the affairs of mortals are reported to be uncertain and without governance; justice, when no diversity of merits is weighed in the movement of the scales. You said that all that happens has in view the judgment of God; how then are the opposing examples contested? And he added, “Why then do the wicked live?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-278",
      "id": "ap_ntb-278-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-370"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_56",
      "title": "56"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:7-8 Why then do the wicked live, and why are they advanced and strengthened with riches? Their seed will continue before them, a multitude of kinsmen, and of children’s children in their sight.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Contrary to the thought of Zophar, who had said, “I know that the praise of the wicked is short, and the joy of the hypocrite but for a moment,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-279",
      "id": "ap_ntb-279-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" he describes not only the many favorable circumstances in which the wicked abound but also that these conditions last for a long time.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-371"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:9 Their houses are secure.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One should take note with what additions of successive things he is careful to augment the first things.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-372"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:10-12 Their cattle have conceived and do not abort; their cow has calved and is not deprived of her offspring. Their children dance and play. They take the timbrel, and the harp, and rejoice at the sound of the organ.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He summarizes everything that characterizes their life that is not merely abundant but even joy-filled. It is full of affection and has much solace, heaps of gold and silver, fertile herds and flocks. And lest these things seem to have been reserved for rural custom, he added those things that the arts invented to soothe the ears or that urbane lewdness devised.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-373"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:13 They spend their days in wealth, and in a moment they go down to the underworld.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A respondent could object, But those things that have been recounted will be altered by the succession of sad things. To answer this he has added that [the wicked] so enjoy constant delights that the swiftness of death banishes even the sad feelings that ordinarily arise from the imminent end of life.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-374"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:14-15 Who have said to God, Depart from us, Who is the Almighty, that we should serve him?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To convict the judgment of his fellow disputant he had set forth two things to himself to show that some are wicked and yet happy. Therefore, he fully described the portion of happiness through its outward forms; it remains to show the wickedness of the same men by open proofs.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-375"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:16 Yet because their good things are not in their hand, may their counsel be far from me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he had interpreted the prosperity of the wicked by a lengthier speech, lest he seem to approve it likewise by a judgment, he has revealed his own thought by the insertion of this statement: "), _c('i', [_vm._v("Yet because their good things are not in their hand, may their counsel be far from me")]), _vm._v(". That is, since they boast over those things that chance can both give and take away,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-280",
      "id": "ap_ntb-280-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])]), _vm._v(" I do not want to be associated with their wealth under such a judgment.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-376"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:17-18 How often is the lamp of the wicked put out? They shall be as chaff before the face of the wind, and as ashes that the whirlwind shall scatter.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He sets forth as things that are harmful to his own case statements that agree with the sense of those men. For if we wish to understand this as said under the persona of saint Job, he will be found not to be refuting but agreeing with their judgment. Therefore, in order to continue in the course of the quarrel, he inserts things that he will make void.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-377"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_57",
      "title": "57"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:19 God has preserved the sorrow of a father for his children.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He himself proposes for himself what they could have said, as if he were to say, You will perhaps say this, even if the wicked man himself does not suffer any adversity per se, yet a vengeful reproach will rage against his posterity; therefore he added, “For what is it to him?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-281",
      "id": "ap_ntb-281-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" That is, when by the intervention of death he is deprived of all sensation, he will not be struck by grief over the affliction of his children.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-378"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:21 For what is it to him?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Up to this passage he has been interpreting the objections of his friends.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-379"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:22 Shall anyone teach God knowledge, who judges those that are on high?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the insertion of this single line, he has solved the question that had countered his own statements. For he seemed to have flung the charge of ignorance at God, if he who had sinned did not lay claim to it for himself but in someone else. Therefore, saint Job says that he knows indeed that knowledge of all things and complete knowledge are with God. Yet they who have said that all things are done by the judgment of justice are not able to prove rationally how these things are done. For indeed, even I confess that often there is vengeance against the wicked; yet it does not follow that wherever affliction exists, fault is also found. But by what rationale does God punish some of the wicked, but he allows others to go away unpunished? And why does he permit others to experience adversities though they have not sinned? It is not ours to know this. For he is the one who by the depth of his own wisdom can both refute the clever and who alone can have true judgment. When this line that he had inserted is removed, a contextually coherent meaning links the things below with the things above. "), _c('i', [_vm._v("Who judges those that are on high")]), _vm._v(". Here one should understand "), _c('i', [_vm._v("those that are on high")]), _vm._v(" as the angels.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-380"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:23-25 One man dies strong, healthy, rich and happy; but another dies in bitterness of soul without any riches.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In order to refute the thought of those men, who wanted to refer everything to the equity of the divine judgment, two cases are set forth, unequal both in respect to merits and outcomes, so that it may clearly appear that in the state of things in the present the justice that they were affirming is lame.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-381"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:26 And yet they shall sleep together in the dust.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Though there may be a great divergence between the lives of the rich and the poor, yet a similar and equal end will overtake them both.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-382"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:27 Surely I know your thoughts.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("What you have said is exposed as false by the evidence of things that occur. But he has nicely recorded "), _c('i', [_vm._v("I know")]), _vm._v(", in order to show that the reason he easily tore down what they had said is because he had understood it.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-383"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:28-29 For you all say, Where are the tabernacles of the wicked? Ask any one of them that go by the way, and you shall perceive that he understands these same things.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He shows that it is a matter of no great wisdom, and one that could fall into the mouth of the common crowd, to bring a speech to a close by using a general accusation against vices and to accuse one whom he regards as guilty without naming any specific instances of sins."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-282",
      "id": "ap_ntb-282-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-384"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_58",
      "title": "58"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:31 Who shall reprove his way to his face, and who has repaid him what he has done?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is obvious and ready at hand to say that punishment awaits all the wicked and no sins can go unpunished. But the following is a matter that pertains to the repository of reason, to convict the one whom you are accusing by bringing facts out into the open without any verbal jeering.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-385"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:32 He will be led to the tombs, and will watch in the heap of the dead.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("["), _c('i', [_vm._v("He will watch")]), _vm._v("] for “he will be,” since the one thing depends on the other, for no one "), _c('i', [_vm._v("watches")]), _vm._v(" unless he first "), _c('i', [_vm._v("is")]), _vm._v(". For the sake of doing justice to the coherence of the context, he recorded "), _c('i', [_vm._v("he shall watch")]), _vm._v(" for “he will be.” Here is another way: But since he is dead, would you perchance say that punishment has been exacted against him? From the same fact that is common to the good and the evil, all guilty persons cannot be convicted; for where that one went, many went before, and all will follow on the same journey.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-386"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:33 He has been sweet to the gravel of Cocytus.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “He has been sweet to the stones of the torrent.” "), _c('i', [_vm._v("He has been sweet to the gravel of Cocytus")]), _vm._v(". As if already long ago the lower world seems to have selected him as desired. Now he recorded the name "), _c('i', [_vm._v("Cocytus")]), _vm._v(" from the usage of common speech,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-283",
      "id": "ap_ntb-283-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])]), _vm._v(" just as he followed the usage of those who call the names of the stars Arcturus, Orion, and Hyades."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-284",
      "id": "ap_ntb-284-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-387"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("21:34 How then do you comfort me in vain, whereas your answer is shown to be repugnant to truth?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He accuses them by the witness of facts that they cannot prove him guilty concerning his sufferings. He says, Though many regard my life based on the judgment of the wicked, merits are not to be appraised based on outcomes. Therefore, it is clear that you profess yourselves to be my friends in appearance, but by your words you fill out the role of enemies. For you came to alleviate my miseries. Instead you make them far worse by your speeches.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-034"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 22]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-388"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:1 Then Eliphaz the Themanite answered and said.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Eliphaz saw that both his own verdict and that of his friends was taken apart by the response of saint Job. He discerns that he is unequal to the task of finding solutions to the things that had been set forth. So he takes refuge in the defense of prejudice and sets the greatness of the Creator in opposition to the question. It is as if he were to say, You have summoned the examples of facts and attempted to show that in marking down the merits of men as paid, justice did not hold fast to its own rights, and that the prosperity of the wicked was repugnant to the equity of judgments, as you have inferred by your great knowledge. To solve this objection, even if we could not produce any rational explanation, yet it is easy for God to show why he acted in such a way.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-389"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:2 Can man be compared with God?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The cleverness of your argument has shown that the wicked prosper contrary to the dignity of the scale of justice, so that, as logical consistency would suggest, it would be "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_59",
      "title": "59"
    }
  }, [_vm._v("understood that the morally upright are exposed to afflictions, and thus you are proven innocent when you are afflicted. If therefore you are not guilty at all, then the one who afflicted you is proven to be a doer of wrong. But by no argument could you tear this from me, for I do not believe that there is injustice in God’s judgments. And he can render a rational account for his own works, by the greatness of his knowledge, something that I am incapable of doing.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-390"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:3-4 What does it profit God if you be just? Will he reprove you out of fear?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We indeed are moved to every action by a twofold affection—namely, by hope or fear—while we either want something to profit us or we take precautions lest it do us harm. But God is estranged from each of these necessities. For he neither needs our goods nor is he helped by them. Nor is he ever frightened by evils; that is, he gains nothing from our devotion. Nor does an obstinate mind steal anything from him. What cause then has aroused him to destroy you, if not the excess of your iniquity?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-391"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:6-7 For you have taken away the pledge of your brethren without cause.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Higher up saint Job had said that what could be sung by those that go by the way pertains to common speech, to wind up a case against the vices by a general oration, and fail to reveal the person’s guilt by specific cases."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-285",
      "id": "ap_ntb-285-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")])]), _vm._v(" Therefore, Eliphaz now attempts to fasten these specific instances of sins on him, but he does so more by way of calumny than conviction. “Without cause you have stripped the naked of their clothing, [failed] to give water to the weary, and withdrawn bread from the hungry.” He heaps up and augments these things that he has proposed in opposition, so that Job’s character, which was not content with sinning moderately, might appear all the more abhorrent. For it seemed tolerable that "), _c('i', [_vm._v("you have taken away the pledge of your brethren")]), _vm._v(", especially if the terms of some contract compelled this; but he adds "), _c('i', [_vm._v("without cause")]), _vm._v(", so as to increase the wicked crime with which he was accusing him. Likewise, those other things he adds proceed to weigh him down with an abundance of accusations.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-392"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:10 Therefore, you are surrounded with snares, and sudden fear troubles you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had said that [Job] had sinned not triflingly and as if from a lack of strength, but grandiosely and with great force. Therefore, he boldly asserts against him that he has been punished, so that the transgression and punishment appear to be paid out in the same moment. "), _c('i', [_vm._v("And sudden fear (")]), _vm._v("formido"), _c('i', [_vm._v(") troubles you")]), _vm._v(". Elsewhere it says, “fortitude ("), _c('i', [_vm._v("fortitudo")]), _vm._v(").”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-393"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:11 And did you think that you should not see darkness?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("You also added this to the charge of your evil deeds, that you did not believe that revenge would follow. At any rate, if you had ever thought about it, it would have called you back from the dangerous path of your works or frightened you less by being already foreseen.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-394"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:12-14 Do you not think that God is higher than heaven? And you say, What indeed does God know? And he judges, as it were, through a mist. The clouds are his covert, and he walks about the poles of heaven.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is an indication of a sacrilegious mind to sin with such carefreeness that it does not believe that the witnessing eyes of the judge are moved by the things it is doing, and that the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_60",
      "title": "60"
    }
  }, [_vm._v("sharp-sightedness of the Knower is excluded from the knowledge of the facts through this inane means, and that it thinks that God cannot approach nearer, in view of the immensity of locations, and be present to all things as the arbiter of the facts. "), _c('i', [_vm._v("And he walks about the poles of heaven")]), _vm._v(". The Greek has “And he walks about the circle of heaven.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-286",
      "id": "ap_ntb-286-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-395"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:15 Do you desire to keep the path of ages, which wicked men have trodden?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, to enter down those same roads by which they walked who revealed the arrogance of their spirit at the beginning of the world by building the tower."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-287",
      "id": "ap_ntb-287-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" Here is another way. By such perversity of thought you are proven clearly to be willing to take up arms against God, and to imitate the giants who tried to climb into heaven by the stubbornness of their mind."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-288",
      "id": "ap_ntb-288-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-396"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:16 Who were taken away before their time.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Their wicked ventures merited that the length of their life be cut short by the incited severity. “And a flood has overthrown their foundation.” Since they were utterly wiped out by a deluge, he rightly says, "), _c('i', [_vm._v("A flood has overthrown their foundation")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-397"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:17 Who said to God, Depart from us.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Not that he uttered these words of sacrilege with his tongue but that their works and wicked actions expressed this. For they were doing the sorts of things that seemed to be casting God out from themselves, and they thought that he could do nothing."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-289",
      "id": "ap_ntb-289-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-398"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:18 Whereas he had filled their houses with good things.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The outpouring of his generosity nourished prosperity, prosperity fed their arrogance, arrogance led ultimately to sacrilege. Thus do blessings become the tinder of sinning for those who use them badly.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-399"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:19 The just shall see, and shall rejoice, and the innocent shall laugh them to scorn.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When criminal actions are checked by punishment, the pursuit of virtues grows stronger and a joyful innocence pleads for its fruits.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-400"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:20 Is not their exaltation cut down, and has not fire devoured the remnants of them?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He provides proof, as it were, of those things that he had said before. Thus, he says that those men of arrogance, of whom Job was an imitator, are not merely "), _c('i', [_vm._v("cut down")]), _vm._v(", but they have even become extinct to posterity, since fire went after their roots.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-401"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:21 Submit yourself then to him, and be at peace.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Leave off the brash voice of your complaints, he says, and hold in check the turmoil of your stomach and heart, so that when the waves of your thoughts subside, you can attain to the hope of salvation with repentance as your guide.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-402"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:22 Receive the law from his mouth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Be a hearer, be a disciple of that which has been divinely promulgated, whose judgment "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_61",
      "title": "61"
    }
  }, [_vm._v("this is, which seems clearly imprinted in these things, so that it crushes the proud and raises up and fosters the lowly.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-403"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:23-24 If you will return to the Almighty, you shall be built up, and he shall give flint for earth, and torrents of gold for flint.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he had said previously, "), _c('i', [_vm._v("you shall be built up")]), _vm._v(", fittingly he has promised that "), _c('i', [_vm._v("flint")]), _vm._v(" is to be given him "), _c('i', [_vm._v("for earth")]), _vm._v(". On flint are made the foundations of a house that will not fall."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-290",
      "id": "ap_ntb-290-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])]), _vm._v(" But in light of the abundance of all things, the flint, which is not advantageous for growing crops, is to be turned into "), _c('i', [_vm._v("torrents of gold")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-404"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:25 And the Almighty shall be against your enemies, and silver shall be heaped together for you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Not only will you be covered with divine protection, but you will even be given an abundance of all things.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-405"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:26 Then you shall abound in delights in the Almighty.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Almighty will provide you with such a reason for joyful delight, that whatever tastes sweet, smells pleasant, feels soft would seem to flow into your senses from him. “And you shall lift up your face to God.” It is a testimony of confidence if no guilt turns one’s face toward the ground.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-406"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:28 You decree a thing, and it shall come to pass to you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Things worthy of approval and just are vowed,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-291",
      "id": "ap_ntb-291-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])]), _vm._v(" and they are allotted an easy, effectual achievement.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-407"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("22:30 The innocent shall be saved, but he shall be saved by the cleanness of his own hands.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Supported by penitence, you will be freed from guilt in such a way that you would appear never to have been in the wrong.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-035"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 23]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-408"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:1-2 Then Job answered, and said, Now also my words are in bitterness.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had not been so battered by the speeches and arguments given earlier that he should be turned to bitterness over the curses of his friends, above and beyond the harshness of the pain. For a general indictment of vices had not dislodged anything from the dignity of his conscience. Therefore, he replies with less mental turmoil. But when he began to be indicted with specific criminal charges, he feels the goads of greater anger. And he says, Now plainly there is a just cause of sadness for me, not only in light of the bitterness of my wounds but also for the reproach of your insults. "), _c('i', [_vm._v("Now also my words are in bitterness")]), _vm._v(". Now plainly I experience worse feelings of my pain; a deeper wound is pressed into me. Having laid aside all reverence, you open wide your mouths in open recriminations.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-409"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:3 Who will grant me that I might know and find him, and come even to his throne?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since they have thus conspired in falsehoods as testimony against me, equity alone can vindicate me from the attorney’s reproaches. Therefore, that very tribunal of the judge is what I must seek by my prayers, so that when my complete case is brought into the open, I may shout out freely before him concerning my afflictions, inquire after a rational accounting for my miseries, and at least find out the reason when he responds.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-410"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_62",
      "title": "62"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:5 That I might know the words that he would answer me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Whether the witness of your false charge were to approach, or that of my conscience.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-411"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:6-7 I do not want him to contend with me with much strength; let him propose equity against me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As far as I know by the witness of my conscience, I see that these things that I suffer have to do with his power alone, not his justice. Therefore, I desire that the judge’s knowledge be granted to me, since equity alone can cast a favorable vote for me.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-412"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:8-9 If I go to the east, he does not appear; if to the west, I shall not understand him. If to the left, what would he do? I shall not take hold of him; if I turn myself to the right, I shall not see [him].")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had said, “Let him propose equity”;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-292",
      "id": "ap_ntb-292-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])]), _vm._v(" that is, let him make the moments of those debating equal. Let him not be inferior in advantages and overwhelmed. Let him first reckon that he is powerful against the one to whom the affair belongs, then that he is invisible, thirdly that he fills and contains every part of the world by his immensity. For by the names "), _c('i', [_vm._v("east")]), _vm._v(" and "), _c('i', [_vm._v("west")]), _vm._v(", "), _c('i', [_vm._v("right")]), _vm._v(" and "), _c('i', [_vm._v("left")]), _vm._v(", he wanted to indicate the four zones of the world.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-413"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:10 But he knows my way and has tried me as gold that is tested through the fire.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He adds this to increase the disparity, that though I may not be able to see how great he is, he in truth knows me in such a way that nothing can be hidden from him, even of my works. For he has often cast me for examination like a lump of shining metal into the furnace.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-414"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:11 My foot has followed his steps.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The reproach of criminal acts wrenched from him a confession to his own praise, with a somewhat concealed sense of shame. He discloses his virtue in order to drive out the heap of vices [of which he had been accused].")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-415"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:12 I have not departed from the commandments of his lips.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says that the "), _c('i', [_vm._v("commandments of God’s lips")]), _vm._v(" is the power of reason stamped on his nature. It was able to teach human beings justice after the manner of the law, as the apostle also says: “For when the Gentiles who do not have the law do by nature the things which are of the law, though not having the law, they are the law to themselves.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-293",
      "id": "ap_ntb-293-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])]), _vm._v(" “And the words of his mouth I have hid in my bosom.” I have applied diligence of watchfulness to keep from slipping through negligence.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-416"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:13 For he is alone, and whatsoever his soul desires, that he does.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He reveals the reason that makes him stick to the narrow paths of God without deflection from the tracks. This compels him carefully to keep his commandments. He says, I conceived with my mind this esteem for God, because he is the only one for whom this name [of God] is truly fitting. As for those who are called gods, he does not admit any of them into the company of his power. For everything is easy for God to do, and nobody can resist his power and will.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-417"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_63",
      "title": "63"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:14 And when he shall have fulfilled his will in me, many other like things are also at hand with him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He wants to show that his sufferings are proof of the divine power, and therefore he added that he could work "), _c('i', [_vm._v("like things")]), _vm._v(" with equal power.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-418"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:15 And therefore I am troubled at his presence.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When I have recourse to my conscience and find nothing in it that is averse to the light, and I consider the proofs of his power, I am upset by the great ambivalence of the counsel, whether it discusses the whole matter to the best of their ability or feigns its own justice by some provision to suit the occasion.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-419"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:16 God has softened my heart.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Whatever strength he had fostered in me by virtue of his patience has wasted away the whole of the scourge that I suffer and by the ignorance of counsel.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-420"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("23:17 For I have not perished because of the darkness that hangs over [me], neither has the mist covered my face.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has recourse to the testimony of his conscience, and confidently declares that the reasons for his outcome come not from the defilement of his works, which rejoiced in the light, once the thick darkness of night had flown away.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-036"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 24]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-421"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:1-2 Times are not hidden from the Almighty.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("[Job] raises the same question he had discussed previously, but now with a profession of his faith. And moreover he says that he certainly knows that by marking down as paid the merits of human beings, justice will pursue the portions of his reproach; but, in the present, many things happen that seem to negate judgment. And by this continuous course of meaning all the way till the end of his speech ("), _c('i', [_vm._v("eclogae")]), _vm._v("), he describes the crimes of the wicked. He says, "), _c('i', [_vm._v("Times are not hidden from the Almighty")]), _vm._v("; that is, in his knowledge there dwells a full awareness of all our moments. It is as if he were to say, God does not disregard any time of our works, even as we change them constantly; yet we, who touch him with the devotion of our mind, do not know what days he weighs out for our examination by patient endurance, which days he weighs out for postponement.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-422"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:2 Others removed the landmarks.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It must be noticed, in this reproof of vices, that they are reckoned either lighter or heavier according to how they are handled with respect to the virtue of the soul. Thus, saint Job and his friends are influenced differently; the friends only accuse the acts of inhumanity, whereas Job describes the crimes of iniquity, violence, robbery, lewdness, pride, and impiety. “They have taken away flocks by force, and fed them.” He professes boldly that he sins who is bold enough to hide the bad things he does. The Greek has “They have carried off the flock with the shepherd.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-294",
      "id": "ap_ntb-294-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-423"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:3 They have driven away the ass of the fatherless; they have taken away the widow’s ox for a pledge.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("His condition of being exposed to public commiseration, which in itself provoked a feeling of humanity in view of his abandonment (that is, the fatherless and the widow), this was unable to bridle the ferocity of their greed.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-424"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_64",
      "title": "64"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:4 They have overturned the way of the poor.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("While nothing satisfies avarice, they increased their own wealth even by the meager income of the poor, which they sought by continuous effort from daily work for their own survival. Here is another way. When the cause of the poor had come into their judgment, the false charges that were raised drove out the appeals for justice.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-425"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:5 Others like wild asses in the desert go forth to their work.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Two accusations are being made simultaneously (namely, of arrogance and robbery) because they are carried without bridles with a neck free from the yoke of common fairness through roads exposed to plundering. “And by watching for a prey they get bread for their children.” He is careful to express the freedom of rapine by an example.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-426"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:6 They reap the field that is not their own.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He runs through each form of evildoing that wickedness was accustomed to carry out.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-427"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:7 They send people away naked.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is more moderate than his friends, who through the anger of their mind were oblivious to a sensible reproach, and said, “You have despoiled the naked.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-295",
      "id": "ap_ntb-295-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-428"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:8 Who are wet with the showers of the mountains, and having no covering embrace the stones.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says, They are so in need of a hovel, due to the distress of their extreme poverty, and they are exposed to rainstorms, as the mountains, not roofs protect them from the rain. And on this account they are forced to take refuge either in caves or in rocks exposed to the winds. "), _c('i', [_vm._v("Who are wet with the showers of the mountains")]), _vm._v(". This whole passage seems to have in view the example of the wild ass that was used in another exposition."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-296",
      "id": "ap_ntb-296-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])]), _vm._v(" Thus, the acts of rapine of violent men are better understood using a description of a stupid wild beast. Thus, his words, "), _c('i', [_vm._v("Who are wet with the showers of the mountains")]), _vm._v(", seems to be more fitting for wild asses.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-429"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:10 From the naked and them that go without clothing and from the hungry they have taken away the ears of corn.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He diligently adds something that could increase the charge of wickedness.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-430"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:11 They have taken their rest at noon among the stores of them.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One sins with the brow exposed when due to ingrained habit extending over a long time one does not fear the testimony of the evil work that is in those things. “Who after having trodden the winepresses suffer thirst.” With these words he expresses avarice that does not know how to be satisfied and that always seeks other people’s things.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-431"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:12 Out of the cities they have made men to groan, and God does not suffer it to pass unavenged.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is what we took note of higher up, that saint Job indeed admits that everything is to be brought before the divine examination, yet the form of judgment is not proven in the present. "), _c('i', [_vm._v("Out of the cities they have made men to groan")]), _vm._v(". It pertains to a tyrannical rule to show no respect for locations and for wrong to exist instead of law.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-432"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_65",
      "title": "65"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:13 They have been rebellious to the light, they have not known his ways.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since it is a proper function of light to keep the tracks of travelers from going astray, he expressly calls those who continue going down perverse roads in this life "), _c('i', [_vm._v("rebellious to the light")]), _vm._v(".")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-433"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:14 The murderer rises at the very break of day, he kills the needy and the poor man; but in the night he will be as a thief.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has indicated two things: that he is not lazy when it comes to doing evil, and he allows no time to pass by without sinning.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-434"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:15 The eye of the adulterer observes darkness, saying, No eye shall see me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has expressed what is quite common for the depraved, that they do not want to entrust to a witness the base things they do; or else, when they dash headfirst into wicked deeds, they are animated more by the hope of concealment.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-435"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:16 He digs through houses in the dark, as in the day they had appointed for themselves.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He was not content with having hit on the custom of adulterers in words only, but he puts their deeds as well on display to increase the abhorrence, and he says that they are not afraid to break through the fortifications of houses in order to perpetrate crimes. “And they have not known the light.” With eyes of shame dug out, they drive strangers from the light of moral integrity. "), _c('i', [_vm._v("And they have not known the light")]), _vm._v(". Elsewhere it says, “By day they have sealed themselves”;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-297",
      "id": "ap_ntb-297-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181")])]), _vm._v(" that is, they have concealed themselves so that they were unknown, as are those who display the outward form of being honest but live as men of crime and as thieves.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-436"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:17 If the dawn suddenly appear, they regard it as the shadow of death.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("They hate that by which they know they are exposed, and they love that by which they think they can be veiled.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-437"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:18 He is light on the face of the water; cursed be his portion.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “He is light from the face of the water”; that is, like water he will easily slip by, so that he is unknown to all. "), _c('i', [_vm._v("He is light upon the face of the water, cursed be his portion")]), _vm._v(". Out of horror for the crimes, he erupts into the words of a man cursing. He says, "), _c('i', [_vm._v("He is light upon the face of the water")]), _vm._v("; that is, he is snatched away to destruction with such great ease that with the swiftness of one perishing he overcomes the waters that are borne straight downward. “Let him not walk by the way of the vineyards.” By the term "), _c('i', [_vm._v("vineyard")]), _vm._v(", he wants him to be driven out from the habitation of all land that is cultivated.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-438"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:19 Let him pass from the snow waters to excessive heat, and his sin even to the underworld.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The expression is twisted around: as snow disappears and is melted into water by the heat, so he desires the vigor of the man to be dissolved whose evil deeds he described earlier in his speech.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-439"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:20 Let mercy forget him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he had said previously, “and his sin even to the underworld”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-298",
      "id": "ap_ntb-298-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")])]), _vm._v("—that is, he is absolved by no intervention of pardon—he has well added, "), _c('i', [_vm._v("Let mercy forget him")]), _vm._v(", so that it concerns not pardon but anger from the horror over his works. “May worms be his sweetness.” Since the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_66",
      "title": "66"
    }
  }, [_vm._v("fruit of works customarily influences the spirit of the one who exerts himself in his labor, may a delightfulness of flavor arise in this one too, in view of those things that he has carried out, of such a kind that would soothe his senses!")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-440"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:21 For he has fed the barren.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is describing the vice of luxury and fornication, while he says that intercourse with a wife is sought after not for the sake of having more children. “And she who does not give birth, and to the widow he has done no good.” The virtue of humanity could not touch the spirit of the libidinous man, since there is no fellowship between vices and virtues.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-441"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:22 He has pulled down the strong by his might.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The following passage in the psalm is similar to this: “He will crouch and fall when he shall have power over the poor.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-299",
      "id": "ap_ntb-299-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])]), _vm._v(" "), _c('i', [_vm._v("The strong by his might")]), _vm._v(". The Greek has “the helpless.” When he has effectually achieved what he wanted, he will tremble over the condition of mortal life. “And when he stands up, he does not believe in his life.” When he will have prospered in his ventures, he does not believe that his life could fall into adversities by a turn of events.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-442"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:23 God has given him room for repentance, and he abuses it in pride.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since the punishment does not catch up to the sinner immediately, he is offered space and time for correction. When this time is spent increasing the criminal acts, the measure of just vengeance is compiled.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-443"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:24 They are lifted up for a little while.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The brief prosperity of the wicked cannot bring them long-term security in their state. “And they shall be humbled as all things, and shall be taken away.” That is, [as all things] which are like this: “And as the tops of the ears of corn they shall be broken.” It is as if he were to say, The frailty inherent in the ear of grain is great in view of its slenderness.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-444"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("24:25 But if it be not so, who can convince me that I have lied?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The pronouncement seems to be incomplete."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-300",
      "id": "ap_ntb-300-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("184")])]), _vm._v(" For after the hesitation the affirmation is not brought in so as to justly agree with what he had introduced. Therefore, it is recorded in the fashion of those who say, "), _c('i', [_vm._v("But if it be not so")]), _vm._v(", or rather, since it is so, it is established that I have not lied. "), _c('i', [_vm._v("But if it be not so, who can convince me?")]), _vm._v(" He infers at the end what he had pleaded through the whole course of the speech, that those abandoning the testimony of works were not able to prove that he was guilty with respect to those miserable circumstances that had befallen him, inasmuch as it was an established fact that often in the present the wicked are not punished. “And set my words before God.” The Greek has “And set my words as nothing.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-301",
      "id": "ap_ntb-301-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("185")])])])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-037"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 25]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-445"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("25:1-2 Then Bildad the Shuhite answered and said, Power and terror are with him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Bildad sees that Eliphaz’s argument, whereby he wanted to prove that saint Job was guilty with respect to his sufferings, had been plainly refuted by holy Job’s response, that there were many impious persons who did not suffer any adversity. Therefore, he departs from this style of argumentation, that he should say that the one whom he sees has fallen into harsh "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_67",
      "title": "67"
    }
  }, [_vm._v("circumstances of life is guilty, and he insists on the following aspect, in order to accuse Job. He preaches the divine "), _c('i', [_vm._v("power")]), _vm._v(", and he says that Job sinned because he had dared call God to judgment. "), _c('i', [_vm._v("Power and terror are with him")]), _vm._v(". Since Bildad is pressed by the force of reason, he is obliged to agree with saint Job’s words. Thus, he leaves out the equity of judgment for the present and preaches the "), _c('i', [_vm._v("power")]), _vm._v(" of God. And since he cannot prove that Job is guilty, he tries to discount him by a comparison. But by this tactic he does not notice what this adjustment brings about, that he is actually apportioning Job great praise."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-302",
      "id": "ap_ntb-302-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186")])]), _vm._v(" For it is a matter of supreme merit when a man is unable to be equated to the virtues of God! “Who makes peace in his high places.” Who has wonderfully mingled the natures of the elements, which are not only various but even contrary, as they come together among themselves. Thus, hot things and cold, wet things and dry unite in one body of the world. "), _c('i', [_vm._v("Who makes peace")]), _vm._v(". He wants to consider the proof of his "), _c('i', [_vm._v("power")]), _vm._v(", which by an equal judgment of agreement is applied in his service from so many countless thousands of angels.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-446"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("25:3 Is there any numbering of his soldiers? And on whom does his light not arise?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The throngs of his attendants attest to the greatness of the king and the benefits so diffused throughout the whole world that no one could be excluded from them.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-447"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("25:4-5 Can man be justified when compared with God? Behold, even the moon does not shine.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("On the verge of speaking about the changeable nature of the elements, he summoned the testimony of the moon, so that he could more easily prove what he wanted. For it is a unique quality of the moon that, when it waxes and wanes, it cannot hold to one state. “And the stars are not pure in his sight.” Since a moonless night often obscures their twinkling."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-303",
      "id": "ap_ntb-303-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187")])])])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-038"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 26]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-448"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("26:1-2 Then Job answered and said, Whose helper are you?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since Bildad had been overwhelmed by the reasoning of the argument and completely neglected the cast of his opponent, he betook himself to a summary of the divine praise, and thought that the estimation of God could be brought into danger, if saint Job proved himself innocent—for he who had inflicted the calamity appeared unjust, if the one who had received it were believed to be just. What is more, the reason he defended the justice of God by the legal defense of his own favor, holy Job says, was not the duty of a religious mind, to believe that God needs the aid of a human defense. "), _c('i', [_vm._v("Whose helper are you")]), _vm._v(", “is it not of him that is weak?” The case seemed to have been conducted in divisions, as it were, so that they laid claim to the justice of God against saint Job, who had removed the suspicion of guilt from himself. Therefore, holy Job reproaches this. He says that this pertains not to the praise of God, but is an affront, if someone believes that God is aided by a person’s own strength.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-449"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("26:3 And you have shown your very great prudence.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So that you firmed up one who was wavering by the subtlety of your argumentation, and removed the part that was being pressed.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-450"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("26:4 Whom did you desire to teach? Was it not him that made the things that breathe?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He divides the rational account of the rebuke into two parts, so that of the things he is about "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_68",
      "title": "68"
    }
  }, [_vm._v("to say, one seems to apply to his power, the other to his wisdom; that is, he who is powerful through himself does not need help from someone else, and he who is wise in himself is not helped by another’s counsel. "), _c('i', [_vm._v("Who made your breath")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-304",
      "id": "ap_ntb-304-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("188")])]), _vm._v(" In order that there be no doubt about the secondary things, the primary things convince; for living is prior to being wise; but no one is wise unless he first lives; therefore, you owe your wisdom to him who bestowed life on you.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-451"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("26:5-6 Behold, the giants groan under the waters. The underworld is naked before him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("After stating first the division that he made between power and wisdom, Job puts forward his evidence. Thus he says, Both the things that live in the depths of the sea, even if they are of tremendous bodily size (and for that reason he calls them "), _c('i', [_vm._v("giants")]), _vm._v(", which we should understand as monstrous beasts) and even "), _c('i', [_vm._v("the underworld")]), _vm._v(" itself, which shuts out the sight of viewers by its dense gloom—[both these realms] either perceive his power or are ever exposed to his eyes. "), _c('i', [_vm._v("Behold, giants groan under the waters")]), _vm._v(". The Greek has “Will the giants be delivered by a midwife under the waters, and in their neighbor?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-305",
      "id": "ap_ntb-305-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("189")])]), _vm._v(" This bears the following meaning: Will the dead rise who are under the waters on earth? “They will be delivered by a midwife” means “rise,” from the metaphor of women giving birth. The meaning is this: Just as the skill of midwives brings the child forth from the womb, so is it possible to call back the dead even from the underworld? Surely only God is capable of this. "), _c('i', [_vm._v("The underworld is naked before him")]), _vm._v(". It is impossible, he says, to hold back those who have been brought to an end by death when God wants to raise them. For at his command alone it is forced to vomit up those whom it had swallowed. “There is no covering for destruction.” Even though [the underworld] is covered by the thickness of darkness, nevertheless it appears transparently before the eyes of its Lord.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-452"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("26:7 He stretched out the north ("), _c('i', [_vm._v("aquilonem")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He made the huge northern ("), _c('i', [_vm._v("borealem")]), _vm._v(") region, which is uninhabitable and deserted on account of the excessive cold, just as on the other hand the southern region is inhospitable due to its excessive heat. “And hangs the earth upon nothing.” The earth that has been commanded to uphold itself balanced in the middle clearly testifies to the power of its own Creator.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-453"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("26:8 He binds up the waters in his clouds, so that they do not break out and fall down together.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since the whole thing that he had said seemed to expect proof of his power, he now adds the means by which the power of wisdom could be known. For that which was to be for destruction, if it were to fall together on the earth, he subdued into discipline by certain chains, as it were, so that it was divided out and dispersed beneficially into soft raindrops.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-454"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("26:9 He withholds the face of his throne, and spreads his cloud over it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It was consistent that the things that he had created by his power, he held together by the duty of judge, and he imposed rudders on affairs, as it were, from the height of the tribunal. But the one who presides in carrying things out is removed from the sight and viewing of men by a great mystery.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-039"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_69",
      "title": "69"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 27]")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This commendation of his virtue that arose from his fear of God clearly is conducive to the removal of the suspicion of boasting and levity.")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-455"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:7 Let my enemy be as ("), _c('i', [_vm._v("ut")]), _vm._v(") the ungodly, and my adversary as ("), _c('i', [_vm._v("quasi")]), _vm._v(") the wicked one.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If I cannot be suddenly led away from the previously mentioned course of my training, so that I feel and declare contrary to the reliability of the facts, it is necessary that I call you unjust and "), _c('i', [_vm._v("ungodly")]), _vm._v(", in whom I have denied that justice inheres. But the words he recorded, as ("), _c('i', [_vm._v("ut")]), _vm._v(") and as ("), _c('i', [_vm._v("quasi")]), _vm._v("), are those of one not wishing for this but pronouncing it.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-456"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:8 For what is the hope of the hypocrite if through covetousness he take by violence?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The reproach of hypocrisy is branded into his friends with a general censure, because earlier they feigned both honesty and friendship, and later on they greedily seized on the opportunity to detract.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-457"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:9-10 Will God hear his cry? Or can he delight himself in the Almighty?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is describing in order the evils that await those who choose to feign rather than to do honest things. “And call on God at all times.” He has nicely recorded "), _c('i', [_vm._v("at all times")]), _vm._v(", for it pertains to a good conscience alone to stay composed amid the evils of tribulation concerning the protection of God.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-458"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:11 I will teach you by the hand of God.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says that he will hand down to them by his authoritative teaching the evils that are inflicted on hypocrites through the hand of God. And in order to show his certain knowledge of the things that he will hand down, he adds a heap of them on the side. He claims that they are not unaware of what he is going to relate. The Greek has “I will announce to you the things that are in the hand of God, the things that are with the Almighty, and I will not lie.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-459"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:12 Behold, you all know it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since they themselves had said that they knew that “the praise of the wicked is short, and the joy of the hypocrite but for a moment.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-306",
      "id": "ap_ntb-306-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("190")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-460"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:13 This is the portion of a wicked man.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is said (not without stinging those who hear) as an invective with general application.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-461"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:14 If his sons be multiplied, they shall be for the sword.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Although he touches on feigned friendships with a speech like this, nevertheless he defends the case of his own appraisal. Thus, he says he would not have been able to feign virtue, since he recognized such fruits of hypocrites.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-462"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:15 They that shall remain of him, shall be buried in death, and his widows shall not weep.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “And no one shall pity their widows.” Here is another way. They will be so overwhelmed by the weight of evils, he says, that they would not even have power to shed tears.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-463"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:16 If he shall heap together silver as earth, and prepare garments as clay?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “gold” [in place of "), _c('i', [_vm._v("garments")]), _vm._v("].")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-464"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_70",
      "title": "70"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:17 He has prepared indeed, but the just man shall be clothed.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("[In v. 16] he is posing a question, if what is said never comes to pass; but if it is ever established as having been fulfilled, then he is bringing a solution.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-465"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:18 He has built his house as a moth, and as a keeper he has made a booth for the shade.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So that when all usefulness of things has been used up, traces remain as a sign of the calamity received. "), _c('i', [_vm._v("He has built his house as a moth, and as a keeper he has made a booth for the shade")]), _vm._v(". When he showed the vain efforts of those who have pursued the shadows of the virtues without any solidity, doubtless he showed that he was estranged from such a pursuit.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-466"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:19 The rich man when he shall sleep takes nothing with him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The things that are one’s own (namely, external wealth) are betrayed in the final end; for just as the goods of character go with us, so whatever was acquired as comforts and tools of the flesh remains behind.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-467"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:20 Poverty like water takes hold of him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the manner of onrushing water, he will be overwhelmed beyond hope by the evils coming on him.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-468"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:21 A wind shall carry him away.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Using a comparison to those things by which crops and sprouts are ruined, adversities are recounted by which the wicked are scourged. “And as a whirlwind shall snatch him from his place.” Variously the evils are recounted that he will encounter who has cared only to pursue his reputation and not conscience.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-469"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:22 And he shall cast on him, and shall not spare; out of his hand the one fleeing will flee.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he had shown that the one whom no virtue had armed is exposed to being wounded by the onrushing calamities, now he puts on the character of his attacker, as it were, from whose hand a javelin is borne and hurled so swiftly that it does not differ from the speed of the one fleeing.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-470"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("27:23 He shall clasp his hands on him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has completed the comparison of one pursuing with a hostile spirit a man in flight.")])])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-040"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 28]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-471"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:1 Silver has beginnings of its veins.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In order to link the things lower down with the things higher up, the meaning is as follows. Often, he says, God subjects the wicked to punishment and robs them of their goods and drives them out of their possession of property. However, he does not do this because he begrudges the wealth of the bad, for he is the one who at the beginning of creation mixed the substance of gold and silver into the veins of the earth for the future benefit and use of human beings. Hence, what he generously bestowed, he judiciously snatches from the wicked. "), _c('i', [_vm._v("Silver has beginnings of its veins")]), _vm._v(". Since at the end of this speech he will speak of the goods of true wisdom,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-307",
      "id": "ap_ntb-307-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("191")])]), _vm._v(" now he recounts the services that seem to imitate it, and he says that what nature removed from sight is brought forth into public view by the hands of prudence. "), _c('i', [_vm._v("Silver has beginnings of its veins")]), _vm._v(". This is all that saint Job pleads in the present speech ("), _c('i', [_vm._v("ecloga")]), _vm._v("), in order to show that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_71",
      "title": "71"
    }
  }, [_vm._v("concerning the power of God he perceives things greater by far than his friends [had perceived]. For by the pursuit of divine knowledge he has been led to a concern for a better life, by which surely he is not able to be forced to mislead. And on account of this he says the things he feels concerning his friends. Second, he has learned to locate the good of man not in bodily happiness, nor in those things that pertain to the body, but in the mind and wisdom. Not in that wisdom which pays attention to providing for earthly things, which often brings forth into the light that which nature has concealed, but in that wisdom that instills the fear of God"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-308",
      "id": "ap_ntb-308-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("192")])]), _vm._v(" and drives out the practice of vices.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-472"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:2 Iron is taken out of the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He provided some metals for beauty, others for cultivation or labor, that it might be adorned on the top and strengthened down below. “And stone melted with heat is turned into brass.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-473"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:3 He has set a time for darkness.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He gave gifts of wisdom to mortals and reduced the alternation of day and night within limits. "), _c('i', [_vm._v("He has set a time for darkness")]), _vm._v(". In order to promote the praise of the divine gifts, he marvels at how, when one substance meets human eyes, the force of reason still seeks another in it; that is, they think as necessary things not the earth that they dig up, or the mountains that they cut into, but that which the Creator mixed into them. And for greater wonder he adds, "), _c('i', [_vm._v("He has set a time for darkness")]), _vm._v(". That is, he has distinguished day and night, so that during the day, with the light as a witness, the eyes could judge concerning the diversity of things, but with the onset of night one color drenches everything. To the gift of sight and light he joined that wise reason could penetrate hidden substances even lying in secret. “And he considers the end of all things.” The Greek has “He considers the ends of times.” Human work is divided out in view of the variations in the times. Thus, one concern stirs mortals during the winter, another during the spring, another in the summer, and something else in the fall. “The stone also that is in the dark and the shadow of death.” He is saying, Even things that are devoid of reason know to some extent what we know by the instruction of nature—namely, to work during the day, to rest at night, to sow in winter, to harvest in summer. For they know what food to seek, what dangers to flee from. With no slip of memory, they seek a safe place to sleep in too. But only to the human being instructed by reason is it proper to know those things that are hidden or remote. Therefore, he recorded "), _c('i', [_vm._v("stone in the dark ")]), _vm._v("and"), _c('i', [_vm._v(" the shadow of death")]), _vm._v(", as if he were saying, Only the wisdom of man has tracked down and brought forth into the light those kinds of metals that are so hidden away and removed from sight that they are thought to have been thrust into hell. "), _c('i', [_vm._v("Stone in the dark")]), _vm._v(". He recorded "), _c('i', [_vm._v("stone")]), _vm._v(" for the boundary by which the spaces and rights of property are customarily marked. The expression is obscure enough, but it suggests the following interpretation: since he had discussed the discovery of bronze and iron, he describes with what difficulty both were discovered, in order to increase in admiration. It is as if he were to say, From those things wisdom brought some usefulness into the open, things that seemed estranged from any suspicion of advantage. For bronze melted out of completely inert stone, but from wasteland and wilderness, and that which was tilled only by water and that which promised no nourishment for the use of the poor, the hand of reason dug out iron that was necessary for agriculture.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-474"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_72",
      "title": "72"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:4 The flood divides from the people that are on their journey, those whom the foot of the needy man has forgotten.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("What wonder is it, he says, if he appointed certain times for day and night, when he marked off with a limit life itself and death, so that this light would not maintain complete control, nor greedy death steal everything? For indeed, the violently onrushing condition of mortality separates "), _c('i', [_vm._v("from the people that are on their journey")]), _vm._v("—namely, from him who is still a sojourner of this earth—him who cannot help the hand of the needy from the law of death.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-475"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:5-6 The land out of which bread grew in its place has been overturned with fire. The stones of it are the place of sapphires, and the clods of it are gold.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That which is called wisdom by the majority through sharing the name has exerted its talent in this direction, that it has even fathomed things placed underground, and eager for greater profits, it neglected the crops as it dug out gemstones and rich "), _c('i', [_vm._v("clods")]), _vm._v(" for "), _c('i', [_vm._v("gold")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-476"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:7 The bird has not known the path.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Although they sail through the air by their flight and touch roads that are near heaven, yet they are unable to approach those by which wisdom travels. "), _c('i', [_vm._v("The bird has not known the path")]), _vm._v(". The context of the exposition seems to demand that he is describing the effects and duties of wisdom, which he set out to describe, and he assigns to its duties that under its lead men approach those places in the hope of profit, which were previously remote from the access of mortals. And in his own way by using hyperbole he says that such desolate wastelands are approached by men that the places where the foot of man has entered are remote from birds and wild beasts themselves.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-477"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:8 The children of the merchants have not trodden it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he discusses this in order to show that men penetrate deserted places, why, on the other hand, does he deny that the desolate places are worn down by the feet of merchants? Hence, he seems to have shown the rarity of travelers and to have denied the frequent traffic of merchants. “Neither has the lioness passed by it.” Neither birds nor creeping things nor four-footed creatures have known those things that reason has discovered by its rigorous investigation of secret things and by its keen sense of inquiry.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-478"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:9 He has stretched forth his hand to the flint.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He searches carefully for unknown metals of marble and looks into the veins of the mountains diffused with various colors. “Neither has the lioness passed by it.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-309",
      "id": "ap_ntb-309-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193")])]), _vm._v(" Of all the species of animals, none are gifted with reason except the human being. Though he bestowed greater bodily goods on others, so that one rejoices in his strength, another in his speed, another rises up with wings and flight, he honored man alone with the activity of reason.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-479"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:10 And his eye has seen every precious thing.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("["), _c('i', [_vm._v("Seen")]), _vm._v(" means] caused to appear. Here is another way: "), _c('i', [_vm._v("his eye has seen every precious thing")]), _vm._v("—that is, not only those things that were useful but also those that were fitting for adornment, such as clothes from wool, fabrics for the rich from the threads of the Persian worms,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-310",
      "id": "ap_ntb-310-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194")])]), _vm._v(" wine from certain kinds of plants, ointments and other remedies from herbs.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-480"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_73",
      "title": "73"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:11 The depths also of rivers he has searched.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("His curious hand explores the unknown stones submerged in water. “And hidden things he has brought forth into the light.” His reason spread knowledge about the previously unknown usefulness of things. In fact, since before humankind the elements subsisted alone, after he was created, the human being with the guidance of his reason came to understand what usefulness could be gained from each of them. He learned what kind of land was suitable for sowing seed, which kind was fit for transplanting, what benefit could be obtained from particular plants, which woods were useful to build ships, which were more suitable for buildings, and what kinds were made only for the fireplace to stoke fires. And in this manner by the vast diversities of things the prudence of man guided his genius so that they would be useful.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-481"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:12 But where is wisdom to be found?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("His talent exerted itself to make the usefulness of these things known. But the activity of reason alone by itself was unable fully to search out what our proper thoughts should be concerning the valuation of God. Here is another way. Let the name of wisdom make a mockery of the listeners. It had led the talents of men through the many arts and brought to light things previously unknown. Now by the preference for precious things he is commending that wisdom that is true and in which the good of man is located. Here is another way. After showing that man excelled the rest of the animals by far through his reason, he prefers the worship and knowledge of God to reason itself, to convince his own detractors that those animals have far better perceptions about God than those men do. "), _c('i', [_vm._v("Where is wisdom to be found?")]), _vm._v(" The Greek has “whence.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-482"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:13 Man knows not the price thereof.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He goes back over each of the things by which he had described that with which wisdom is thought to have occupied itself, and he says that the functions of true wisdom could not be involved in the preparation or provision of such things, nor should its worth be associated with wealth or else with delights.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-483"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:15 The finest gold shall not be given for it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This passage is similar to the Proverbs of Solomon in which the worth of wisdom is preferred to everything that is reckoned great by human beings."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-311",
      "id": "ap_ntb-311-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("195")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-484"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:16 It shall not be compared with the dyed colors of India.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If anything glows red with gold, sparkles with gemstones, blooms with colors, it is sought for the use and adornment of human beings. But in human beings, living precedes adornment. It is an established fact that wisdom by which life is "), _c('i', [_vm._v("compared")]), _vm._v(" is better by far than all the precious and beautiful things. "), _c('i', [_vm._v("It shall not be compared")]), _vm._v(". He had described that the diligence of human beings, which seems to imitate wisdom, went through all those things. Thus, it sought for veins of silver in hidden away places, it condensed the sands of rivers into gold, it collected gemstones from watery depths. Therefore, he says that true wisdom, of which God is the teacher, is not found in these locations or pursuits.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-485"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:18 High and eminent things shall not be mentioned in comparison of it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He shows that not only amassed riches but also the heights of honors and the highest "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_74",
      "title": "74"
    }
  }, [_vm._v("peaks of official dignity become worthless in comparison with it. “Wisdom is drawn from what is hidden.” Since in order to honor wisdom, he had depreciated all the things that entice the eyes, flatter the other senses, or make a mockery of our imaginations, he also vindicates [wisdom] from that injustice, in order that it may not appear to lie open to everybody; that is, it may not be reckoned to dwell in the pursuits and the functions of the common crowd.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-486"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:19 The topaz of Ethiopia shall not be equal to it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Hebrews call "), _c('i', [_vm._v("topaz")]), _vm._v(" “smaragdon.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-487"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:20 Whence, then, shall come wisdom, and where is the place of understanding?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the form of a question, he extols its merit, lest as if set out in public view it become worthless by the very ease of those approaching it.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-488"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:21 It is hidden from the eyes of all.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He advances to the peak of honor because it is not touched by human knowledge, nor is it found in hidden away places, but it is located only in the knowledge of God.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-489"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:22 Destruction and death have said, With our ears we have heard the fame thereof.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For the wisdom by which one approaches the worship of divinity not only takes precedence over all the things that human diligence has sought for; it is even clear from this, that we find just ones devoted even to this wisdom that taught them to fear God, that he not only vindicated them from destruction or death but others as well. Thus, justly, as if it has no rights over them, it says that the fame of them has reached only to their ears. "), _c('i', [_vm._v("Destruction and death have said")]), _vm._v(". Wisdom presides over this, through which we are instructed in the worship of the true religion, so that "), _c('i', [_vm._v("destruction and death say")]), _vm._v(" that we who are placed far from its jurisdiction are without knowledge.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-490"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:23 God understands the way of it, and he knows the place.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had said higher up through what means or where it could not be found. Therefore, so as to increase its worth, he has said by whom it has been found and by whose teaching it could be known.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-491"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:24 For he beholds the ends of the world and all things.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Lest the difficulty of discovery that he had shown higher up by the grand ostentation of speech would be thought to hinder even God, he describes the immensity of his power, because it easily meets the eyes of one who considers all the exposed spaces of the earth in every place where the heaven extends.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-492"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:25 Who made a weight for the winds.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Even another testimony is employed, so that the possibility of comprehending wisdom from God may be indicated. He is saying, He "), _c('i', [_vm._v("who made a weight for the winds")]), _vm._v(" found by his own subtlety that which had escaped the grasp of men. He weighs by a definite examination those things that among us are thought to be the lightest, as things weighed on scales, and he knows with such certainty the immensity of the waters, which exceed the reckoning of our calculation, so that he seems to have measured them. Here is another way. As proof of his providence that he wanted decreed for mortals, he joined together elements that were at odds with each other by established measures, in such a way that one would not be the destruction of another by its own larger part. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_75",
      "title": "75"
    }
  }, [_c('i', [_vm._v("He made a weight for winds")]), _vm._v(", lest everything collapse either from winds greater than was fitting or else they not bring help by weaker ones. “And he weighed the waters by measure.” Either he brought into order those (waters) that were under the firmament,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-312",
      "id": "ap_ntb-312-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196")])]), _vm._v(" so that they did not equally run down into the lower regions, or he gave them equal space by limiting their positions to those that are on the earth.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-493"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:26 When he gave a law for the rain.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since at the beginning of creation he formed by his own disposition a way to govern the world by means of changes in seasons and moderating air temperatures.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-494"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("28:28 And he said to man, Behold, the fear of the Lord, that is wisdom.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("His authority of his first command extends to the communion of the human race. For when he issued the injunction to abstain from the tree,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-313",
      "id": "ap_ntb-313-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("197")])]), _vm._v(" he was not begrudging the taste of fruit but seeking humanity’s obedience.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-041"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 29]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-495"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:1 Job also added, taking up his parable.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One properly speaks of a "), _c('i', [_vm._v("parable")]), _vm._v(" when more is contained in the meaning than is declared in the words. Either the coherence of things means more than is on the surface or the understanding is completed by reason. For either the lengthy description of divine power or the commendation of wisdom that was briefly summarized discussed all this, so that by means of these things a testimony to saint Job’s virtues could be offered.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-496"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:2 Who will grant me, that I might be according to the months past, according to the days in which God kept me?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is not that he does not know who could summon him back to the "), _c('i', [_vm._v("past")]), _vm._v(" prosperity, since he is certain that it could be granted even in the present by him who first bestowed it. Rather, he has introduced the speech of one who is wavering for the sake of affect and in the manner of one expressing his wishes. "), _c('i', [_vm._v("Who will grant me, that I might be according to the months past?")]), _vm._v(" He first says those things that have in view the divine generosity, and he lingers in unfolding God’s acts of kindness toward himself and skillfully postpones saying anything about his own virtues so that, when he has published his own goods, you would understand that he has not lapsed into vain boasting but was forced [to say these things] by necessity. By this he shows that the reason he had developed such character in himself is that he had never thought meanly of God, as, for instance, his friends were assuming.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-497"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:3-4 When his lamp shined over me. My head.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When I enjoyed such great prosperity that the gifts of heavenly grace were clearly reflected in me. “And I walked by his light in darkness. When God was secretly in my tabernacle.” As far as the literal meaning"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-314",
      "id": "ap_ntb-314-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("198")])]), _vm._v(" of the words is concerned, it seems to be contradictory. For how could he "), _c('i', [_vm._v("walk in darkness")]), _vm._v(" who was rejoicing in the splendor of light? But since he had actually said "), _c('i', [_vm._v("lamp")]), _vm._v(", the use of which is necessary at night time, he responded to the occasion first mentioned, which had arisen from the term; or else he wanted that to be understood that he made evident in the subsequent verse, that he recorded "), _c('i', [_vm._v("darkness")]), _vm._v(" for "), _c('i', [_vm._v("secretly")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-498"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_76",
      "title": "76"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:5-6 When I washed my feet with butter. And my servants round about me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He recounts everything that has in view commending his benefits. For to be crowded with the duties of servants and to overflow with wealth is not an indication of virtue proper but of the munificence of the generous donor.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-499"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:7 When I went out to the gate of the city, and in the street they prepared me a chair?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is proclaiming either past dignity or abundance of property, so that the change of state which followed may instill more pity.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-500"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:8 The young men saw me, and hid themselves, and the old men rose up and stood.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is both a testimony of reverence and of authority, that either the old men rise up or the young men leave (for whom customarily solemn maturity is something foreign).")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-501"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:9 The princes ceased to speak and laid the finger on their mouth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Appointed silence and restricted speech, attentive ears and awestruck faces of those standing about attested to the merits of his very influential tongue.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-502"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:11 The ear that heard [me] blessed me, and the eye that saw [me] gave witness to me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The hearer was so influenced by the light of my thoughts and the grandness of my statements that he did not conceal his own judgment. For on the basis of their own experience even those to whom the reputation of my works had reached claimed that they had heard the truth.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-503"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:12 Because I had delivered the poor man that cried out.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Lest he should seem to have proclaimed the gifts of his own genius while he charmingly winds up his speech, he added the reason why the throng of those standing about him imagined that you knew that what was praised pertained not to eloquence but to justice.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-504"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:13 The blessing of him that was about to perish came upon me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He said "), _c('i', [_vm._v("him that was about to perish")]), _vm._v(", not him whom perdition awaited based on his merits, but one who was beset by danger unless protection came to his aid. “I comforted the heart of the widow.” He either promised her the comforts that she would have reaped from the provision of a husband or he prevented her from being treated unjustly since she seemed especially exposed to this by her condition.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-505"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:14 I was clad with justice, and it clothed me like a robe.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In order to show that he has been greatly concerned for justice, he nicely sought for an example from the robes in which we go around. He says, As the body needs constant covering and is impatient of its own nakedness, so an intimate sense of justice was ingrained with deep affection in my actions. “And my justice was a diadem.” Not only have I put justice around myself like clothing but I have even taken such delight in its charm that I thought of wearing an ornament and a sign of royal authority on my head.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-506"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:15 I was an eye to the blind.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("On account of the linking of subjects, this seems to apply both to the aspect of mercy and justice, because in the discussion of doubtful things and in the ferreting out of hidden "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_77",
      "title": "77"
    }
  }, [_vm._v("things, he often discovered those things that those whose business it was did not see. For he adds:")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-507"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:16 And the cause that I knew not, I searched out most diligently.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Lest I be deceived by the first look at the unexamined business.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-508"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:17 I broke the jaws of the wicked man.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A concern for justice was preeminent so that I did not listen negligently to those things that were called to my examination; my authority allowed me to punish with very great severity what I had ascertained was true.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-509"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:18 And I said, I shall die in my nest, and as a palm tree I shall multiply my days.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I thought that the fruits of justice were such that it bestowed on those who cultivated it not only prosperity but even long life.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-510"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:19 My root is opened beside the waters.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By various comparisons he shows that he believed that he had to be given favorable circumstances.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-511"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:20 My glory shall always be renewed.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The condition and state of my life will allow no impairing of the help"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-315",
      "id": "ap_ntb-315-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199")])]), _vm._v(" of justice.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-512"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:21-23 They that heard me waited for my sentence. They waited for me as for rain.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("They hung on my words, not trusting in their own sentiments and judgment, and what I sanctioned was wondrously approved by the consent of all; and so great was the uprightness of my statements that it roused not merely the pursuits of the listeners but also affectionate feelings of goodwill toward me. Whence this is not a repetition of the things above, but something new, so that the former seems to have in view his authority, the latter his prestige.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-513"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:24 If at any time I laughed on them, they did not believe.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("His solemnness was so mingled with good cheer that he met not with dread over his excessive gloominess, nor scorn concerning his paltry permissiveness.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-514"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("29:25 And though I sat as a king with an army standing about, yet I was a comforter of them that mourned.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The honor conferred on me and the ardent obedience about me did not strip me of my feelings of humanity, but I remembered that I too was human, whenever a cause for tears occurred.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-042"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 30]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-515"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:1 But now the younger in time scorn me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These words testify to the authority, prestige, and power of his former life, as he has proclaimed. For to the extent that the state of his former happiness had been more pleasant, so much the more bitter now it makes his feelings of pain after things turned into the opposite. “Whose fathers I would not have deigned to set with the dogs of my flock.” This provides evidence of extreme poverty, through which also the vileness of his condition is shown, not only the fact that he lives on charity but also that he is appointed to offer shepherd’s care of the food of dogs.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-516"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:2 The strength of whose hands was to me as nothing.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By these words he takes care to show the outstanding nature of his previous life and the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_78",
      "title": "78"
    }
  }, [_vm._v("degree to which there was no vice of pride in the midst of his own state and theirs. “And they were thought unworthy of life itself.” He did not come to this by the vice of arrogance or by the elation and haughtiness of pride, but for the sake of the extreme condition of persons and abject worthlessness.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-517"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:3 Who brayed in the wilderness.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the sound of a confused voice they were indicating the abundance of their distresses.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-518"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:4 And they ate grass and the bark of trees.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The impoverished life of lowly persons is being described all the more keenly so that he may make headway in reaching the peak of griefs in disrespect of such persons.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-519"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:5 Who snatched up these things out of the valleys, when they ran with a cry.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is emphatically describing poverty as well as burning and violent hunger, in which nothing was left.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-520"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:6 They dwelt in the desert places.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, they were stripped of the comforts of both food and shelter.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-521"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:7 They pleased themselves among these kinds of things.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is as if he were to say, By withdrawing from the society of human beings, they lived like wild beasts.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-522"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:8 The children of fools, and not appearing on the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By this addition he has revealed how he wanted the things stated earlier to be understood.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-523"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:9 Now I am turned into their song.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is common among men to sing with a melodious voice the collapse of a certain state and the change of things for the worse. The following is like this: “They that sat in the gate carried on against me, and they that drank wine made me their song.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-316",
      "id": "ap_ntb-316-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('i', [_vm._v("Now I am turned into their song")]), _vm._v(". Up to this point a lengthy description both of his prosperity and of an external disaster was advancing in order to increase the causes of his grief by the comparison of the portions.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-524"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:10 They abhor me and are not afraid to spit in my face.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Just as fearing contact is a sign of great horror, so daring to spit is a sign of great scorn.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-525"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:11 For he has opened his quiver and has afflicted me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That which is despised, which is mocked, which is spit at, he says that he endures, because he is shaken by the attack of a higher hand. It is as if he were to say, The reason such great things are allowed against me even as most contemptible things is because I have been brought into these miseries with God standing in opposition. The following words of the Lord are like this: “You would have no power over me except it were given to you from above.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-317",
      "id": "ap_ntb-317-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("201")])]), _vm._v(" “And he put a bridle into my mouth.” Lest as one gravely doomed I should invite a milder sentence.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-526"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:12 My calamities [are] at the right hand of my rising.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “of my offspring.” Since by the term "), _c('i', [_vm._v("quiver")]), _vm._v(" he had said that God was armed "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_79",
      "title": "79"
    }
  }, [_vm._v("for his own destruction, he completes the comparison taken up and indicates what sort of arrows he shoots with his upraised right hand, saying, “My calamities forthwith arose.” He maintains the figure of an attacker even in the rest and says that his companions have been soldiers in the assault and fight against him.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-527"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:15 I am brought to nothing; as a wind you have taken away my desire.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When those things have dispersed, which either used to or were capable of inciting my feelings in themselves—that is, when I have been deprived of both comforts and services—I came to realize that there was no hope left to me by which I could be supported. “And my welfare ("), _c('i', [_vm._v("salus")]), _vm._v(") passed away like a cloud.” He said that his "), _c('i', [_vm._v("welfare passed away")]), _vm._v("—not his life—which was placed in the comforts of home and bodily health.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-528"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:16 And now my soul fades within myself, and the days of affliction possess me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Not without reason did he say "), _c('i', [_vm._v("possess")]), _vm._v(", but this was to show that nothing within him was free from the sensation of pain.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-529"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:17 In the night my bone is pierced with sorrows, and they that feed on me do not sleep.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("My tormenters do not allow a respite either in the change of time or by exhibiting satisfaction.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-530"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:18 With the multitude of them my garment is consumed.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When there is not sufficient flesh to eat, eager vermin consume clothing as well.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-531"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:19 I am compared to dirt, and am likened to embers and ashes.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he had said that he was wrapped with a multitude of vermin, as with a tunic, fittingly from the source from which so many bubble forth, he compared himself to dirt, which is customarily found in sewers and on buried corpses.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-532"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:20 I shall cry to you, and you have not heard me; I stand up, and you do not regard me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("You refuse to show me any feelings of mercy, so long as you do not hear my appeal and do not turn your eye toward my sufferings.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-533"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:21-22 You are changed to be cruel toward me. You have lifted me up and set me, as it were, on the wind, and you have mightily dashed me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I see not only that you have shared no help with me, but I sense that you are in reality a violent attacker as well; for I have been raised up higher in order that I should fall more heavily. Now he said this using the metaphor of wrestlers.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-534"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:23-24 I know that you will deliver me to death, where a house is appointed for every one that lives. But yet you do not stretch forth your hand to their consumption; and if they shall fall down, you will save.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He seemed to have removed all differences in merits when he said, "), _c('i', [_vm._v("Where a house is appointed for every one that lives")]), _vm._v(". Therefore, he gives attention to this: although the just and the sinner equally are liable to the laws of death, yet he who has pleased you will not be led into everlasting destruction. For after the collapse of his body, he will be restored unto life.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-535"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:25 I wept once for him that was afflicted.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Previously he discussed the pursuit of justice."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-318",
      "id": "ap_ntb-318-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("202")])]), _vm._v(" Now he brings into view the affection of great mercy that was in him. "), _c('i', [_vm._v("I wept once")]), _vm._v(". The grand "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_80",
      "title": "80"
    }
  }, [_vm._v("pursuit of piety is revealed in him; for if, as he himself says, he “broke the jaws of the wicked man, and out of his teeth I took away the prey,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-319",
      "id": "ap_ntb-319-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("203")])]), _vm._v(" what reason for tears did he have when he saw that someone was afflicted? But the former passage had in view the function of authority, the latter that of mercy. Justice was carried out in the former passage; the bowels of compassion were struck by the latter.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-536"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:26 I expected good things, and evils came upon me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I thought that equal, not opposite fruit would answer to the things above.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-537"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:27 My inner parts have boiled without any rest.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By repeated interruptions he reveals how sparing he is and embarrassed to proclaim his own virtues. For when his praises have been briefly touched on, he tarries in narrating his griefs.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-538"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:28 Without indignation I rose up and cried out in the crowd.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The greatness of pain compelled me to burst out in public wailing, and I cried out as if out of my mind; with a sound state of mind I discussed the matter of indignation. He cried out:")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-539"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:29 I was the brother of dragons.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “I was the brother of sirens and a companion of sparrows.” “And companion of ostriches.” It is normal for those suffering from poor health to believe that an alleviation of pain comes to them by frequent changes of environment. Therefore, he says this using the metaphor of "), _c('i', [_vm._v("dragons")]), _vm._v(" and "), _c('i', [_vm._v("ostriches")]), _vm._v(", because when the evils stirred themselves up, he pursued wastelands and deserts.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-540"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:30 My skin has become black on me, and my bones are dried up with heat.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It was consistent that one who lived in the desert and was defended by no protection of a roof would burn in the blazing rays of the sun.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-541"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("30:31 My harp is turned to mourning.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("All delight, which was usually applied to soothe the senses, has been driven out by the onset of grief.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-043"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 31]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-542"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:1 I made a covenant with my eyes, that I would not so much as think on a virgin.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The understanding is well linked with the previous verse."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-320",
      "id": "ap_ntb-320-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("204")])]), _vm._v(" Not even at the time, he says, when the sweetness of the harp soothed my ears did I allow any lustful feeling to dwell in my heart, even though the sound of lute-playing artfully affected my senses. "), _c('i', [_vm._v("I have made a covenant with my eyes")]), _vm._v(". After the pursuit of justice and the feeling of mercy, the virtue of chastity is made public. And since it was beneficial to his posterity to imitate that which the confession of the saintly man announced about himself, he points out that he carefully avoided, as a great evil, the vice of sexual impurity, and he tarries at length in extirpating the evil that is familiar to human beings.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-543"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:2-3 Is not destruction to the wicked?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He was not satisfied with saying that by sexual impurity he would be rendered unworthy of being indwelt by God, but he added that "), _c('i', [_vm._v("destruction")]), _vm._v(" would await him, who had polluted himself by unlawful sexual intercourse. “For what part should God from above have in me?” "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_81",
      "title": "81"
    }
  }, [_vm._v("Therefore, “I made a covenant with my eyes,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-321",
      "id": "ap_ntb-321-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("205")])]), _vm._v(" since I believed that God was always present as a witness to my actions.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-544"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:5 If I have walked in vanity.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This also is said about the same pursuit of virtue.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-545"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:6 Let him weigh me in a just balance.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He proceeds to speak about his great awareness of virtue, that if he is summoned to judgment, he will possess it in reality, no less than his profession shows.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-546"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:7 If my step has turned out of the way.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says not merely that he did not fall into the precipice of sexual impurity but that he walked along the prescribed footpaths of moral integrity without stumbling and that he held firm to the right tracks. “And if my heart followed my eyes.” Watchful concern for chastity so held me in my post that if the influence of some beautiful form passing by caught my eyes for a look, I was not led astray into base desire by any willful act.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-547"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:8 Let me sow and let another eat.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Odious luxury attests how it will be respecting the pursuit of the affection of chastity; for he would never have pleaded this for himself so earnestly if he considered this vice trivial and esteemed it lightly.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-548"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:9 If my heart has been deceived over a woman.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He quite often tarries by repeating the same things since he wants to create a remedy for this disease, which is familiar to human beings.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-549"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:10 Let my wife be the harlot of another.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is armed against sin by the bitter thought of adultery, so that the dread of the accursed thing may lead to caution.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-550"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:11 For this is a heinous crime.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He proceeds to weigh down heavily on what he wants to be carefully on guard against, and from the fruits of the works he discourages the works themselves. He shows the merit of the thing to those whom he wants to avoid punishment.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-551"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:12-13 It is a fire that devours even to destruction. If I have despised abiding judgment with my manservant.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("After first mentioning his virtues of justice, mercy, and chastity, he adds another—namely, the virtue of moderation. For he would not have defended himself against the expostulations of petty servants with the master’s authority but by satisfying reason.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-552"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:14 For what shall I do when God shall rise to judge?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Before the sentence of the Judge, the guilt of my own conscience would have overwhelmed me, if in the appraisal of things I had followed the differences of conditions, not the merits of the cases, and if fairness rather than persons had not moved me.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-553"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:15 Did not he that made me in the womb make him also?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Why would diverse merits create a prejudice over a name if one creator’s hand made both?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-554"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:16 If I have denied to the poor what they desired.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In order that it might not appear that by treating his servants humanely he did not "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_82",
      "title": "82"
    }
  }, [_vm._v("practice a real liberality but was only taking care of his property, he says that he extended the hand of mercy and kindness to strangers as well. Here is another way. One who does not wait to satisfy the desires of the needy gives without delay. “And I have made the eyes of the widow wait.” The caring affection of one who is merciful offers of his own accord what he thinks must be asked of him.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-555"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:17 If I have eaten my morsel alone.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Not only does he say that he worked outside with a bountiful hand, but, what pertains to greater kindness, he says that he invited to share his table those whose condition exposed them to injury by the powerful and to robbery.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-556"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:18 For from my infancy mercy grew up with me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In order to show his constant and sufficiently personal pursuit of kindness, he said that the virtue of humanity was ingrained in him.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-557"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:19 If I have despised him that was passing by for want of clothing, and the poor man that had no covering.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says that he always focused his sight on doing good even in chance encounters with poor people, and his heart was impacted by the afflictions of strangers.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-558"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:20 If his sides have not blessed me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Even with their tongue being silent, those bodily members that his acts of blessing reached are said to have burst into speech.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-559"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:21 If I have lifted up my hand against the fatherless.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since previously he confessed that which is more, when he said, “If I have eaten my morsel alone, and the fatherless has not eaten thereof,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-322",
      "id": "ap_ntb-322-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("206")])]), _vm._v(" how is it that he seems to add to the pile of virtue that which is less? Clearly such praise of this virtue is increased from its continuation, because he always practiced it in such a way that no intermission ever occurred. "), _c('i', [_vm._v("If I have lifted it up against the fatherless")]), _vm._v(". Lest he seem to have done his works of mercy not from his own property but from things he had pillaged from others, which even his friends indeed raise as an objection to him,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-323",
      "id": "ap_ntb-323-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("207")])]), _vm._v(" he nicely adds, "), _c('i', [_vm._v("If I have lifted up my hand against the fatherless")]), _vm._v(". That is, I have not brought to another what someone else received from me.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-560"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:22 Let my shoulder fall from its joint.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he first mentioned his virtues, just as so grave an imprecation records the truth, so it removes from them the suspicion of fickleness.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-561"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:23 For I have always feared God as waves swelling over me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He gives the reasons why such a fertile crop of virtues sprang up within him—namely, because a very great fear of God, and one of the sort that the comparison indicates, cultivated the soil of his heart.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-562"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:24 If I have thought gold my strength.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He could not place any support or delight in external and perishable goods, however grand they may have been, he who possessed his own private wealth of soul that was vast. The lord of great treasure"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-324",
      "id": "ap_ntb-324-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("208")])]), _vm._v(" thought little of lesser things.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-563"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:26-27 If I beheld the sun when it shined, and the moon advancing in brightness, and I have kissed my hand with my mouth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_83",
      "title": "83"
    }
  }, [_vm._v("I was not so moved by the beauty and splendor of the stars that I believed them to be gods and devoted any worship and veneration to them. In this it should be noted that he not only strove after good morals but also held fast to right thoughts concerning religion.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-564"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:28 Which is a very great iniquity?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To believe that created things are gods is an injustice to the Creator, and to want to place that which has been made ahead of the Maker, this is not pardonable ignorance but punishable wickedness."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-325",
      "id": "ap_ntb-325-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("209")])]), _vm._v(" A person plainly denies God who does not confess the one who is true and alone.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-565"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:29 If I have been glad at the downfall of him that hated me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("How far removed he is from the pursuit of doing harm. He even experiences some grief at the evils that afflict his own enemy! A person is incapable of wounding who necessarily feels pain over the one who has been wounded.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-566"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:30 For I have not given my mouth to sin by wishing a curse to his soul.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("From the same virtue he came to restrain his tongue from cursing, from which [tongue] the seriousness of his character and the proper training of his senses had proceeded.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-567"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:31 If the men of my tabernacle have not said, Who will give us of his flesh that we may be filled?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The extent of his love and the ardor of his passion is more often indicated in these words. But he wants to say that he presented himself as common and dear to his household, so that he roused everyone’s most ardent affections for himself.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-568"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:32 The stranger did not remain outside.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That which was recorded in the first place among the great virtues that he had recounted seemed inadequate. He heaped up more by an addition when he said, “My door was open to the traveler.” That is, The gate of my hospitality received not only those whom either previous acquaintance or dignity had recommended but all whom the necessity of traveling had brought [to me].")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-569"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:33 If as a man I have hid my sin.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A sensitive brow and a foolish sense of shame did not obstruct me from making public that which I had done perversely, nor from blotting out my evil deeds by confession.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-570"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:34 If I have been afraid at a multitude, and the contempt of kinsmen has terrified me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The title of my office was not of such great worth to me that I was afraid to cast it down if confession of sin rendered me more vile before the people. Nor since blame stripped of honor thrust me out among neighbors, therefore I chose the concealment of silence rather than concern for publicity. “And I have not rather held my peace.” Just as I repressed my voice from protecting things done wrongly, so I condemned myself by keeping the secret.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-571"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:35 Who would grant me a hearer, that the Almighty may hear my desire?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had been forced to admit his virtues, both by the accusations of his friends and by his pious esteem for God; that is to say, his virtues had proceeded from the fear of God. Therefore, he now desires to add the testimony of the sentence of the Judge in support of his words, so that, when God declares that he had "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_84",
      "title": "84"
    }
  }, [_vm._v("spoken the truth, none of his opponents would be able to deny it."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-326",
      "id": "ap_ntb-326-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("210")])])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-572"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("31:38-40 If my land cry against me, and with it the furrows thereof mourn, if I have eaten the fruits thereof without money, let thistles grow up to me instead of wheat.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has indicated at the end of the third line what he intends to be understood by these two verses—namely, that he never oppressed his laborers by an unjust quota of work or cheated those whom he had hired out of their agreed-on wage.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-044"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 32]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-573"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:1 So these three men ceased to answer Job.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-574"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:2 Because he said he was just before God.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the recounting of his own virtues he had claimed for himself the calculation of justice, as if the portions of his life and suffering had been weighed in the balance.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-575"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:4 So Elihu waited while Job was speaking.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Elihu does not so much rail at the virtues of saint Job as feel annoyance that he could be given preference by God when he is placed under examination.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-576"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:6 Then Elihu the son of Barachel the Buzite answered and said, I am younger in time, and you [all] are more ancient; therefore, I was afraid to show you my opinion.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When Elihu sees that the three friends took refuge in silence from the failure of their responses, he says that he indeed held fast to the discipline of silence for the sake of the reckoning of age; but since the speech of elders yielded to Job’s arguments, he is no longer able to be silent. Yet he is convicted about tracing the tracks of their thoughts through the same paths that the friends previously had worn down.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-577"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:8 But, as I see, there is a spirit in men, and the inspiration of the Almighty gives understanding.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The gift of being wise does not pertain to the law of bodies if it is granted to each by the divine generosity.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-578"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:9 They that are aged are not (supply in thought, “the only”) wise men, neither do the elderly (supply “alone”) understand judgment, lest he seem to have reputed to youths alone what he denied to the others.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-579"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:10 Therefore I will speak: I also will show you my knowledge.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-580"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:13 Lest you should say, We have found wisdom, God has cast him down, not man.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since your speech ceased, you were not able to reply to those things that were said; therefore, you should believe that this summary could support you, so that you say, What we were trying to show by arguments is proven by the judgment of God—namely, that he is guilty of transgression. In fact, the divine punishment would not have had any rights against him had it not found an evil work in him.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-581"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:14 He has spoken nothing to me, and I will [not] answer him according to your words.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I was not involved in the debate with him, as you know, nor did he provoke me to bitterness after adopting the aim of speaking against me. Therefore, the words that I bring forth are not inspired by indignation but by the mind’s reason.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-582"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_85",
      "title": "85"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:15-17 They were afraid and answered no more. I also will answer my part.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Their silence is a taunt, because having been vanquished by the power of his statements, they would have chosen to be better if they were silent.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-583"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:18 For I am full of matter to speak of.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, it is time for me to say some things, for there are many things that I could set in opposition to his statements.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-584"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:19 And my belly is as new wine.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He shows that he endured the flood of their thoughts when they were speaking, and he had discovered many things, which, as it seemed to him, could be said wisely and suitably.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-585"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:21 I will not accept the person of man, and I will not level God with man.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says that he is forced into the necessity of speaking by the honor of God, lest because he is silent it should seem that Job ceased, as his friend had done, and was granted favor.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-586"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("32:22 For I know not how long I shall continue, and after a while my Maker may take me away.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Therefore, it is not expedient for me to keep silent about an injury to God, lest the final end of life may find me in sin.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-045"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 33]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-587"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("33:3 My words are from my simple heart.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In confirmation of those things that he is about to say, he says that he is not impelled by the goads of anyone’s sin but by the rationale of truth.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-588"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("33:4-5 The spirit of God made me. If you can, answer me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He believes that with the aid of a comparison he can do something effective against saint Job. He says, If you cannot answer me, I who am a thing created by God, know that you will be much less able to answer to God, who is the Maker of all things.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-589"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("33:7 But yet let not my wonder terrify you, and let not my eloquence be burdensome to you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The parts of the reply I seized on, after the elders were exposed, this is what ought not seem so wonderful to you that you too are "), _c('i', [_vm._v("terrified")]), _vm._v(". "), _c('i', [_vm._v("But yet let not my wonder terrify you")]), _vm._v(". The Greek has “My fear shall not disturb you, neither shall my hand be heavy on you.” Here is another way. He has expressed the reason for his indignation openly, because Job wants to challenge God to judgment. And in the argument against his friends, holy Job had said, “Let him take his rod away from me, and let not his fear terrify me. I will speak, and will not fear.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-327",
      "id": "ap_ntb-327-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("211")])]), _vm._v(" It is as if he were fleeing for the sake of this judgment alone. For higher up nature remained against him, although he had just claims in view of the testimony of his works, which excluded every voice of opposition. Therefore, Elihu warns him and says, Behold you have what you wanted, your argument will be against an equal, whose authority does not overwhelm you, nor does terror compel you to silence.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-590"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("33:8-10 Because he has found complaints against me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As he "), _c('i', [_vm._v("found complaints against me")]), _vm._v(", so “he has counted me for his enemy.” Now you said in my hearing, and I have heard the voice of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_86",
      "title": "86"
    }
  }, [_vm._v("[your] words, since "), _c('i', [_vm._v("he has found complaints against me")]), _vm._v(", therefore "), _c('i', [_vm._v("he has counted me for his enemy")]), _vm._v(". This is what saint Job had said earlier: “And you want to consume me for the sins of my youth.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-328",
      "id": "ap_ntb-328-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("212")])]), _vm._v(" Therefore, [Elihu] refutes this as a curse—that is, because saint Job had not soundly believed that no faults could be found in him from his mature age, but believed that he was being punished severely in himself for the errors of his youth.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-591"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("33:12 I will answer you, that God is greater than man.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If you see for yourself that this has to be admitted even by those who are ungrateful, doubtless you will agree that God is superior to all things. Therefore, since he is also the first in justice and wisdom, he should not appear to have done anything in such a way that may incur your brand mark of reproof.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-592"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("33:14 God speaks once.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To ratify a verdict but not to repeat it, this pertains to God’s authority, to the gravity of his constancy.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-593"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("33:15-16 By a dream in a vision by night, when deep sleep falls on men, and they are sleeping in their beds, then he opens the ears of men, and by teaching them he instructs discipline.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("From Elihu’s words it appears that saint Job came before the time of the law. For he would never have said that God warns men by dreams and nocturnal images, or that he instructs concerning fleeing from errors or seeking virtue, if he had already conferred the teaching authority of the good life in written form.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-594"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("33:19 He rebukes also by sorrow in the bed.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By many and various ways"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-329",
      "id": "ap_ntb-329-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("213")])]), _vm._v(" he shows that God displays concern for human beings, when he says he not only stands by those who are sleeping, and shows them what needs to be done, but even chastises all those who have gone astray by the scourges of illnesses and diseases. Now this statement seems to be directed properly at Job himself.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-595"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("33:23-24 If there shall be an angel speaking for him, one among like ones ("), _c('i', [_vm._v("similibus")]), _vm._v("),"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-330",
      "id": "ap_ntb-330-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("214")])]), _vm._v(" he shall have mercy on him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The affection of mercy is shown to be ready at hand in God, so that any suspicion of injustice and savageness and deformity of character is far removed from him. For he says that if in a man who is struck by adverse health, some single good is brought by his angel as by his intercessor, God is immediately ready to pardon and he takes it well when he has found something to be sparing towards.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-596"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("33:27 He shall look on men, and shall say, I have sinned.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By these words it is shown what benefit comes from a chastisement and the forgiveness that follows of one already acquitted and placed at rest. For the greatness of sins becomes known at that time when the free soul sees them clearly after danger.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-597"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("33:29 Behold, all these things God works three times within every one.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We should understand "), _c('i', [_vm._v("three times")]), _vm._v(" either as “in many ways” or, if we cling to the number recorded, we say that God’s providence is present to mortals at the beginning before they sin; then, when they begin to withdraw from natural simplicity by the imitation of evils, the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_87",
      "title": "87"
    }
  }, [_vm._v("concern of the admonisher is present; after this, if love of transgression continues, the bitterness of scourges is applied.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-598"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("33:32 But if you have anything to say, answer me, speak.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If you can defend your person against my objections or endure the weight of my statements by the strength of your reply.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-046"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 34]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-599"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:1-4 And Elihu continued his discourse and said this: Let us choose to us judgment.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Whether it is appropriate for us to accuse God or Job.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-600"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:5 For Job has said, I am just.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The affirmation of his virtues and the introduction of punishments are at odds with each other. If the affirmation of his virtues is true, the introduction of the punishments is unjust. If the chastisement was just, his boasting about his virtues was false.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-601"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:6 For in judging me there is a lie.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For I am not being examined according to the rules of fairness; I experience fruits that are in opposition to my works. “My arrow is violent without any sin.” He has added something on his own that indeed seems similar to the statements of saint Job, yet it is not the same, so that the changes in the wording become the occasion for a just rebuke.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-602"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:7 What man is there like Job, who drinks up scorning like water?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He reproves God’s judgments and despises them, and he thinks that they must be considered worthless.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-603"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:8 Who goes in company with them that work iniquity.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By thinking ill of the judgments of God, he does not differ at all from those who are proven to be impious by the injustice of their actions.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-604"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:12 For in very deed God has not condemned without cause.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The thought of each is similar, either in view of the apportioning to men or in view of the rational reckoning of the times. For what Elihu asserts happens to many in the present, saint Job says that this is to be carried out universally in the future.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-605"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:10-11 Therefore, ye men of understanding, hear me. Far from God be wickedness. For he will repay a man for his work.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("According to the rules of the debate, both sides might quite easily be speaking falsely in their general pronouncements rather than speaking the truth. Therefore, here, since they are speaking against each other, the pronouncement of both is nonetheless proven to be true. For both what Elihu says cannot be completely proved by holy Job to be false; and what Job asserts cannot be proven to be untrue. For God is shown to "), _c('i', [_vm._v("repay")]), _vm._v(" according to "), _c('i', [_vm._v("a man’s work")]), _vm._v(", if not in everyone, yet in many; and Job is convicted by the testimony that God does not "), _c('i', [_vm._v("repay")]), _vm._v(". Therefore, it is evident that what both say is partly true. According to Elihu, [God] does not repay everybody; according to Job, he has not repaid many.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-606"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:13 What other has he appointed over the earth?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By proclaiming God’s kindness, he wants to commend his justice by saying, If he is so kind "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_88",
      "title": "88"
    }
  }, [_vm._v("to human beings that he delivered over the world and the things that are in the world to the service of man,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-331",
      "id": "ap_ntb-331-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("215")])]), _vm._v(" how shall he not maintain justice with respect to man himself?")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-607"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:14 If his heart speak ("), _c('i', [_vm._v("dixerit")]), _vm._v(")"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-332",
      "id": "ap_ntb-332-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("216")])]), _vm._v(" to him, he shall draw his spirit and breath unto himself.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since his kindness shuts out any suspicion of wickedness, and his power attests that nothing obstructs what he wants to do—for if he makes known a judgment against someone to bring about his death, the destruction of the condemned man will not delay—how is it that you complain about his violence and injustice?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-608"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:17 Can he heal one who does not love judgment?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To summon back to health by means of chastisements one who is astray, this pertains to one who does not want sins to increase by the hope of impunity. But to be unwilling to permit vices to go unpunished, this is what it means to "), _c('i', [_vm._v("love judgment")]), _vm._v(". Therefore, the causes of healing have regard for the vigor of judgment. “And how do you so far condemn him that is just?” He proposes this examination of judgment, lest he believed to be unjust.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-609"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:18 Who says to the king, Apostate, who calls rulers ungodly.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So much so does the concern for justice abide with him that he does not hesitate to brand a sinner with the mark of reproach, though he be lofty in dignity.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-610"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:19 For all are the work of his hands.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He shows the reasons why he applies equal scales of judgments among people of disparate conditions.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-611"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:20 They shall suddenly die.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Doubtless those whom the name of his power was not able to protect from harm. “And they shall pass and take away the violent without hand.” That is, when egregious wickedness is consumed by its partisans. "), _c('i', [_vm._v("Without hand")]), _vm._v(", without work or effort.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-612"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:23 For it is no longer in the power of man to enter into judgment with God.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he has once and for all been doomed to punishment, he will not be able to appeal, as it were, for a milder verdict.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-613"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:24 He shall break in pieces many and shall make others to stand in their stead.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The former out of severity, the latter out of goodness. For it pertains to providence to substitute others in place of those whom punishment has removed.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-614"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:25 He shall bring night on them, and they shall be destroyed.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is the face and appearance of severity.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-615"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:26 He has struck them, as being wicked, in open sight.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("In open sight")]), _vm._v(" God struck those who sinned intentionally and, as it were, with an applied zeal, so that their death would lead to the correction of the rest.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-616"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:27-28 Who, as it were, on purpose have revolted from him, so that they caused the cry of the needy to come to him, and the voice of the poor.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Those who spurned all the ways of God, while they oppress and ravage the "), _c('i', [_vm._v("needy")]), _vm._v(", "), _c('i', [_vm._v("caused their cry")]), _vm._v(" to strike the stars.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-617"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_89",
      "title": "89"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:29 For when he granted peace, who is there that can condemn? When he hides his countenance, who is there that can behold him?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has recorded two contrary things, that just as no one’s vileness can be prejudicial to those who delight in God’s appeasement, so, when he turns his countenance away and covers it, as it were, no one will have any prosperity.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-618"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:30 Who makes a man that is a hypocrite to reign for the sins of the people.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is replying to an implied question: If he so pleads the cause of the poor that he holds in check the acts of violence of tyrants by death, why does he allow either similar or else worse men to come to power? Therefore, they cause the faults of their subjects, so that the iniquity of those who preside seems to contradict providence and deny justice.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-619"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:31 Since, therefore, I have spoken for God.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, if what I have said could vindicate the estimation of God from the injustice of evil opinion.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-620"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:32 If I have erred, teach me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If by asserting his justice I have wrongly inferred all these things, that he who is kind, powerful, a defender of the poor, could not fail to be just, you, by rejecting everything, are asserting that he rejoices in iniquity.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-621"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:33 Does God require it of you, because it displeased you?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Supply in thought: justice.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-622"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:34 Let men of understanding speak to me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It seems that, as his friends, in view of the silence that they have exhibited in themselves, approve and ascribe to their praise the fact that they have welcomed without contradiction those statements that were made by him, so holy Job praises himself for what he has found repose in with his words and thoughts.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-623"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:36 My father, let Job be tried even to the end.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Lest you should desire to lessen the rebuke of your severity by a milder sentence. "), _c('i', [_vm._v("My father, let him be tried")]), _vm._v(". He is addressing God.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-624"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("34:37 Let him be tied fast in the meantime among us, and then let him provoke God to judgment with his speeches.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Then")]), _vm._v(" he will rightly be able to question God if he first convinces us.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-047"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 35]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-625"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("35:1-2 Therefore, Elihu spoke again these words: Does your thought seem right to you, that you should say, I am more just than God?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The apostrophe"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-333",
      "id": "ap_ntb-333-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("217")])]), _vm._v(" made to him intends that he examine himself, putting down his zeal a little bit, as to what he obtained by his whole disputation.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-626"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("35:3 For he said, That which is right does not please you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Elihu says that saint Job had a wrong opinion about God, and these words are gathered from his reflections, because God is rightly offended by deeds, and Job recounted the errors of others in the heap of his own honor. “What will it profit you if I sin?” This is clearer "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_90",
      "title": "90"
    }
  }, [_vm._v("elsewhere: “What advantage did I get from not sinning?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-334",
      "id": "ap_ntb-334-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("218")])]), _vm._v(" That is, What else would I have suffered because of the iniquity of my morals if I received such misfortunes after my pursuit of virtue?")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-627"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("35:4 Therefore, I will answer your words, and your friends with you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since your friends are shown to agree with you in thinking wrongly about the judgments of God by the fact that they oppose you with no contradictions, so that by this you seem to be just, but God appears unjust, therefore I will take care to answer in order to oppose you and them.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-628"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("35:5 Look up to heaven and behold the sky.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The very immensity of the infinite separation can show you that God can neither be injured by your evil deeds nor helped by your good deeds. "), _c('i', [_vm._v("Look up to heaven and behold")]), _vm._v(". By the testimony of divine providence he wants to call his ventures into fault, because he had said that he wanted to come as an equal into judgment with God, whose supremacy he strives to prove from the testimony of his works and benefits.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-629"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("35:6-8 If you sin, how will you hurt him? And if you act justly, what will you give him? Your wickedness will hurt a man that is like you, and your justice will help the son of man.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Even the nature of your works will not advance any further in either direction than earning the affection and offense of the judge; moreover, neither advantage nor loss will be introduced into his reality.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-630"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("35:9 By reason of the multitude of false accusers they shall cry out and shall wail for the violence of the arm of tyrants.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had said that his justice could help them; now he shows that it is time to bring help. When men burst out into a voice of wailing, he says, "), _c('i', [_vm._v("by reason of the multitude of false accusers")]), _vm._v(". "), _c('i', [_vm._v("They shall cry out and shall wail")]), _vm._v(". So much so is God not in need of human offerings and gifts that when all inferiors are harassed by the violence and rapine of superiors, they ask God to avenge.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-631"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("35:10 And he has not said, Where is God?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is either the voice of one inflicting violence or the voice of one enduring violence. "), _c('i', [_vm._v("And he has not said: Where is the God")]), _vm._v(" “who made me?” He had spoken of the one whom they called on to avenge those whom the power of the wealthy was accustomed to join to their houses violently. Therefore, now he expresses the feeling of those very violent ones, who do not fear the judgments of God. “Who has given songs in the night?” Having made a partial beginning, he revisits the general description of providence, so that he says that God generally wants to be consulted by men, he who separates one time of night for rest, another time for work and labor. "), _c('i', [_vm._v("Who has given songs in the night")]), _vm._v(". That is, He mingled the time of night with the pleasure of sleep.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-632"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("35:11 Who teaches us more than the beasts.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Who gifted us beyond the other living creatures with understanding and reason, and made us capable of instruction.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-633"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("35:12 There they shall cry, and he will not hear.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He recorded "), _c('i', [_vm._v("there")]), _vm._v(" in keeping with the custom of Scripture, as the reason, not the location. It "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_91",
      "title": "91"
    }
  }, [_vm._v("is as if he were to say, For this reason "), _c('i', [_vm._v("they shall cry")]), _vm._v(". "), _c('i', [_vm._v("There they shall cry, and he will not hear")]), _vm._v(". For this reason, "), _c('i', [_vm._v("he will not hear")]), _vm._v(" the violent and the arrogant who are placed among evils, since he previously took in the cry of the afflicted with an attentive ear.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-634"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("35:13-14 Therefore, the Almighty will look into the causes of every one. Yea, when you shall say, He considers not, be judged before him, and expect him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Even if he postpones your complaints by some delay, exhibit patience and wait for his judgments.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-635"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("35:15 For he does not now bring on his fury.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("For now")]), _vm._v(" is said for “not at once.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-636"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("35:16 Therefore, Job has opened his mouth in vain.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, He has spoken such things about God unbecomingly. “And he multiplies words without knowledge.” He is saying, Failing to understand how great the difference is between God and men, he has made use of verbose and disordered speech.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-048"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 36]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-637"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:1-2 Elihu also proceeded, and said this: Suffer me a little.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The author of the book, while distributing the chapters of the speeches to us, connects the words that follow to the beginning. Since he had made his hearers attentive by discussing the providence of God, he also asks their patience for the things that he is about to add.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-638"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:5 God does not cast away the mighty, though he himself also is mighty.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("[By "), _c('i', [_vm._v("mighty")]), _vm._v(" he means] the innocent. Here is another way: he does not have reasons for jealousy that would corrupt with envy the virtue of his own judgment.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-639"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:6 But he does not save the wicked.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This has in view the duty of justice.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-640"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:7 He places kings on the throne forever.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("First he excluded the suspicion of jealousy from him, now he excludes the vice of fickleness. For if this was his sentence when he placed a man on the highest summit of dignity, that if he did not disfigure the merit in himself, he would not change his judgment, you cannot accuse him of fickleness. "), _c('i', [_vm._v("And he places kings on the throne")]), _vm._v(". He added another reason for which he claimed the side of justice—namely, that he has conferred the very kingdoms. Therefore, he is not vexed by his very own gifts, so that he judges wrongly.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-641"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:8-10 And if they shall be in chains, and be bound with the cords of poverty, he shall show them their works; he also shall open their ear to correct them.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If those whom he set on royal thrones change their status due to merits, not even then will he cast away care for them; for he will encourage correction by means of admonition. Or else this should be understood by changing the time, that is, before they come "), _c('i', [_vm._v("into the chains")]), _vm._v(" and are "), _c('i', [_vm._v("bound with the cords of poverty")]), _vm._v(", he pins the merits of their works on them, in order that they be corrected.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-642"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:13 Dissemblers and crafty men provoke the wrath of God; neither shall they cry when they are bound.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Overwhelmed by a bad conscience, they will not have the confidence to cry out; or else those on the verge of crying out are denied because there will be no effect to the cry.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-643"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_92",
      "title": "92"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:14 Their souls shall die in a storm, and their life among the effeminate.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had said, “God does not cast away the mighty.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-335",
      "id": "ap_ntb-335-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("219")])]), _vm._v(" Therefore, he has said well that this one who by his own contempt kindles the avenger’s anger against himself "), _c('i', [_vm._v("shall die among the effeminate")]), _vm._v("; that is, he will be stripped of all strength by the misfortunes that will happen to them.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-644"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:15 He shall deliver the poor out of his distress and shall open his ear in affliction.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Through the voices of the facts themselves he will teach them that he has not forgotten the cry of the poor.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-645"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:16 Therefore, he shall save you at large out of the narrow mouth, which has no foundation under it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is as if he were to say, Out of hell, whose mouth is said to widen in order to receive people indeed by a huge gaping hole, but those who are to be sent forth are constrained by the narrowness into a tight spot. For in order to show its great void, he adds, "), _c('i', [_vm._v("which has no foundation under it")]), _vm._v("—that is, because the depth of it stretched on without measure with no bottom to be reached. “But there will be rest at your table.” It is logically coherent that one who is delivered from misfortunes by God’s aid, with his grace generously granting this, will likewise be gifted with prosperity.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-646"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:17 Your cause has been judged as that of the wicked; cause and judgment you shall receive.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since the appearance of things deceive, you have endured prejudgments about merit, but whatever was thought to be lost will be restored to you completely.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-647"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:18 Therefore, let not anger overcome you to oppress anyone; neither let a multitude of gifts turn you aside.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("You too then, imitate the form of your judge. When you make presumptions about things that are doubtful, let neither anger nor influence steer you away from the love of truth. Or else thus: since this hope awaits you, that you receive the cause and judgment, you ought not want to oppress the side of God, having been led into bitterness by the present circumstances; that is, you ought not think wrongly about his judgments, and you should believe that providence is present in affairs, not merely in prosperity, when you abound in his gifts.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-648"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:19 Lay down your greatness without tribulation, and all the mighty of strength.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("From the link to what is above, a twofold meaning occurs. For either since he had promised to restore his state when he said, “cause and judgment you shall receive,” he is persuading him to accept without resentment the loss of his power that came to him for a time, and to teach others too to think that way who are placed in the same situation, or else let him bear it without annoyance that God has cast him down from the step of his greatness.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-649"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:20 Do not prolong the night, that people may come up for them.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, do not kindle the anger of the avenger against yourself by your complaints, and though you perish, others will be substituted in your place.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-650"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:21 Beware you turn not aside to iniquity.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That you should want to accuse the judgments of God. For unto this you have stumbled by the bitterness and offense of your mind.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-651"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_93",
      "title": "93"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:22 Behold, God is on high, and none is like him among the lawgivers.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He calls "), _c('i', [_vm._v("lawgivers")]), _vm._v(" those who in different countries have established human institutions by which the assembled peoples can be ruled.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-652"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:23 Who can search out his ways?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The very ignorance of "), _c('i', [_vm._v("his ways")]), _vm._v(" (that is, of his works) does not permit anyone to lay claim to confidence about his judging.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-653"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:24 Concerning which men have sung.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Referring to all the saints who foretold things while filled with the Spirit.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-654"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:25 Every one beholds him afar off.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since they are unable to approach nearer leading to full knowledge.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-655"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:26 Behold, God is great, exceeding our knowledge.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If he is great in his nature, he is also great in his wisdom and great likewise in justice. Therefore, he cannot be summoned under the censure of our judgment.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-656"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:27-28 He lifts up the drops of rain and will pour out showers like floods that flow from the clouds.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is inferring the providence and power of God by the things that he can point to.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-657"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:31 For by these he judges peoples.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("While he either makes lands barren with drought or fertile by the outpouring of rain.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-658"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:32 In his hands he hides the light.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He is not saying this about the alternation of day and night but about the sign of his power, that it is just as easy for God to take away the services of all light as it is easy to cover the scantiest thing by blocking it with his hand.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-659"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("36:33 He announces to his friend concerning it, that it is his possession and that he may come up to it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Though he may somewhat be wise beyond the earth, about what could be numbered among the profits, he shows that he nevertheless does not perceive enough great things when he reckons that only the possession of light is to be given to the friends of God.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-049"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 37]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-660"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:1 At this my heart trembles and is moved out of its place.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So that it does not stand still in the vigor of his thoughts.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-661"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:2 Hear ye attentively the terror of his voice, and the sound that comes out of his mouth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Sound that comes out of his mouth")]), _vm._v(" refers to thunder.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-662"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:3 His light is on the ends of the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("His light")]), _vm._v(" refers to his eyes.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-663"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:4 And shall not be found out when his voice shall be heard.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He so wants to remove the justice of his judgments from comprehension that many of his works and dispensations escape the power of human recognition.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-664"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_94",
      "title": "94"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:6 He commands the snow to go down on the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This stands as a proof of his providence, to regulate the earth for human use by changing the weather.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-665"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:7 He seals up the hand of all men, that every one may know his works.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the gift of reason he has caused men to know which times correspond with his diverse works.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-666"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:8 The beast shall go into his covert.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("And this has in view the laws of his creation, that beasts know when they need to roam, when to lie concealed.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-667"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:9 Out of the inner parts a tempest comes.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, from the north."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-336",
      "id": "ap_ntb-336-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("220")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-668"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:10 When God blows, there comes frost, and again the waters are poured out abundantly.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The diversity of divine activity is summoned so that the knowledge of his justice may be removed.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-669"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:11 The clouds spread their light.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He recorded "), _c('i', [_vm._v("light")]), _vm._v(" for the rains, which are desired by the farmer in the manner of light.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-670"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:12 Which go round about, whithersoever the will of him that governs them shall lead.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This agrees with the following words of the prophet: “I rained on one city and did not send rain on another. One part was rained on, and the part on which I did not send rain withered.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-337",
      "id": "ap_ntb-337-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("221")])]), _vm._v(" Surely by this he shows not that they are fortuitous but that they follow the will of the one in command.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-671"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:13 Whether in one tribe, or in his own land, he shall command them to be found.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He recorded "), _c('i', [_vm._v("in one tribe")]), _vm._v(" for “in one region.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-672"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:15 Do you know when God commanded the rains, to show his light of his clouds?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had said this obscurely earlier."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-338",
      "id": "ap_ntb-338-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("222")])]), _vm._v(" Here he caused it to be understood openly, that by "), _c('i', [_vm._v("light of his clouds")]), _vm._v(" he was referring to the rains.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-673"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:16 Do you know the paths of the clouds?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By all these things he is trying to show the effects of providence, which undoubtedly he is commending by a lengthy speech in support of the divine justice.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-674"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:18 You perhaps made the heavens with him, which are most strong, as if they were of molten brass?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he had made mention of the air, therefore he said "), _c('i', [_vm._v("molten")]), _vm._v(", not that the clouds are "), _c('i', [_vm._v("molten")]), _vm._v(" but because it is proper to air to be dissolved and poured into another form and use.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-675"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:20 Who shall tell him the things I speak? Even if a man shall speak, he shall be swallowed up.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As his own wish, he wants to reach the knowledge of God. It is as if he were to say, Who makes known to him the intention of my words, which I apply to unfolding his praises? "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_95",
      "title": "95"
    }
  }, [_vm._v("But why do I say that I praise him? Though I publish great things in his honor, they will be found to be so scanty that they could be "), _c('i', [_vm._v("swallowed up")]), _vm._v(" by the waves of his praises.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-676"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:21 But now they see not the light: the air on a sudden is thickened into clouds; and the wind shall pass and drive them away.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He has made clear by the added words how it is that "), _c('i', [_vm._v("they do not see light")]), _vm._v(", when he says, "), _c('i', [_vm._v("The air on a sudden is thickened into clouds")]), _vm._v(". For when the clouds have condensed and the air grown dark, the brightness of the sun is shut out, which is again recalled for the use of mortals by the driving away of the clouds.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-677"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("37:22 Gold comes out of the north.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Septuagint has “From the north [come] clouds of golden color, in these is the great glory and honor of the Almighty.” "), _c('i', [_vm._v("Gold comes out of the north")]), _vm._v(". He said "), _c('i', [_vm._v("north")]), _vm._v(" for east, and "), _c('i', [_vm._v("gold")]), _vm._v(" for dawn, which imitates the appearance of the shining metal with its reddish color. “And to God praise with fear.” For the service of praising him is not undertaken without fear because of the immensity of his public fame.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-050"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 38]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-678"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:1-2 Then the Lord answered Job and said, Who is this that wraps up sentences in unskillful words?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Elihu had been roused by no bitterness of mind when he approached the disputation, but was merely inflamed by the outspokenness of the complaints, and he thought of checking saint Job by the reasoning of his reply. He alleged that God—who had so much power, so much goodness, whose care for the human race he disclosed by his creation and governance of creatures—allowed for no movement leading to the injury of justice, as if he had been motivated by hatred. But he had brought forth certain things less worthily, either in respect to the honor of God or in the defense of his providence. Therefore, God reproaches him merely for "), _c('i', [_vm._v("lack of skill")]), _vm._v(", not for maliciousness as well, as those three friends had been who impudently and mendaciously engaged against the past life of saint Job.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-679"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:3 Gird up your loins like a man; I will ask you, and you answer me.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("After Elihu is reproached for lack of skill,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-339",
      "id": "ap_ntb-339-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("223")])]), _vm._v(" not for maliciousness, because when maintaining the justice of God he had produced things inferior to what the subject demanded, the Lord’s speech is directed to Job himself, and he is shown to have been given satisfaction for his request. For he had said, “Who will grant me that I might know and find him, and come even to his throne? I would set judgment before him.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-340",
      "id": "ap_ntb-340-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("224")])]), _vm._v(" In a logically coherent way, then, it is said to him, What you wanted is fulfilled. Behold, I am here; stand ready with your complaints with perseverance.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-680"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:4 Where were you when I laid up the foundations of the earth?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I prepared this earth to be your possession and in service to you. "), _c('i', [_vm._v("Where were you when I laid up the foundations of the earth?")]), _vm._v(" The suspicion of evil intent is excluded by the proof of infinite goodness. For if God’s kindness toward humanity is proven to be so great that before human beings even existed so much was prepared for their use and service, how is it all of a sudden that they are abandoned and despised? Therefore, God recounts each thing by which he shows that his care for humanity existed, even before he was formed, so that Job may understand by many proofs of facts, which "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_96",
      "title": "96"
    }
  }, [_vm._v("speak of God’s kindness toward men, that he could not be robbed of God’s providence.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-681"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:5-6 Who laid the measures thereof? Or who stretched the line on it? On what are its bases grounded? Or who laid the cornerstone thereof?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the terms "), _c('i', [_vm._v("measure")]), _vm._v(", "), _c('i', [_vm._v("line")]), _vm._v(", "), _c('i', [_vm._v("base")]), _vm._v(", and "), _c('i', [_vm._v("cornerstone")]), _vm._v(", he shows that he made all things with reason, so that saint Job may understand, if those things that were made for his sake have come into existence by the application of consideration, his Creator’s concern for him had never completely failed.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-682"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:7 When the morning stars praised me together, and all the sons of God made a joyful melody?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Some think that what saint Moses overlooked among the beginnings of creatures, (namely, When were the angels made?) is indicated here in the reference of his Lord, who not only says that the angels were present at the beginning of his works but even nicely testified to their good works.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-683"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:8 Who shut up the sea with doors, when it broke forth as issuing out of the womb?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since he says that he made new elements and things that had no previous existence, he has splendidly adopted the metaphor of birth and offspring.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-684"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:9 When I made a cloud the garment thereof.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, I poured out the atmosphere over it. The following passage is similar: “And the Spirit of God was being borne over the waters.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-341",
      "id": "ap_ntb-341-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("225")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-685"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:10 I set my bounds around it.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This too has in view that reason by which I wanted to exercise foresight for man, lest what I had made marvelously in view of its greatness should prove fatal to the farmer, if it were permitted to rush forth freely.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-686"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:12 Did you since your birth command the morning and show the dawning of the day its place?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This too testifies to the great proofs of my kindness toward man. For I have permitted those things that I created to be administered not by his solicitude, which indeed would not have been equal to the great things, but I commanded them to obey the laws of my providence to the point that while it preserves the appointed bounds in its rising and setting, there would occur for you a pleasing alternation of labor and rest.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-687"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:13 And did you hold the extremities of the earth, shaking them, and have you shaken the ungodly out of it?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He attests not merely that he exerted himself to bring benefits to mankind, but even ordained that he would set out to correct their customs. He is referring to the fear of future judgment in which there will be such a destruction of the "), _c('i', [_vm._v("ungodly")]), _vm._v(" that they are said to have been "), _c('i', [_vm._v("shaken out of the earth. ")]), _vm._v(" This has to do with a denial of rest. Whence it is significant that he added the time when this would take place—namely, when the clay of the body dissolves in view of the condition imposed on it, and it will be restored to its original form.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-688"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:14 The seal shall be restored as clay.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Septuagint has “Or did you take clay of the ground and form a living creature, and set it famously on the earth?” "), _c('i', [_vm._v("The seal shall be "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_97",
      "title": "97"
    }
  }, [_vm._v("restored as clay")])]), _vm._v(", “and it shall stand as a garment.” It is well said that we will have a body like a garment in the resurrection,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-342",
      "id": "ap_ntb-342-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("226")])]), _vm._v(" since no concern for maintenance will touch us when our frailty has been laid aside.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-689"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:16-18 Have you entered into the depths of the sea and walked in the lowest parts of the deep?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He wanted the things that he added to be relevant as an indication of the time when the ungodly are to be shaken out of the earth,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-343",
      "id": "ap_ntb-343-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("227")])]), _vm._v(" and he spoke briefly concerning the restoration of bodies. Therefore, he adds another indication of the last time, and he unlocks the mystery of the Lord’s incarnation. For he "), _c('i', [_vm._v("entered into the depths of the sea, and walked in the lowest parts of the deep")]), _vm._v(". In order to make his obscure statement a little clearer, he added, “Have the gates of death been opened to you, and have you seen the darksome doors?” The added line requires that "), _c('i', [_vm._v("the deep")]), _vm._v(" be understood here in view of hell’s immense capaciousness.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-690"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:18-19 Tell me where is the way where light dwells, and where is the place of darkness?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says what he had said before but more clearly—that is, that the course of human life is regulated by the alternation of times, so that at one time people dedicate themselves to work; in another time, the body’s strength is returned to them, which exhaustion had taken away.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-691"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:21 Did you know then that you would be born?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These words are not said without purpose, but prove that God’s goodness is the cause of everything. If you owe the fact that you exist to my kindness, he says, since you did not exist before, how can you think that you are estranged from this kindness, now that you live and are able to function?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-692"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:22-23 Have you entered into the storehouses of the snow, or have you beheld the treasures of the hail, which I prepared for the time of the enemy?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had previously mentioned things that testified to his kindness toward men. Therefore, lest he should show himself to be merely generous and not also severe, and it should thereby be believed that he could be scorned with impunity, he has of necessity added things through which he could inspire terror. For ordinarily he punishes the rebellious by these same things by which he pays back the upright."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-344",
      "id": "ap_ntb-344-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("228")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-693"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:24-25 By what way is the light spread and heat divided on the earth? Who gave a course to the very violent showers, and a way for noisy thunder?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says that the change of day and night, heat and cold, clear skies and rain pertain to his providence, by which he wanted to be thought of by men.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-694"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:26 That it should rain on the earth without man in the wilderness, where no mortal dwells.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("From regard not only for human beings but also for wild animals, he says that the earth is both shaken by thunder and irrigated by rains for fecundity.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-695"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:28 Who is the father of rain, or who begot the drops of dew?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He shows that everything by which the world is made fruitful or is ruled has in view the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_98",
      "title": "98"
    }
  }, [_vm._v("principles of his good disposition. That is why he uses the term "), _c('i', [_vm._v("father")]), _vm._v(" improperly for his own works, since things that previously did not exist received from him the beginning of their being.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-696"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:30 The waters are hardened like a stone.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Even things that come about as a consequence look back to the original creation.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-697"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:31 Will you be able to join together the shining stars of the Pleiades,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-345",
      "id": "ap_ntb-345-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("229")])]), _vm._v(" or can you stop the turning about of Arcturus?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-346",
      "id": "ap_ntb-346-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("230")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since in arranging the administration of the world, providence did not lack the collaboration of [divine] power, he now recounts those things that it is acknowledged properly concern the power of the Creator. Here is another interpretation. Even though the amount of space between them [i.e., the stars of Pleiades] might be small, your power ("), _c('i', [_vm._v("virtus")]), _vm._v(") will never be able to promote forcing them together into a single place and location after removing whatever it is that makes them distinct. Nor will you be able to alter "), _c('i', [_vm._v("the turning about of Arcturus")]), _vm._v(" (that is, the seven stars of the Great Bear) and move it to a location or region different from the one that I have set.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-698"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:33 Do you know the order of heaven?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is effective in opposing those who promise that they have comprehended in their subtle discussions, as they think, the form of the sky and its positioning, also the courses and distances of the stars, and to transmit this to others.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-699"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:34 Will you lift up your voice to the clouds, that its force of waters may cover you?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, Will it hurry up and hasten to obey your command?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-700"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:35 Can you send bolts of lightning, and will they go? And will they say to you reverently, Here we are?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is a sign of obedience that they are said to refuse to carry out what had been commanded to them.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-701"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:36 Who has put wisdom in the heart of man?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Septuagint has “Who has given to woman knowledge of embroidery?” "), _c('i', [_vm._v("Who has put wisdom in the heart of man")]), _vm._v(", “or who gave the cock understanding?” He had said that he established many things for mankind’s benefit. Lest he should seem to have provided only for his conveniences and not for man himself, he says he has given by his own generosity that which is more excellent among his goods, and what distinguishes him from fellowship with cattle. Whence solicitously, lest he should seem to have given the same gift to the remaining animate creatures, he says that "), _c('i', [_vm._v("he gave the cock")]), _vm._v(" not wisdom but "), _c('i', [_vm._v("understanding")]), _vm._v(", so that it could announce to the night time that the light was near at hand.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-702"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:37 Who will declare the rational account of the heavens?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He claims that this is known to himself alone, who made these things, not to the curiosity of human beings, who have occupied their mental talents with the investigation of incomprehensible things. “And who makes the harmony of heaven to sleep?” Who could remove the voice of praise from him, since by the very beauty of his work he seems melodious in praise of his "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_99",
      "title": "99"
    }
  }, [_vm._v("Creator, or else, who either preserves the harmony amid the various movements of the stars or guards the imposed arrangement of knowledge?")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-703"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:38 When was the dust poured on the earth?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This pertains to the initial coming together of the elements, as if he were to say, When the addition of the tiniest parts were joined to the single mass.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-704"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("38:39-41 Will you take the prey for the lioness or satisfy the appetite of her whelps? Who provides food for the raven? When do they lie down in their dens?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That he should understand all the more that God’s providence does not fail human beings, he indicates by the testimonies supplied that it even reaches diverse living creatures and the very birds too. And so everything that follows has in view this meaning.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-051"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 39]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-705"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("39:5 Who has sent out the wild ass free?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Many things are compiled, not merely to indicate the riches of the divine work but also to show that the reckoning of those works for the most part is hidden, so that saint Job may understand by how much more he is not able to know the justice of his judgments.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-706"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("39:10 Can you bind the rhinoceros to plow?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Both those things that I have commanded you to tame for your use, and those that I have armed with a bulk of power to defy you, will follow the laws of their creation, so that you could not lead and force them to do anything else.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-707"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("39:11 Will you have confidence in his great strength and leave your labors to him?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, will you invite him to share in your work?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-708"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("39:12 Do you trust him that he will render you the seed or gather it into your barn floor?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Will he submit his neck to your plow and gather your seed into your barn floor when the crop is multiplied?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-709"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("39:13 The wing of the ostrich is like the wings of the heron.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He preserves the course taken among the foundational things, and when many witnesses have been summoned, as it were, he proves that the laws of his own creation are preserved without any alteration.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-710"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("39:16-18 She is hardened against her young ones as though they were not hers; she has labored in vain, no fear constraining her. She scorns the horse and his rider.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since love customarily does feel fear on behalf of those things to which something is expended, he has well said that fear was absent from them in whom he had shown that the feeling of passionate love was estranged.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-711"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("39:19-25 Will you give strength to the horse? He breaks up the earth with his hoof; he prances boldly; he goes forward to meet armed men. He smells the battle afar off.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He made an appropriate transition from the proximity of the previously mentioned term, so that since he had said, “She scorns the horse,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-347",
      "id": "ap_ntb-347-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("231")])]), _vm._v(" he showed what significance there was in the nature of the horse itself; and in order to make "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_100",
      "title": "100"
    }
  }, [_vm._v("what he says more splendid, he proceeds to adorn in detail the inborn character of the spirited creature.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-712"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("39:26 Does the hawk begin to have feathers by your wisdom?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says that many things, which we in our leisure overlook, upon closer inspection, are greatly to be admired, while he removes these things from the orderly arrangement of human wisdom.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-713"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("39:31-32 And the Lord went on, and said to Job, Is he who contends with God so easily silenced?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Who asks of him an accounting for his works and judgments? Since he began to disclose the reasons for his affairs, does he adduce in public so much approval of his deeds that the accuser of his work is dashed by the waves of his wisdom? Here is another way: he who enters into combat with one who is superior by means of challenges ought not quickly to withdraw from the heat of his argument. “Surely he that reproves God ought to answer him.” He who assumes for himself the place of a superior in making accusations ought to carry out the role of debater by persistence in his replies.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-714"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("39:33-34 Then Job answered the Lord, and said, What can I answer, who has spoken inconsiderately ("), _c('i', [_vm._v("leviter")]), _vm._v(")? I will lay my hand on my mouth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("I will lay my hand on my mouth")]), _vm._v(". Saint Job has come to understand where the whole essence of God’s arguments had led—that is, that he himself had not been abandoned by that providence that had been paid out for his sake in other matters as well. And therefore he condemns himself to silence.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-715"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("39:35 One thing I have spoken, which I wish I had not said, and another, to which I will add no more.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He recorded "), _c('i', [_vm._v("one thing")]), _vm._v(" or "), _c('i', [_vm._v("another")]), _vm._v(" for “a few things.”")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-052"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 40]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-716"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:1-3 And the Lord answered Job out of the whirlwind and said, Will you make void my judgment?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("After he proved the care of his providence and kindness by many testimonies of creatures, it is logically coherent that he interviews saint Job about whether he abides in that opinion, whereby he believed that God had abandoned him. And he says to him, "), _c('i', [_vm._v("Will you make void my judgment")]), _vm._v(", “and condemn me, that you may be justified?” That is, since there has been a concern for justice in you, do you not think that I have been concerned about your merits? Have I allowed you to be unrecompensed, since you did not experience being abandoned? "), _c('i', [_vm._v("Will you make void my judgment")]), _vm._v(", whereby I neglected my concern for you, so that I could reveal your merits? And lest your virtue should have been unknown, did I want there to be doubt about my estimation of it in the meantime?"), _c('i', [_vm._v(" Will you make void my judgment?")]), _vm._v(" The Septuagint has “Or do you think that I have dealt with you in any other way than that you might appear to be just?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-348",
      "id": "ap_ntb-348-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("232")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-717"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:4 And do you have an arm like God, and can you thunder with a voice like him?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had said, “Will you make void my judgment?” that is, do you think that you could deliberate better in the ruling of things? Therefore, he describes everything that matches the power of the judge and his grace, which is compared from his character and his judicial rebuke.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-718"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_101",
      "title": "101"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:6-8 Scatter the proud in your indignation and crush the wicked in their place. Hide them in the dust of the earth.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These words are not spoken with an offended mind but with the affection of a lover, so that they may be useful in consoling and instructing him and that he may understand that to perform such a great judgment is beyond his strength.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-719"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:9 And I will confess that your own right hand is able to save you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If you could play the role of such a judge, as I described it in my speech, evidently you would not need any further help.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-720"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:10 Behold, Behemoth, whom I made with you, he eats grass like an ox.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Through the creation of such a hateful and enormous beast, people are given three advantages. [First,] they can recognize that the power of the Creator not only made those beasts that served human beings, but he also fashioned those who frighten them. [Second,] they can understand the goodness of providence, because it removed from the midst [of humans] those beasts that would have been deadly, and he relegated them to live in isolated places. [Third,] they can learn how severe he is against vices. These [beasts] that are troublesome to mortals according to their size and strength are also subject to his rebuke. "), _c('i', [_vm._v("Behold Behemoth whom I made with you, he eats grass like an ox")]), _vm._v(". After the intervention of a question, by which he asked whether his judgments displeased him, he set forth the kind of rebuke he himself ought to undertake. He returns again to the description of the creatures, which attested both to his power and providence, and he intentionally put off all the way to the end of the speech mention of these two beasts. This way it would be established how much more someone is to be punished for that haughtiness that arose from the vice of the will, if God did not spare that which seemed to imitate the arrogance in view of the bulk of its body and magnitude of its strength. Here is another way: they intend this to refer to a four-footed creature and an earthly animal. Here is another way: with one term among the Hebrews, all earthly animals are called "), _c('i', [_vm._v("Behemoth")]), _vm._v("; similarly, everything that lives in the water is called Leviathan. For the Greek in this passage recorded as follows: “Behold, with you the wild beasts eat grass like oxen.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-349",
      "id": "ap_ntb-349-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("233")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-721"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:12 He sets up his tail like a cedar.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Sets up")]), _vm._v(": raises. For beasts, when made savage, customarily lift up their tails. “The sinews of his testicles are wrapped together.” As a sign of his great strength he said that "), _c('i', [_vm._v("the sinews of his testicles are wrapped together")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-722"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:14 He is the beginning of the ways of God, who made him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We are constrained by the authority of the one speaking, that this one’s original form proceeded into the fashioning of the diversities of the beasts. “He who made him applied his sword.” Not that with which he is struck but that with which he can strike others; that is, he who made him knows at what time he ought to set him loose for the devastation and destruction of mortals. Here is another way: he is the one who, due to the bulk of his body and the magnitude of his strength, holds primacy among wild animals.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-723"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:15-17 To him the mountains bring forth grass; there all the beasts of the field shall play. He sleeps under the shadow. The willows of the brook shall compass him about.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_102",
      "title": "102"
    }
  }, [_vm._v("This is said as a testimony to his size, because all kinds of beasts could dwell in the mountains, which are reputed to be his pastures with more freedom to roam."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-350",
      "id": "ap_ntb-350-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("234")])])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-724"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:18 Behold, he will drink up a river, and not wonder.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had said that he slept in the shade of willows for the sake of avoiding the heat."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-351",
      "id": "ap_ntb-351-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("235")])]), _vm._v(" Now he claims that he has no fear of inundations of water.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-725"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:19 In his eyes as with a hook he shall take him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Lest the description of his size should be believed to protect him from all destruction, he shows that he is of such little account to himself as a little fish for which a hook causes danger.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-726"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:20 Can you draw out the Leviathan with a hook, or will you bind him with a cord?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Likewise, the making and magnitude of another brute, which is testified to be in the Indian Ocean, is described for our admiration. Holy Job himself also mentioned it at the beginning of the book."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-352",
      "id": "ap_ntb-352-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("236")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-727"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:22 Will he make many prayers to you or speak soft words to you?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Not that a speechless animal would burst forth into a voice of supplication, but that it intends to be patient to the touch when it is treated gently.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-728"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:24 Will you play with him?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So that laying aside his fierceness he begins to be a delight?")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-729"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:25 Shall friends cut him in pieces, shall merchants divide him?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("According to the understanding of the preceding and subsequent things, this is said not to affirm but to deny. Thus, it means, His friends will not cut him to pieces and apportion him in the fashion of meat that is for sale, will they? Here is another way: when the time of slaughter comes to him, he will be shared by the hands of many. Here is another way: the Greek has "), _c('i', [_vm._v("nations")]), _vm._v(" instead of "), _c('i', [_vm._v("friends")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-730"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:26 Will you fill nets with his skin?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, the thing is so large that not even at that time when it is cut up and divided out would you be able to enclose its skin or head with your nets, however large those nets may be.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-731"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:27 Lay your hand on him; remember the battle, and speak no more.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This too is said in accordance with the sense given previously. He says, If you have an arm like God, and if you thunder with a voice like his,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-353",
      "id": "ap_ntb-353-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("237")])]), _vm._v(" "), _c('i', [_vm._v("lay your hand on him")]), _vm._v("; that is, arm yourself to destroy him and gird yourself to slaughter him. But if you distrust your strength, hold in check the outspokenness of your words too.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-732"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("40:28 Behold, his hope shall fail him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Fittingly, when the choice of combat is resolved, the greatness of the venture is revealed, and there is talk of destruction, not of one man but of many, either by the wish to attack or by the intent to catch.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-053"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 41]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-733"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_103",
      "title": "103"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:1 I will not stir him up, like one that is cruel.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He says that he will not make him free at some point so that his violence would increase by human calamities, but in order that the power may be made known either of the one holding him or else of the one appointing him for destruction.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-734"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:2 Who has first given to me that I should repay him? All things that are under heaven are mine.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Therefore, he shows either that its restraint or slaughter was easy for him, since the same thing by which it was made can either be held in check or killed by his power.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-735"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:3 I will not spare him, nor his words framed to make supplication.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That power is to be feared by others, that monstrous size of body is shown to jump at words of supplication by the right of their master.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-736"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:4 Who shall unveil the face of his garment, and who has entered the midst of his mouth?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had revealed his submission that came from fear. Therefore, lest this should seem unique to his nature, again the cause of terror is told. "), _c('i', [_vm._v("Who shall unveil the face of his garment, and who has entered the midst of his mouth?")]), _vm._v(" That is, that appendage with which the voracity of its mouth is impeded.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-737"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:5 Who can open the doors of his face?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The meaning is the same that was also found in the brief verse higher up."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-354",
      "id": "ap_ntb-354-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("238")])])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-738"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:6 His body is like shields.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Since an animal that is native to water is being described, it is fittingly claimed to possess rings of scales like fish.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-739"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:9-11 His sneezing is like the shining of fire; out of his mouth go forth lamps; out of his nostrils goes smoke.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By a lengthy arrangement of a description, everything is recounted that is either truly menacing in his nature or for the sake of emphasis serves to inspire terror.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-740"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:13 In his neck strength shall dwell, and want shall go before his face.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He will move himself in every direction. He will lay waste to all things and in order to show not only that those things that he had approached remained deserted but also he indicates that the flight of all things occurred when he moved himself along any path.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-741"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:14 The members of his flesh even cleave one to another.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That is, they are tightly connected, bound by many bonds of sinews. “He shall send bolts of lightning against him.” And because all other things were hanging from nothing, he shows only what prevailed to kill it.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-742"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:15 His heart shall be as hard as a stone and as firm as a smith’s anvil.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He will not "), _c('i', [_vm._v("be made hard")]), _vm._v(" by strokes of lightning, but he makes those weapons bounce off him that human strength has hurled.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-743"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:16 When he shall raise him up, the angels shall fear, and being affrighted shall purify themselves.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("By the example of punishment directed at the beast, an opportunity of fear will arise that is "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_104",
      "title": "104"
    }
  }, [_vm._v("useful to the higher rational creation, so that it strives not to have in its character what it has seen being struck against the bodies in this way.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-744"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:17-18 A sword shall not be able to hold up; for he shall esteem iron as straw.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He had said previously, “His heart shall be as hard as a stone and as firm as a smith’s anvil.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-355",
      "id": "ap_ntb-355-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("239")])]), _vm._v(" Therefore, he shows that against which such callousness is prepared. Therefore, it is not the Leviathan that will be unable to hold out, but the sword that is drawn out against him.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-745"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:21 The beams of the sun shall be under him.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is customary in the Scriptures always to extol the descriptions of great things in an abundance of words. Therefore, in order to show him to be of immense bulk, he says that "), _c('i', [_vm._v("the beams of the sun")]), _vm._v(" shall rise and grow red "), _c('i', [_vm._v("under him")]), _vm._v(". “He strews gold under him like mire.” He does not say what he is doing, but what he is capable of doing, if his size and strength allowed no hindrances. By the term "), _c('i', [_vm._v("gold")]), _vm._v(" he has indicated riches that various forms of things make.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-746"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:23 He shall esteem the deep as growing old.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Which could not oppose him, as if its strength were exhausted.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-747"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:24 There is no power on earth that can be compared with him, who was made to fear no one.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Another way is how the Greek renders it: “There is no power on the earth of him, who was made to be sported with by the angels.”")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-748"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("41:25 He beholds every high thing; he is king over all the children of pride.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This would be the true description of the beasts according to reliability of history. Let there be no doubt about their great size in light of the power of the Creator. However, they also leave room for a deeper understanding, so that we may believe in addition to them something else is signified as well. Thus, the power of spiritual wickedness may be perceived more easily in the representation of the bodies. Just as the former beasts are deadly to bodies, so the latter are to morals, and as the sin of pride must deservedly be imputed to them, so it ought to be punished. Another way is given in the Greek: “He is king of all that are in the waters.” "), _c('i', [_vm._v("He beholds")]), _vm._v(" is recorded for “despises.”")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-054"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("[Chapter 42]")]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-749"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("42:1-2 Then Job answered the Lord, and said, I know that you can do all things, and no thought is hidden from you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For you have understood that more was involved in my feelings of bitterness than the speech of complaints had brought out. Here is another way: whoever therefore believes that what he turns over in his mind does not lie exposed to your knowledge is ignorant of reality and acts as one who is devoid of rational knowledge.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-750"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("42:3 Who is this that hides counsel?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Septuagint has “For who is he that hides counsel from you?” “Therefore I have spoken unwisely.” The Greek has “What I did not know has been told to me, great and wonderful things which I understood not?” Here is another way: that I should have believed that I had been forsaken by your providence, which intervenes in all things that it has created.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-751"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_105",
      "title": "105"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("42:5 With the hearing of the ear, I"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-356",
      "id": "ap_ntb-356-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("240")])]), _vm._v(" heard, but now my eye sees you.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That which the speech of reason and teaching authority previously brought to my awareness (namely, that you care about justice) has now settled more deeply into my mind by the presence of your revelation.")])])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-752"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("42:6 Therefore, I reprehend myself and do penance in dust and ashes.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Greek has “I esteem myself earth and ashes.” Here is another way: this means either I will not take offense over the misfortunes I suffer, but will embrace them in the place of training or correction, or else I will zealously employ other things as well with my torments.")])]), _c('div', {
    staticClass: "niv4",
    attrs: {
      "id": "niv4-753"
    }
  }, [_c('h4', {
    staticClass: "int_niv4",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("42:7 But after the Lord had spoken these words to Job, he said to Eliphaz the Themanite, My wrath is kindled against you, and against your two friends, because you have not spoken the thing that is right before me, as my servant Job has.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("He deservedly incites. . . ."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#ntb-357",
      "id": "ap_ntb-357-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("241")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "bl"
  })])])])])])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample from InterVarsity Press.  ")]), _vm._v(" "), _c('p', [_vm._v("Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9780830825486',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(112)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(114);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 114 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.b62bea4334feabaad854.js